import * as api from '@codametrix/client-api';
import { request, authHandler } from '@codametrix/client-api';
import { S as ServiceLines, M as Methods, b as ConfigurationKeyName, d as InvoiceTypes$1, e as IssueTypeErrors$1, A as AmplifyErrorSources, E as EditorIssueLevel, f as CaseArtifactTypes, g as EditorIssueProvenance, h as CaseAlertType, u as uiStatus, i as CodeType, j as CodeSearchType, k as ChargeSessionCodeType, l as CustomerPhase, m as DictionaryFilterDefault, n as AccelerateProcessStatus, o as CaseAccessState, B as BenchMode, p as MiniTabLabels, q as commonEnums, r as CapabilityAvailabilityReason, P as ProcessQAStatus, R as ResourceId, c as commonEnums$1, U as UIModesEnum, F as FeedbackMeta, C as CoderNotesLookupTypeName } from './enums-CbPAb7iQ.mjs';
import { i as isEmpty, c as capitalize, a as upperFirst, t as truncate, g as groupBy, b as isStringifiedJSON, d as getValueForString, e as isString, f as cloneDeep, s as set$2 } from './object-utils-BaV0EGpT.mjs';
import { s as sortByDate, f as format, F as FORMATS, a as calculateDurationDateFns } from './date-time-B7hPZ_ab.mjs';
import { c as capabilityValue } from './conditional-0YSA_RAK.mjs';
import { d as deleteDTO, B as BulkDeleteDTO, u as updateDTO, a as createDTO, b as BulkcreateDTO, e as createTransactionDTO } from './transaction-updates-C4_DQZ0L.mjs';

var CMxApplication$1 = /*#__PURE__*/ function(CMxApplication) {
    CMxApplication["DRAWER"] = "DRAWER";
    CMxApplication["AWAITING_RESOURCES"] = "AWAITING_RESOURCES";
    CMxApplication["DRAWER_CONTENT"] = "DRAWER_CONTENT";
    CMxApplication["LOADING"] = "LOADING";
    CMxApplication["IN_PROGRESS"] = "IN_PROGRESS";
    CMxApplication["FORM_SUBMISSION"] = "FORM_SUBMISSION";
    CMxApplication["FEEDBACK"] = "FEEDBACK";
    CMxApplication["DISMISS_FEEDBACK"] = "DISMISS_FEEDBACK";
    CMxApplication["CHOOSE_CONTEXT"] = "CHOOSE_CONTEXT";
    return CMxApplication;
}({});
var FeedbackLevel = /*#__PURE__*/ function(FeedbackLevel) {
    FeedbackLevel["WARNING"] = "WARNING";
    FeedbackLevel["SUCCESS"] = "SUCCESS";
    FeedbackLevel["ERROR"] = "ERROR";
    return FeedbackLevel;
}({});
var Case = /*#__PURE__*/ function(Case) {
    Case["IMPORT_TO_AMPLIFY"] = "IMPORT_TO_AMPLIFY";
    Case["ORGANIZATION_CONTEXT"] = "ORGANIZATION_CONTEXT";
    Case["DETAIL"] = "CASE_DETAIL";
    Case["DETAIL_WILL_NAVIGATE"] = "DETAIL_WILL_NAVIGATE";
    Case["DETAIL_TOGGLE_ARTIFACTS"] = "DETAIL_TOGGLE_ARTIFACTS";
    Case["BPM_TASKS"] = "BPM_TASKS";
    Case["FEATURE_SELECTION"] = "CASE_FEATURE_SELECTION";
    Case["FEATURE_ACTIVATION"] = "CASE_FEATURE_ACTIVATION";
    Case["CODE_DESCRIPTIONS"] = "CODE_DESCRIPTIONS";
    Case["INVOICE_CODE_DESCRIPTIONS"] = "INVOICE_CODE_DESCRIPTIONS";
    Case["DICTIONARY"] = "CASE_DICTIONARY";
    Case["LIST"] = "LIST_CASES";
    Case["SELECTED"] = "CASE_SELECTED";
    Case["FILTER"] = "CASE_FILTER";
    Case["DATE_FILTER"] = "DATE_FILTER";
    Case["CASE_STATUS"] = "CASE_STATUS";
    Case["BILLING_GROUP"] = "BILLING_GROUP";
    Case["SUBMITTER_ACCESSION_SEARCH"] = "SUBMITTER_ACCESSION_SEARCH";
    Case["BPM_EVIDENCE"] = "BPM_EVIDENCE";
    Case["TENANT"] = "GET_TENANTS";
    Case["CLEAR_ALL_FILTERS"] = "CLEAR_ALL_FILTERS";
    Case["APPLY_DEFAULT_FILTERS"] = "APPLY_DEFAULT_FILTERS";
    Case["TOGGLE_TIMELINE"] = "TOGGLE_TIMELINE";
    Case["DETAIL_INIT"] = "CASE_DETAIL_INITIAL";
    Case["DETAIL_RECONCILE"] = "CASE_DETAIL_RECONCILE";
    Case["CASE_DETAIL_RECONCILIATION_PENDING"] = "CASE_DETAIL_RECONCILIATION_PENDING";
    Case["CASE_DETAIL_RECONCILIATION_APPLIED"] = "CASE_DETAIL_RECONCILIATION_APPLIED";
    Case["CASE_DETAIL_RECONCILIATION_APPLY"] = "CASE_DETAIL_RECONCILIATION_APPLY";
    Case["CASE_DETAIL_RECONCILIATION_DISMISS"] = "CASE_DETAIL_RECONCILIATION_DISMISS";
    Case["CASE_DETAIL_FRESHNESS_WARNING"] = "CASE_DETAIL_FRESHNESS_WARNING";
    Case["CASE_DETAIL_FRESHNESS_WARNING_DISMISS"] = "CASE_DETAIL_FRESHNESS_WARNING_DISMISS";
    Case["LIST_INIT"] = "CASE_LIST_INITIAL";
    Case["SET_ACTIVE_PROCESS_ID"] = "SET_ACTIVE_PROCESS_ID";
    Case["CASE_AND_PROCESS_ID"] = "CASE_AND_PROCESS_ID";
    Case["LAUNCH_WORKITEM_IN_AMPLIFY"] = "LAUNCH_WORKITEM_IN_AMPLIFY";
    Case["GET_PREV_OR_NEXT_CASE"] = "GET_PREV_OR_NEXT_CASE";
    Case["SET_ACTIVE_NOTE"] = "SET_ACTIVE_NOTE";
    Case["SHOW_ORDER_NUMBER"] = "SHOW_ORDER_NUMBER";
    Case["IGNORE_EVIDENCE"] = "IGNORE_EVIDENCE";
    Case["FETCH_WORKITEM_DETAILS"] = "FETCH_WORKITEM_DETAILS";
    Case["UPDATE_WORKITEM_DISMISSED"] = "UPDATE_WORKITEM_DISMISSED";
    Case["FETCH_WORKER_FULLNAME"] = "FETCH_WORKER_FULLNAME";
    Case["FETCH_GROUP_NAME"] = "FETCH_GROUP_NAME";
    return Case;
}({});
var UserInterface$1 = /*#__PURE__*/ function(UserInterface) {
    UserInterface["BOOTSTRAP"] = "BOOTSTRAP";
    UserInterface["REPLACE_UI_STATE"] = "REPLACE_UI_STATE";
    UserInterface["LOGOUT"] = "LOGOUT";
    UserInterface["NAVIGATE"] = "NAVIGATE";
    UserInterface["DETAIL_TOGGLE_PHI"] = "DETAIL_TOGGLE_PHI";
    UserInterface["SHOW_MODAL_MESSAGE"] = "SHOW_MODAL_MESSAGE";
    UserInterface["DISMISS_MODAL_MESSAGE"] = "DISMISS_MODAL_MESSAGE";
    UserInterface["ADMIN_TAB_CHANGE"] = "ADMIN_TAB_CHANGE";
    UserInterface["SET_ACTIVE_USER"] = "SET_ACTIVE_USER";
    UserInterface["OPEN_CHILD_WINDOW"] = "OPEN_CHILD_WINDOW";
    UserInterface["NAVIGATE_CONTEXT"] = "NAVIGATE_CONTEXT";
    UserInterface["SET_DEFAULT_HOMEPAGE"] = "SET_DEFAULT_HOMEPAGE";
    UserInterface["SET_BACK_TO_WORKLIST_PATH"] = "SET_BACK_TO_WORKLIST_PATH";
    UserInterface["MODAL_SUBMIT"] = "MODAL_SUBMIT";
    UserInterface["REFRESH"] = "REFRESH";
    return UserInterface;
}({});
var UserSession = /*#__PURE__*/ function(UserSession) {
    UserSession["TIMEOUT"] = "TIMEOUT";
    UserSession["REFRESH"] = "REFRESH";
    UserSession["RESET"] = "RESET";
    UserSession["ACTIVITY_PROMPT"] = "ACTIVITY_PROMPT";
    return UserSession;
}({});
var ParentWindow = /*#__PURE__*/ function(ParentWindow) {
    ParentWindow["PARENT_NAVIGATION"] = "PARENT_NAVIGATION";
    return ParentWindow;
}({});
var AuthenticatedWindow = /*#__PURE__*/ function(AuthenticatedWindow) {
    AuthenticatedWindow["ACTIVITY"] = "AUTHENTICATED_WINDOW_ACTIVITY";
    AuthenticatedWindow["SHOULD_REFRESH"] = "AUTHENTICATED_WINDOW_SHOULD_REFRESH";
    return AuthenticatedWindow;
}({});
var CaseJSON = /*#__PURE__*/ function(CaseJSON) {
    CaseJSON["LOAD"] = "CASE_JSON_LOAD";
    CaseJSON["SET_ACTIVE_PROCESS"] = "SET_ACTIVE_PROCESS";
    return CaseJSON;
}({});
var Router = /*#__PURE__*/ function(Router) {
    Router["LOCATION_CHANGE"] = "@@router/LOCATION_CHANGE";
    return Router;
}({});
var Eula = /*#__PURE__*/ function(Eula) {
    Eula["SAVE_EULA"] = "SAVE_EULA";
    Eula["FETCH_EULA"] = "FETCH_EULA";
    Eula["ACCEPT_EULA"] = "ACCEPT_EULA";
    Eula["CANCEL_EULA"] = "CANCEL_EULA";
    Eula["ACCEPT_INIT"] = "ACCEPT_EULA_INITIAL";
    return Eula;
}({});
var AmplifyAuthenticate = /*#__PURE__*/ function(AmplifyAuthenticate) {
    AmplifyAuthenticate["AUTHENTICATE"] = "AUTHENTICATE";
    AmplifyAuthenticate["AUTOMATE"] = "AUTOMATE";
    AmplifyAuthenticate["USER_DETAILS"] = "USER_DETAILS";
    return AmplifyAuthenticate;
}({});
var AmplifyUIActions$1 = /*#__PURE__*/ function(AmplifyUIActions) {
    AmplifyUIActions["SHOW_CONFIRM"] = "SHOW_CONFIRM";
    AmplifyUIActions["DISMISS_CONFIRM"] = "DISMISS_CONFIRM";
    AmplifyUIActions["HANDLE_CONFIRM"] = "HANDLE_CONFIRM";
    AmplifyUIActions["AMPLIFY_FEEDBACK"] = "AMPLIFY_FEEDBACK";
    AmplifyUIActions["HIDE_FEEDBACK"] = "HIDE_FEEDBACK";
    AmplifyUIActions["SHOW_SIZE_EXP_WARNING"] = "SHOW_SIZE_EXP_WARNING";
    AmplifyUIActions["HIDE_SIZE_EXP_WARNING"] = "HIDE_SIZE_EXP_WARNING";
    AmplifyUIActions["SET_STANDALONE_MODE"] = "SET_STANDALONE_MODE";
    AmplifyUIActions["SET_AMPLIFY_VIEW"] = "SET_AMPLIFY_VIEW";
    AmplifyUIActions["SET_AUTOMATE_VIEW"] = "SET_AUTOMATE_VIEW";
    AmplifyUIActions["SAVE_SERVICE_LINE_CAPABILITY"] = "SAVE_SERVICE_LINE_CAPABILITY";
    AmplifyUIActions["GET_CODER_CONFIG"] = "GET_CODER_CONFIG";
    return AmplifyUIActions;
}({});
var InvoiceEditor = /*#__PURE__*/ function(InvoiceEditor) {
    InvoiceEditor["REMOVE_PROVIDER"] = "REMOVE_PROVIDER";
    InvoiceEditor["REMOVE_REFERRING_PERFORMER"] = "REMOVE_REFERRING_PERFORMER";
    InvoiceEditor["ADD_PROVIDER"] = "ADD_PROVIDER";
    InvoiceEditor["ADD_REFERRING_PERFORMER"] = "ADD_REFERRING_PERFORMER";
    InvoiceEditor["CHOOSE_PROVIDER"] = "CHOOSE_PROVIDER";
    InvoiceEditor["SEARCH_PROVIDERS"] = "SEARCH_PROVIDERS";
    InvoiceEditor["BILLING_PROVIDER_RESULTS"] = "BILLING_PROVIDER_RESULTS";
    InvoiceEditor["PERFORMING_PROVIDER_RESULTS"] = "PERFORMING_PROVIDER_RESULTS";
    InvoiceEditor["CREATE_INVOICE"] = "CREATE_INVOICE";
    InvoiceEditor["INVOICE_OPTIONS"] = "INVOICE_OPTIONS";
    InvoiceEditor["REMOVE_TRANSACTION"] = "REMOVE_TRANSACTION";
    InvoiceEditor["BILLING_AREA_OPTIONS"] = "BILLING_AREA_OPTIONS";
    InvoiceEditor["REMOVE_PERFORMER"] = "REMOVE_ADDITION_PERFORMER";
    InvoiceEditor["ADD_PERFORMER"] = "ADD_ADDITION_PERFORMER";
    InvoiceEditor["CHOOSE_PERFORMER"] = "CHOOSE_ADDITION_PERFORMER";
    InvoiceEditor["CHOOSE_REFERRING_PERFORMER"] = "CHOOSE_REFERRING_PERFORMER";
    InvoiceEditor["SEARCH_PERFORMERS"] = "SEARCH_ADDITION_PERFORMERS";
    InvoiceEditor["CHANGE_DATE_PERFORMER"] = "CHANGE_DATE_ADDITION_PERFORMER";
    InvoiceEditor["FEE_SCHEDULE_CHANGE"] = "FEE_SCHEDULE_CHANGE";
    InvoiceEditor["DEPARTMENT_CHANGE"] = "DEPARTMENT_CHANGE";
    InvoiceEditor["CANCEL_INVOICE"] = "CANCEL_INVOICE";
    InvoiceEditor["SAVE_INVOICE"] = "SAVE_INVOICE";
    InvoiceEditor["SEARCH_PROVIDERS_DATAACCESS"] = "SEARCH_PROVIDERS_DATAACCESS";
    return InvoiceEditor;
}({});
var Launch$1 = /*#__PURE__*/ function(Launch) {
    Launch["XCALIBER_TOKEN"] = "XCALIBER_TOKEN";
    Launch["EPIC_TOKEN"] = "EPIC_TOKEN";
    Launch["EPIC_CLOSE_ACTIVITY"] = "EPIC_CLOSE_ACTIVITY";
    Launch["LOAD_FROM_URL"] = "LOAD_FROM_URL";
    Launch["PARENT_CASE"] = "PARENT_CASE";
    Launch["CONTEXT_PARAMS"] = "CONTEXT_PARAMS";
    Launch["PARAMS_AVAILABLE"] = "PARAMS_AVAILABLE";
    Launch["NAVIGATE_DETAIL"] = "NAVIGATE_DETAIL";
    Launch["NAVIGATE_PATIENT"] = "NAVIGATE_PATIENT";
    Launch["NAVIGATE_PROVIDER"] = "NAVIGATE_PROVIDER";
    Launch["NAVIGATE_CODER_COMMENTS"] = "NAVIGATE_CODER_COMMENTS";
    Launch["CASE_DETAIL"] = "CASE_DETAIL";
    Launch["CASE_DETAIL_WITH_REFRESH"] = "CASE_DETAIL_WITH_REFRESH";
    Launch["CASE_SELECTED"] = "CASE_SELECTED";
    Launch["CASE_SEARCH"] = "CASE_SEARCH";
    Launch["LOAD_CASE_FROM_ID"] = "LOAD_CASE_FROM_ID";
    Launch["LOAD_CASE_WITH_TOKEN"] = "LOAD_CASE_WITH_TOKEN";
    Launch["BILLING_GROUP"] = "BILLING_GROUP";
    Launch["CODE_DESCRIPTIONS"] = "CODE_DESCRIPTIONS";
    Launch["CASE_LOOKUP_ERROR"] = "CASE_LOOKUP_ERROR";
    Launch["NAVIGATE_PROVIDER_DATAACCESS"] = "NAVIGATE_PROVIDER_DATAACCESS";
    return Launch;
}({});
var EpicLaunchPoints = /*#__PURE__*/ function(EpicLaunchPoints) {
    EpicLaunchPoints["NO_CONTEXT"] = "NoContext";
    EpicLaunchPoints["CHARGE_ROUTER"] = "ChargeRouter";
    EpicLaunchPoints["CHARGE_REVIEW"] = "ChargeReview";
    EpicLaunchPoints["FOLLOW_UP"] = "FollowUp";
    EpicLaunchPoints["ERROR"] = "Error";
    EpicLaunchPoints["ERROR2"] = "Error2";
    return EpicLaunchPoints;
}({});
var InvoiceMetadata$1 = /*#__PURE__*/ function(InvoiceMetadata) {
    InvoiceMetadata["ORGANIZATION_AVAILABLE"] = "ORGANIZATION_AVAILABLE";
    return InvoiceMetadata;
}({});
var ImprovementAction = /*#__PURE__*/ function(ImprovementAction) {
    ImprovementAction["ADD"] = "IMPROVEMENT_ADD";
    ImprovementAction["UPDATE"] = "IMPROVEMENT_UPDATE";
    ImprovementAction["REMOVE"] = "IMPROVEMENT_REMOVE";
    ImprovementAction["SEARCH"] = "IMPROVEMENT_SEARCH";
    ImprovementAction["GET"] = "IMPROVEMENT_GET";
    ImprovementAction["FETCH_IMPROVEMENT_OPTIONS"] = "FETCH_IMPROVEMENT_OPTIONS";
    ImprovementAction["ADD_PROVIDER"] = "IMPROVEMENT_PROVIDER_ADD";
    ImprovementAction["UPDATE_PROVIDER"] = "IMPROVEMENT_PROVIDER_UPDATE";
    ImprovementAction["REMOVE_PROVIDER"] = "IMPROVEMENT_PROVIDER_REMOVE";
    return ImprovementAction;
}({});
var MergeCases = /*#__PURE__*/ function(MergeCases) {
    MergeCases["SHOW_MERGE_CASES_MODAL"] = "SHOW_MERGE_CASES_MODAL";
    MergeCases["HIDE_MERGE_CASES_MODAL"] = "HIDE_MERGE_CASES_MODAL";
    MergeCases["FETCH_MERGEABLE_CASES"] = "FETCH_MERGEABLE_CASES";
    MergeCases["GET_DOCUMENTS_AS_HTML"] = "GET_DOCUMENTS_AS_HTML";
    MergeCases["SET_ACTIVE_CASE_RUN"] = "SET_ACTIVE_CASE_RUN";
    MergeCases["TOGGLE_MERGEABLE_CASE_SELECTION"] = "TOGGLE_MERGEABLE_CASE_SELECTION";
    MergeCases["FETCH_MERGE_CASES"] = "FETCH_MERGE_CASES";
    MergeCases["LAUNCH_IN_AMPLIFY"] = "LAUNCH_IN_AMPLIFY";
    MergeCases["SPLIT_CASE"] = "SPLIT_CASE";
    return MergeCases;
}({});
var CreateCase = /*#__PURE__*/ function(CreateCase) {
    CreateCase["NAVIGATE_CREATE_CASE"] = "NAVIGATE_CREATE_CASE";
    CreateCase["SUBMIT_CREATE_CASE"] = "SUBMIT_CREATE_CASE";
    CreateCase["FETCH_NOTES_SPECIALTY"] = "FETCH_NOTES_SPECIALTY";
    return CreateCase;
}({});
var AttachDocs = /*#__PURE__*/ function(AttachDocs) {
    AttachDocs["SHOW_ATTACH_DOCS_MODAL"] = "SHOW_ATTACH_DOCS_MODAL";
    AttachDocs["HIDE_ATTACH_DOCS_MODAL"] = "HIDE_ATTACH_DOCS_MODAL";
    AttachDocs["GET_DOCS_TO_ATTACH"] = "GET_DOCS_TO_ATTACH";
    AttachDocs["FETCH_SPECIALTY_DICTIONARY"] = "FETCH_SPECIALTY_DICTIONARY";
    AttachDocs["FETCH_NOTE_TYPE_DICTIONARY"] = "FETCH_NOTE_TYPE_DICTIONARY";
    AttachDocs["DOWNLOAD_DOCS"] = "DOWNLOAD_DOCS";
    return AttachDocs;
}({});
var Bench$2 = /*#__PURE__*/ function(Bench) {
    Bench["FEATURE_SELECTION"] = "FEATURE_SELECTION";
    Bench["CODE_DESCRIPTIONS"] = "CODE_DESCRIPTIONS";
    Bench["ACTIVITY"] = "ACTIVITY";
    Bench["OPTIMISTIC_CHANGE"] = "OPTIMISTIC_CHANGE";
    Bench["OPTIMISTIC_PRO_TECH_CHANGE"] = "OPTIMISTIC_PRO_TECH_CHANGE";
    Bench["POPUP_NAVIGATE"] = "POPUP_NAVIGATE";
    Bench["POPUP_CLOSE"] = "POPUP_CLOSE";
    Bench["PROMPT_CLOSE"] = "PROMPT_CLOSE";
    Bench["CODE_SEARCH"] = "CODE_SEARCH";
    Bench["CODE_SEARCH_DROP"] = "CODE_SEARCH_DROP";
    Bench["CLEAR_SEARCH"] = "CLEAR_SEARCH";
    Bench["CODE_ADD"] = "CODE_ADD";
    Bench["BULK_CODE_ADD"] = "BULK_CODE_ADD";
    Bench["BUNDLED_CODES_ADD"] = "BUNDLED_CODES_ADD";
    Bench["CREATE_TRANSACTION_AND_CODE_ADD"] = "CREATE_TRANSACTION_AND_CODE_ADD";
    Bench["CODE_UPDATE"] = "CODE_UPDATE";
    Bench["CODE_REMOVE"] = "CODE_REMOVE";
    Bench["BULK_CODE_REMOVE"] = "BULK_CODE_REMOVE";
    Bench["TIME_BASED_CODE_ADD"] = "TIME_BASED_CODE_ADD";
    Bench["TIME_BASED_CODE_UPDATE"] = "TIME_BASED_CODE_UPDATE";
    Bench["TRANSACTION_ORDER_CHANGE"] = "TRANSACTION_ORDER_CHANGE";
    Bench["REMOVE_INVOICE"] = "REMOVE_INVOICE";
    Bench["SELECT_INVOICE_TO_EDIT"] = "SELECT_INVOICE_TO_EDIT";
    Bench["SELECT_INVOICE_TO_ADD"] = "SELECT_INVOICE_TO_ADD";
    Bench["CANCEL_INVOICES_POPUP"] = "CANCEL_INVOICES_POPUP";
    Bench["CANCEL_INVOICES_CONFIRM"] = "CANCEL_INVOICES_CONFIRM";
    Bench["CANCEL_INVOICES_DISMISS"] = "CANCEL_INVOICES_DISMISS";
    Bench["OPEN_ADD_CHARGE_MODAL"] = "OPEN_ADD_CHARGE_MODAL";
    Bench["CLOSE_ADD_CHARGE_MODAL"] = "CLOSE_ADD_CHARGE_MODAL";
    Bench["ADD_TRANSACTION"] = "ADD_TRANSACTION";
    Bench["ADD_TRANSACTION_FAILED"] = "ADD_TRANSACTION_FAILED";
    Bench["ADD_TRANSACTION_LOADING"] = "ADD_TRANSACTION_LOADING";
    Bench["TXN_SHARED_CODE"] = "TXN_SHARED_CODE";
    Bench["SHOW_SUBMITTED_FEEDBACK"] = "SHOW_SUBMITTED_FEEDBACK";
    Bench["SHOW_LOADING_SUBMISSION"] = "SHOW_LOADING_SUBMISSION";
    Bench["SHOW_LOADING_CANCELATION"] = "SHOW_LOADING_CANCELATION";
    Bench["HIDE_LOADING_SUBMISSION"] = "HIDE_LOADING_SUBMISSION";
    Bench["HIDE_SUBMITTED_FEEDBACK"] = "HIDE_SUBMITTED_FEEDBACK";
    Bench["SHOW_CANCELED_MODAL"] = "SHOW_CANCELED_MODAL";
    Bench["SUBMITTED_MODAL_TIMER"] = "SUBMITTED_MODAL_TIMER";
    Bench["SHOW_SIZE_EXP_WARNING"] = "SHOW_SIZE_EXP_WARNING";
    Bench["HIDE_SIZE_EXP_WARNING"] = "HIDE_SIZE_EXP_WARNING";
    Bench["DELETE_SIZE_EXP_WARNING"] = "DELETE_SIZE_EXP_WARNING";
    Bench["ENABLE_TECH_PRO"] = "ENABLE_TECH_PRO";
    Bench["DISABLE_TECH_PRO"] = "DISABLE_TECH_PRO";
    Bench["TOGGLE_TECH_PRO"] = "TOGGLE_TECH_PRO";
    Bench["SET_LOADING_TECH_PRO"] = "SET_LOADING_TECH_PRO";
    Bench["SHOW_CLAIMS_ISSUES_MODAL"] = "SHOW_CLAIMS_ISSUES_MODAL";
    Bench["HIDE_CLAIMS_ISSUES_MODAL"] = "HIDE_CLAIMS_ISSUES_MODAL";
    Bench["SET_CLAIMS_ISSUES"] = "SET_CLAIMS_ISSUES";
    Bench["SHOW_HOLD_CASE_MODAL"] = "SHOW_HOLD_CASE_MODAL";
    Bench["HIDE_HOLD_CASE_MODAL"] = "HIDE_HOLD_CASE_MODAL";
    Bench["SHOW_CASE_COMMENT_MODAL"] = "SHOW_CASE_COMMENT_MODAL";
    Bench["HIDE_CASE_COMMENT_MODAL"] = "HIDE_CASE_COMMENT_MODAL";
    Bench["SHOW_EXCLUSION_CASE_MODAL"] = "SHOW_EXCLUSION_CASE_MODAL";
    Bench["HIDE_EXCLUSION_CASE_MODAL"] = "HIDE_EXCLUSION_CASE_MODAL";
    Bench["TOGGLE_LATE_CASE_CLEAR_MODAL"] = "TOGGLE_LATE_CASE_CLEAR_MODAL";
    Bench["SHOW_SPLIT_CASE_MODAL"] = "SHOW_SPLIT_CASE_MODAL";
    Bench["HIDE_SPLIT_CASE_MODAL"] = "HIDE_SPLIT_CASE_MODAL";
    Bench["TOGGLE_CHARGEABLE_CASE"] = "TOGGLE_CHARGEABLE_CASE";
    Bench["CLEAR_LATE_CASE_UPDATE"] = "CLEAR_LATE_CASE_UPDATE";
    Bench["HOLD_CASE"] = "HOLD_CASE";
    Bench["OFFHOLD_CASE"] = "OFFHOLD_CASE";
    Bench["FETCH_HOLD_CASE"] = "FETCH_HOLD_CASE";
    Bench["FETCH_CASE_VERSIONS"] = "FETCH_CASE_VERSIONS";
    Bench["NAVIGATE"] = "NAVIGATE";
    Bench["TOGGLE_SUBMIT_OLD_CASE_MODAL"] = "TOGGLE_SUBMIT_OLD_CASE_MODAL";
    Bench["SHOW_SIDE_NAV_BAR"] = "SHOW_SIDE_NAV_BAR";
    Bench["HIDE_SIDE_NAV_BAR"] = "HIDE_SIDE_NAV_BAR";
    Bench["LOAD_NEXT_OR_PREVIOUS_CASE"] = "LOAD_NEXT_OR_PREVIOUS_CASE";
    Bench["LOAD_WORKITEM_IN_AMPLIFY"] = "LOAD_WORKITEM_IN_AMPLIFY";
    Bench["LOAD_CURSOR_API_CONTEXT"] = "LOAD_CURSOR_API_CONTEXT";
    Bench["RESET_CURSOR_API_CONTEXT"] = "RESET_CURSOR_API_CONTEXT";
    Bench["FETCH_CASE_INTERACTIONS"] = "FETCH_CASE_INTERACTIONS";
    Bench["FETCH_CASE_INTERACTIONS_INFINITE"] = "FETCH_CASE_INTERACTIONS_INFINITE";
    Bench["FETCH_FLAGS"] = "FETCH_FLAGS";
    Bench["FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES"] = "FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES";
    Bench["FETCH_CASES_WITH_ENCOUNTER"] = "FETCH_CASES_WITH_ENCOUNTER";
    Bench["FETCH_CODES_WITH_ENCOUNTER"] = "FETCH_CODES_WITH_ENCOUNTER";
    Bench["GET_RELATED_CODES"] = "GET_RELATED_CODES";
    Bench["FETCH_RELATED_CODES"] = "FETCH_RELATED_CODES";
    Bench["SET_FILTER_TYPES_PATIENT_TIMELINE"] = "SET_FILTER_TYPES_PATIENT_TIMELINE";
    Bench["SET_FILTER_DATES_PATIENT_TIMELINE"] = "SET_FILTER_DATES_PATIENT_TIMELINE";
    Bench["SET_FILTER_TYPES_PATIENT_TIMELINE_INFINITE"] = "SET_FILTER_TYPES_PATIENT_TIMELINE_INFINITE";
    Bench["SET_FILTER_DATES_PATIENT_TIMELINE_INFINITE"] = "SET_FILTER_DATES_PATIENT_TIMELINE_INFINITE";
    Bench["LOAD_ROLES"] = "LOAD_ROLES";
    Bench["UPDATE_PROCESS_INSTANCE"] = "UPDATE_PROCESS_INSTANCE";
    Bench["FETCH_MESSAGE_COUNTS"] = "FETCH_MESSAGE_COUNTS";
    Bench["FETCH_MESSAGE_COUNTS_INFINITE"] = "FETCH_MESSAGE_COUNTS_INFINITE";
    Bench["FETCH_NOTE_TYPES"] = "FETCH_NOTE_TYPES";
    Bench["PROVIDER_ROLETYPE_CONFIGURATION"] = "PROVIDER_ROLETYPE_CONFIGURATION";
    Bench["UPDATE_TRANSACTION"] = "UPDATE_TRANSACTION";
    Bench["UPDATE_TRANSACTION_OPTIMISTICALLY"] = "UPDATE_TRANSACTION_OPTIMISTICALLY";
    Bench["CREATE_TRANSACTION_OPTIMISTICALLY"] = "CREATE_TRANSACTION_OPTIMISTICALLY";
    Bench["REPLACE_OPTIMISTIC_TRANSACTION"] = "REPLACE_OPTIMISTIC_TRANSACTION";
    Bench["UPDATE_TRANSACTION_ORDER_OPTIMISTICALLY"] = "UPDATE_TRANSACTION_ORDER_OPTIMISTICALLY";
    Bench["DOCUMENT_METADATA"] = "DOCUMENT_METADATA";
    Bench["SET_ACTIVE_NOTE"] = "SET_ACTIVE_NOTE";
    Bench["SET_ACTIVE_MINI_TAB"] = "SET_ACTIVE_MINI_TAB";
    Bench["SET_ACTIVE_VERTICAL_MINI_TAB"] = "SET_ACTIVE_VERTICAL_MINI_TAB";
    Bench["SET_UNRESOLVED_DOCUMENTS"] = "SET_UNRESOLVED_DOCUMENTS";
    Bench["FETCH_ORDER_TYPE_STATUS"] = "FETCH_ORDER_TYPE_STATUS";
    Bench["ADD_CODER_NOTE"] = "ADD_CODER_NOTE";
    Bench["ADD_USER_ACTIVITY_COMMENT"] = "ADD_USER_ACTIVITY_COMMENT";
    Bench["FETCH_CODER_NOTES"] = "FETCH_CODER_NOTES";
    Bench["SET_CODER_NOTE"] = "SET_CODER_NOTE";
    Bench["UPDATE_CODER_NOTE"] = "UPDATE_CODER_NOTE";
    Bench["DELETE_CODER_NOTE"] = "DELETE_CODER_NOTE";
    Bench["TOGGLE_NOTE_EDIT_MODE"] = "TOGGLE_NOTE_EDIT_MODE";
    Bench["FETCH_RELATED_CASE_FILTER_DICTIONARIES"] = "FETCH_RELATED_CASE_FILTER_DICTIONARIES";
    Bench["UPDATE_RELATED_CASE_FILTER_SELECTION"] = "UPDATE_RELATED_CASE_FILTER_SELECTION";
    Bench["ACQUIRE_CASE_ACCESS"] = "ACQUIRE_CASE_ACCESS";
    Bench["REFRESH_CASE_ACCESS_TIMER"] = "REFRESH_CASE_ACCESS_TIMER";
    Bench["RELEASE_CASE_ACCESS"] = "RELEASE_CASE_ACCESS";
    Bench["CASE_OPEN_SUCCESS"] = "CASE_OPEN_SUCCESS";
    Bench["CASE_OPEN_FAILED"] = "CASE_OPEN_FAILED";
    Bench["CASE_OPEN_CONFLICT"] = "CASE_OPEN_CONFLICT";
    Bench["REFRESH_TIMER_SUCCESS"] = "REFRESH_TIMER_SUCCESS";
    Bench["RESET_CASE_ACCESS"] = "RESET_CASE_ACCESS";
    Bench["SET_BENCH_MODE"] = "SET_BENCH_MODE";
    Bench["CASE_CLOSE_SUCCESS"] = "CASE_CLOSE_SUCCESS";
    Bench["CASE_CLOSE_NOT_FOUND"] = "CASE_CLOSE_NOT_FOUND";
    Bench["CASE_CLOSE_CONFLICT"] = "CASE_CLOSE_CONFLICT";
    Bench["CASE_CLOSE_FAILED"] = "CASE_CLOSE_FAILED";
    Bench["SET_LOCK_CASE_UID"] = "SET_LOCK_CASE_UID";
    Bench["REFRESH_HOLD_SUBMISSION"] = "REFRESH_HOLD_SUBMISSION";
    return Bench;
}({});
var CaseEdits = /*#__PURE__*/ function(CaseEdits) {
    CaseEdits["UPDATE_VALUE"] = "UPDATE_VALUE";
    CaseEdits["SET_ACTIVE_FIELD"] = "SET_ACTIVE_FIELD";
    CaseEdits["UPDATE_CASE"] = "UPDATE_CASE";
    CaseEdits["LOAD_ALL_PATIENT_DETAIL_OPTIONS"] = "LOAD_ALL_PATIENT_DETAIL_OPTIONS";
    CaseEdits["LOAD_PATIENT_DETAIL_OPTIONS"] = "LOAD_PATIENT_DETAIL_OPTIONS";
    return CaseEdits;
}({});
var StateReset = /*#__PURE__*/ function(StateReset) {
    StateReset["RESET_COMMON"] = "RESET_COMMON";
    return StateReset;
}({});
var GradeBenchPanel = /*#__PURE__*/ function(GradeBenchPanel) {
    GradeBenchPanel["GRADE_UPDATE"] = "GRADE_UPDATE";
    GradeBenchPanel["UPDATE_OR_ADD_ASSESSMENT"] = "UPDATE_OR_ADD_ASSESSMENT";
    GradeBenchPanel["UPDATE_UNITS"] = "UPDATE_UNITS";
    GradeBenchPanel["FETCH_RISK_CATEGORIES"] = "FETCH_RISK_CATEGORIES";
    GradeBenchPanel["ADD_CODE"] = "ADD_CQA_CODE";
    GradeBenchPanel["ADD_PROCEDURE_CODE"] = "ADD_PROCEDURE_CQA_CODE";
    GradeBenchPanel["ADD_DIAGNOSIS_CODE"] = "ADD_DIAGNOSIS_CQA_CODE";
    GradeBenchPanel["ADD_MODIFIER_CODE"] = "ADD_MODIFIER_CQA_CODE";
    GradeBenchPanel["REMOVE_CODE"] = "REMOVE_CODE";
    GradeBenchPanel["FETCH_QA_RULE"] = "FETCH_QA_RULE";
    GradeBenchPanel["CODE_EVENT"] = "HANDLE_CODE_EVENT";
    GradeBenchPanel["RESEQUENCE_CODE"] = "RESEQUENCE_CODE";
    GradeBenchPanel["BULK_RESEQUENCE"] = "BULK_RESEQUENCE";
    GradeBenchPanel["LOAD_CQA_WORK_ITEM_FROM_URL"] = "LOAD_CQA_WORK_ITEM_FROM_URL";
    GradeBenchPanel["REFRESH_SPAN_COMPLETION"] = "REFRESH_SPAN_COMPLETION";
    GradeBenchPanel["FETCH_CQA_WORKITEM_DOCUMENTS"] = "FETCH_CQA_WORKITEM_DOCUMENTS";
    GradeBenchPanel["FETCH_CQA_CODE_DESCRIPTIONS"] = "FETCH_CQA_CODE_DESCRIPTIONS";
    GradeBenchPanel["CREATE_CQA_TRANSACTION"] = "CREATE_CQA_TRANSACTION";
    GradeBenchPanel["DELETE_CQA_TRANSACTION"] = "DELETE_CQA_TRANSACTION";
    GradeBenchPanel["SUBMIT_CQA_WORKITEM"] = "SUBMIT_CQA_WORKITEM";
    GradeBenchPanel["RESOLVE_CQA_WORKITEM"] = "RESOLVE_CQA_WORKITEM";
    GradeBenchPanel["DELETE_CQA_CODE"] = "DELETE_CQA_CODE";
    GradeBenchPanel["RETRIEVE_ASSOCIATED_WORKITEMS"] = "RETRIEVE_ASSOCIATED_WORKITEMS";
    GradeBenchPanel["LOAD_ASSOCIATED_WORKITEM"] = "LOAD_ASSOCIATED_WORKITEM";
    GradeBenchPanel["FETCH_WORKER_INFO_FOR_USER"] = "FETCH_WORKER_INFO_FOR_USER";
    GradeBenchPanel["FETCH_GRADER_WORK_ITEM_ACTIVITY"] = "FETCH_GRADER_WORK_ITEM_ACTIVITY";
    GradeBenchPanel["ADD_EMPTY_SPAN"] = "ADD_EMPTY_SPAN";
    GradeBenchPanel["ATTACH_CODE_TO_SPAN"] = "ATTACH_CODE_TO_SPAN";
    GradeBenchPanel["DETACH_CODE_FROM_SPAN"] = "DETACH_CODE_FROM_SPAN";
    GradeBenchPanel["DELETE_SPAN"] = "DELETE_SPAN";
    GradeBenchPanel["FETCH_RUBRIC_VERSION"] = "FETCH_RUBRIC_VERSION";
    GradeBenchPanel["CLEAR_RUBRIC_VERSION"] = "CLEAR_RUBRIC_VERSION";
    GradeBenchPanel["UPDATE_ATTRIBUTE"] = "UPDATE_ATTRIBUTE";
    GradeBenchPanel["FETCH_ATTRIBUTES"] = "FETCH_ATTRIBUTES";
    GradeBenchPanel["DELETE_ATTRIBUTE"] = "DELETE_ATTRIBUTE";
    GradeBenchPanel["FETCH_ALL_ATTRIBUTES"] = "FETCH_ALL_ATTRIBUTES";
    GradeBenchPanel["ADD_USER_ACTIVITY_COMMENT"] = "ADD_USER_ACTIVITY_COMMENT";
    GradeBenchPanel["CLEAR_DOWNSTREAM_ATTRIBUTES"] = "CLEAR_DOWNSTREAM_ATTRIBUTES";
    GradeBenchPanel["AWAIT_AUTOSAVES_IDLE"] = "AWAIT_AUTOSAVES_IDLE";
    return GradeBenchPanel;
}({});

var commonActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AmplifyAuthenticate: AmplifyAuthenticate,
  AmplifyUIActions: AmplifyUIActions$1,
  AttachDocs: AttachDocs,
  AuthenticatedWindow: AuthenticatedWindow,
  Bench: Bench$2,
  CMxApplication: CMxApplication$1,
  Case: Case,
  CaseEdits: CaseEdits,
  CaseJSON: CaseJSON,
  CreateCase: CreateCase,
  EpicLaunchPoints: EpicLaunchPoints,
  Eula: Eula,
  FeedbackLevel: FeedbackLevel,
  GradeBenchPanel: GradeBenchPanel,
  ImprovementAction: ImprovementAction,
  InvoiceEditor: InvoiceEditor,
  InvoiceMetadata: InvoiceMetadata$1,
  Launch: Launch$1,
  MergeCases: MergeCases,
  ParentWindow: ParentWindow,
  Router: Router,
  StateReset: StateReset,
  UserInterface: UserInterface$1,
  UserSession: UserSession
});

// src/utils/formatProdErrorMessage.ts

// src/utils/isPlainObject.ts
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}

// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
function die(error, ...args) {
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var O = Object;
var getPrototypeOf = O.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = (value) => !!value && !!value[DRAFT_STATE];
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || isArray(value) || !!value[DRAFTABLE] || !!value[CONSTRUCTOR]?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = O[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
  if (!value || !isObjectish(value))
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null || proto === O[PROTOTYPE])
    return true;
  const Ctor = O.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
  if (Ctor === Object)
    return true;
  if (!isFunction(Ctor))
    return false;
  let ctorString = cachedCtorStrings.get(Ctor);
  if (ctorString === void 0) {
    ctorString = Function.toString.call(Ctor);
    cachedCtorStrings.set(Ctor, ctorString);
  }
  return ctorString === objectCtorString;
}
function each(obj, iter, strict = true) {
  if (getArchtype(obj) === 0 /* Object */) {
    const keys = strict ? Reflect.ownKeys(obj) : O.keys(obj);
    keys.forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
var has = (thing, prop, type = getArchtype(thing)) => type === 2 /* Map */ ? thing.has(prop) : O[PROTOTYPE].hasOwnProperty.call(thing, prop);
var get$1 = (thing, prop, type = getArchtype(thing)) => (
  // @ts-ignore
  type === 2 /* Map */ ? thing.get(prop) : thing[prop]
);
var set$1 = (thing, propOrOldValue, value, type = getArchtype(thing)) => {
  if (type === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (type === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
};
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
var isArray = Array.isArray;
var isMap = (target) => target instanceof Map;
var isSet = (target) => target instanceof Set;
var isObjectish = (target) => typeof target === "object";
var isFunction = (target) => typeof target === "function";
var isBoolean = (target) => typeof target === "boolean";
function isArrayIndex(value) {
  const n = +value;
  return Number.isInteger(n) && String(n) === value;
}
var getProxyDraft = (value) => {
  if (!isObjectish(value))
    return null;
  return value?.[DRAFT_STATE];
};
var latest = (state) => state.copy_ || state.base_;
var getValue = (value) => {
  const proxyDraft = getProxyDraft(value);
  return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var getFinalValue = (state) => state.modified_ ? state.copy_ : state.base_;
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (isArray(base))
    return Array[PROTOTYPE].slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = O.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc[WRITABLE] === false) {
        desc[WRITABLE] = true;
        desc[CONFIGURABLE] = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          [CONFIGURABLE]: true,
          [WRITABLE]: true,
          // could live with !!desc.set as well here...
          [ENUMERABLE]: desc[ENUMERABLE],
          [VALUE]: base[key]
        };
    }
    return O.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = O.create(proto);
    return O.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    O.defineProperties(obj, {
      set: dontMutateMethodOverride,
      add: dontMutateMethodOverride,
      clear: dontMutateMethodOverride,
      delete: dontMutateMethodOverride
    });
  }
  O.freeze(obj);
  if (deep)
    each(
      obj,
      (_key, value) => {
        freeze(value, true);
      },
      false
    );
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections
};
function isFrozen(obj) {
  if (obj === null || !isObjectish(obj))
    return true;
  return O.isFrozen(obj);
}

// src/utils/plugins.ts
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var PluginArrayMethods = "ArrayMethods";
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var isPluginLoaded = (pluginKey) => !!plugins[pluginKey];
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}

// src/core/scope.ts
var currentScope;
var getCurrentScope = () => currentScope;
var createScope = (parent_, immer_) => ({
  drafts_: [],
  parent_,
  immer_,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: true,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
  arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
});
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    scope.patchPlugin_ = getPlugin(PluginPatches);
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
var enterScope = (immer2) => currentScope = createScope(currentScope, immer2);
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
    }
    const { patchPlugin_ } = scope;
    if (patchPlugin_) {
      patchPlugin_.generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope
      );
    }
  } else {
    result = finalize(scope, baseDraft);
  }
  maybeFreeze(scope, result, true);
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    const finalValue = handleValue(value, rootScope.handledSet_, rootScope);
    return finalValue;
  }
  if (!isSameScope(state, rootScope)) {
    return value;
  }
  if (!state.modified_) {
    return state.base_;
  }
  if (!state.finalized_) {
    const { callbacks_ } = state;
    if (callbacks_) {
      while (callbacks_.length > 0) {
        const callback = callbacks_.pop();
        callback(rootScope);
      }
    }
    generatePatchesAndFinalize(state, rootScope);
  }
  return state.copy_;
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function markStateFinalized(state) {
  state.finalized_ = true;
  state.scope_.unfinalizedDrafts_--;
}
var isSameScope = (state, rootScope) => state.scope_ === rootScope;
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
  const parentCopy = latest(parent);
  const parentType = parent.type_;
  if (originalKey !== void 0) {
    const currentValue = get$1(parentCopy, originalKey, parentType);
    if (currentValue === draftValue) {
      set$1(parentCopy, originalKey, finalizedValue, parentType);
      return;
    }
  }
  if (!parent.draftLocations_) {
    const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
    each(parentCopy, (key, value) => {
      if (isDraft(value)) {
        const keys = draftLocations.get(value) || [];
        keys.push(key);
        draftLocations.set(value, keys);
      }
    });
  }
  const locations = parent.draftLocations_.get(draftValue) ?? EMPTY_LOCATIONS_RESULT;
  for (const location of locations) {
    set$1(parentCopy, location, finalizedValue, parentType);
  }
}
function registerChildFinalizationCallback(parent, child, key) {
  parent.callbacks_.push(function childCleanup(rootScope) {
    const state = child;
    if (!state || !isSameScope(state, rootScope)) {
      return;
    }
    rootScope.mapSetPlugin_?.fixSetContents(state);
    const finalizedValue = getFinalValue(state);
    updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
    generatePatchesAndFinalize(state, rootScope);
  });
}
function generatePatchesAndFinalize(state, rootScope) {
  const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */ || state.type_ === 1 /* Array */ && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
  if (shouldFinalize) {
    const { patchPlugin_ } = rootScope;
    if (patchPlugin_) {
      const basePath = patchPlugin_.getPath(state);
      if (basePath) {
        patchPlugin_.generatePatches_(state, basePath, rootScope);
      }
    }
    markStateFinalized(state);
  }
}
function handleCrossReference(target, key, value) {
  const { scope_ } = target;
  if (isDraft(value)) {
    const state = value[DRAFT_STATE];
    if (isSameScope(state, scope_)) {
      state.callbacks_.push(function crossReferenceCleanup() {
        prepareCopy(target);
        const finalizedValue = getFinalValue(state);
        updateDraftInParent(target, value, finalizedValue, key);
      });
    }
  } else if (isDraftable(value)) {
    target.callbacks_.push(function nestedDraftCleanup() {
      const targetCopy = latest(target);
      if (target.type_ === 3 /* Set */) {
        if (targetCopy.has(value)) {
          handleValue(value, scope_.handledSet_, scope_);
        }
      } else {
        if (get$1(targetCopy, key, target.type_) === value) {
          if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) {
            handleValue(
              get$1(target.copy_, key, target.type_),
              scope_.handledSet_,
              scope_
            );
          }
        }
      }
    });
  }
}
function handleValue(target, handledSet, rootScope) {
  if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
    return target;
  }
  if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) {
    return target;
  }
  handledSet.add(target);
  each(target, (key, value) => {
    if (isDraft(value)) {
      const state = value[DRAFT_STATE];
      if (isSameScope(state, rootScope)) {
        const updatedValue = getFinalValue(state);
        set$1(target, key, updatedValue, target.type_);
        markStateFinalized(state);
      }
    } else if (isDraftable(value)) {
      handleValue(value, handledSet, rootScope);
    }
  });
  return target;
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const baseIsArray = isArray(base);
  const state = {
    type_: baseIsArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let target = state;
  let traps = objectTraps;
  if (baseIsArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return [proxy, state];
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    let arrayPlugin = state.scope_.arrayMethodsPlugin_;
    const isArrayWithStringProp = state.type_ === 1 /* Array */ && typeof prop === "string";
    if (isArrayWithStringProp) {
      if (arrayPlugin?.isArrayOperationMethod(prop)) {
        return arrayPlugin.createMethodInterceptor(state, prop);
      }
    }
    const source = latest(state);
    if (!has(source, prop, state.type_)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(
      state.operationMethod
    ) && isArrayIndex(prop)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      const childKey = state.type_ === 1 /* Array */ ? +prop : prop;
      const childDraft = createProxy(state.scope_, value, state, childKey);
      return state.copy_[childKey] = childDraft;
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_.set(prop, false);
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop, state.type_)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_.set(prop, true);
    handleCrossReference(state, prop, value);
    return true;
  },
  deleteProperty(state, prop) {
    prepareCopy(state);
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_.set(prop, false);
      markChanged(state);
    } else {
      state.assigned_.delete(prop);
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      [WRITABLE]: true,
      [CONFIGURABLE]: state.type_ !== 1 /* Array */ || prop !== "length",
      [ENUMERABLE]: desc[ENUMERABLE],
      [VALUE]: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
for (let key in objectTraps) {
  let fn = objectTraps[key];
  arrayTraps[key] = function() {
    const args = arguments;
    args[0] = args[0][0];
    return fn.apply(this, args);
  };
}
arrayTraps.deleteProperty = function(state, prop) {
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? VALUE in desc ? desc[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.assigned_ = /* @__PURE__ */ new Map();
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.useStrictIteration_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (isFunction(base) && !isFunction(recipe)) {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (!isFunction(recipe))
        die(6);
      if (patchListener !== void 0 && !isFunction(patchListener))
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(scope, base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || !isObjectish(base)) {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin(PluginPatches).generateReplacementPatches_(base, result, {
            patches_: p,
            inversePatches_: ip
          });
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (isFunction(base)) {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (isBoolean(config?.autoFreeze))
      this.setAutoFreeze(config.autoFreeze);
    if (isBoolean(config?.useStrictShallowCopy))
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    if (isBoolean(config?.useStrictIteration))
      this.setUseStrictIteration(config.useStrictIteration);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(scope, base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(value) {
    this.useStrictIteration_ = value;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(rootScope, value, parent, key) {
  const [draft, state] = isMap(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent?.scope_ ?? getCurrentScope();
  scope.drafts_.push(draft);
  state.callbacks_ = parent?.callbacks_ ?? [];
  state.key_ = key;
  if (parent && key !== void 0) {
    registerChildFinalizationCallback(parent, state, key);
  } else {
    state.callbacks_.push(function rootDraftCleanup(rootScope2) {
      rootScope2.mapSetPlugin_?.fixSetContents(state);
      const { patchPlugin_ } = rootScope2;
      if (state.modified_ && patchPlugin_) {
        patchPlugin_.generatePatches_(state, [], rootScope2);
      }
    });
  }
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  let strict = true;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    strict = state.scope_.immer_.shouldUseStrictIteration();
  } else {
    copy = shallowCopy(value, true);
  }
  each(
    copy,
    (key, childValue) => {
      set$1(copy, key, currentImpl(childValue));
    },
    strict
  );
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/plugins/mapset.ts
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2 /* Map */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
        handleCrossReference(state, key, value);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(state.scope_, value, state, key);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    const map = new DraftMap(target, parent);
    return [map, map[DRAFT_STATE]];
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3 /* Set */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false,
        assigned_: void 0,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
        handleCrossReference(state, value, value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    const set2 = new DraftSet(target, parent);
    return [set2, set2[DRAFT_STATE]];
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(state.scope_, value, state, value);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  function fixSetContents(target) {
    if (target.type_ === 3 /* Set */ && target.copy_) {
      const copy = new Set(target.copy_);
      target.copy_.clear();
      copy.forEach((value) => {
        target.copy_.add(getValue(value));
      });
    }
  }
  loadPlugin(PluginMapSet, { proxyMap_, proxySet_, fixSetContents });
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;

// src/index.ts

// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(formatProdErrorMessage(0) );
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(formatProdErrorMessage(28) );
      }
      if (type in actionsMap) {
        throw new Error(formatProdErrorMessage(29) );
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addAsyncThunk(asyncThunk, reducers) {
      if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
      if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
      if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
      if (reducers.settled) actionMatchers.push({
        matcher: asyncThunk.settled,
        reducer: reducers.settled
      });
      return builder;
    },
    addMatcher(matcher, reducer) {
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg, {
      signal
    } = {}) {
      return (dispatch, getState, extra) => {
        const requestId = options?.idGenerator ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        if (signal) {
          if (signal.aborted) {
            abort(externalAbortMessage);
          } else {
            signal.addEventListener("abort", () => abort(externalAbortMessage), {
              once: true
            });
          }
        }
        const promise = async function() {
          let finalAction;
          try {
            let conditionResult = options?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler, {
                once: true
              });
            });
            dispatch(pending(requestId, arg, options?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

var IdentifierFormat = /*#__PURE__*/ function(IdentifierFormat) {
    IdentifierFormat["GUID"] = "GUID";
    IdentifierFormat["NUMERIC"] = "NUMERIC";
    IdentifierFormat["STRING"] = "STRING";
    IdentifierFormat["UNDEFINED"] = "UNDEFINED";
    IdentifierFormat["UNKNOWN"] = "UNKNOWN";
    return IdentifierFormat;
}({});
const uuidv4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const uuidv5Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-5[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/**
 * Detects the format of an identifier value, which can be a number, string, or undefined.
 *
 * The function returns one of the following `IdentifierFormat` values:
 * - `GUID`: if the identifier matches a UUID v4 or v5 format
 * - `NUMERIC`: if the identifier is a valid integer
 * - `STRING`: if the identifier is a non-empty string
 * - `UNDEFINED`: if the identifier is `undefined`
 * - `UNKNOWN`: if the identifier does not match any of the above formats
 *
 * @param candidate The identifier value to detect the format of
 * @returns {IdentifierFormat} The detected format of the identifier
 */ const detectIdFormat = (candidate)=>{
    if (candidate === undefined) {
        return "UNDEFINED";
    }
    if (uuidv4Regex.test(`${candidate}`)) {
        return "GUID";
    }
    if (uuidv5Regex.test(`${candidate}`)) {
        return "GUID";
    }
    if (Number.isInteger(candidate)) {
        return "NUMERIC";
    }
    if (parseInt(`${candidate}`) > 0) {
        return "NUMERIC";
    }
    if (typeof candidate === 'string') {
        return "STRING";
    }
    return "UNKNOWN";
};

var identifierUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IdentifierFormat: IdentifierFormat,
  detectIdFormat: detectIdFormat
});

function _define_property$c(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$c(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$c(target, key, source[key]);
        });
    }
    return target;
}
/**
 * Enum representing the different generations of the Automate feature.
 * - `GEN1`: The first generation of the Automate feature.  Originally Rad and Path.
 * - `GEN2`: The second generation of the Automate feature. Originally BSP.
 * - `GEN3`: The third generation of the Automate feature. Originally Radv2, will be all service lines.
 */ var AutomateGeneration = /*#__PURE__*/ function(AutomateGeneration) {
    AutomateGeneration["GEN1"] = "GEN1";
    AutomateGeneration["GEN2"] = "GEN2";
    AutomateGeneration["GEN3"] = "GEN3";
    return AutomateGeneration;
}({});
const v1 = [
    `${ServiceLines.RADIOLOGY}`,
    `${ServiceLines.PATHOLOGY}`
];
const V1_ALLOWED = new Set(v1.map((l)=>l.toUpperCase()));
const v2 = [
    `${ServiceLines.SURGERY}`
];
const V2_ALLOWED = new Set(v2.map((l)=>l.toUpperCase()));
const v3 = [
    `${ServiceLines.IPC}`,
    `${ServiceLines.IPC_LONG_NAME}`
];
const V3_ALLOWED = new Set(v3.map((l)=>l.toUpperCase()));
// --------------------------------
//  Service lines Definitions
// --------------------------------
const baseParameters = [
    [
        'evidence',
        'true'
    ],
    [
        'processTypes',
        'PREDICTION'
    ],
    [
        'processTypes',
        'ADDENDUM'
    ]
];
const gen3Parameters = [
    [
        'evidence',
        'true'
    ],
    [
        'processTypes',
        'PREDICTION'
    ],
    [
        'processTypes',
        'ADDENDUM'
    ],
    [
        'view',
        'amplify'
    ]
];
const DEFAULT_SL = {
    path: '',
    amplifyPath: '',
    caseIdProp: 'case_id',
    processInstanceIdprop: 'process_instance_id',
    caseDetailVersion: 'v2',
    caseListVersion: 'v2',
    automateGen: "GEN1",
    caseDetailParms: [
        ...baseParameters
    ]
};
const RADIOLOGY_V1_SL = {
    path: '',
    caseIdProp: 'case_id',
    processInstanceIdprop: 'process_instance_id',
    amplifyPath: 'radiology',
    caseListVersion: 'v2',
    caseDetailVersion: 'v4',
    automateGen: "GEN1",
    caseDetailParms: [
        ...baseParameters
    ]
};
const RADIOLOGY_V2_SL = {
    path: '/api/cases/RADIOLOGY',
    amplifyPath: 'radiology',
    caseIdProp: 'case_uid',
    processInstanceIdprop: 'caserun_uid',
    caseListVersion: 'v2',
    caseDetailVersion: 'v1',
    automateGen: "GEN3",
    caseDetailParms: [
        ...gen3Parameters
    ],
    ignoreEvidence: true
};
const PATHOLOGY_V1_SL = {
    path: '/api/cases/PATHOLOGY',
    amplifyPath: 'pathology',
    caseIdProp: 'case_id',
    processInstanceIdprop: 'process_instance_id',
    processInstanceGuidProp: 'process_instance_guid',
    caseListVersion: 'v2',
    caseDetailVersion: 'v2',
    automateGen: "GEN1",
    caseDetailParms: [
        ...baseParameters
    ]
};
const PATHOLOGY_V2_SL = {
    path: '/api/cases/PATHOLOGY',
    amplifyPath: 'pathology',
    caseIdProp: 'case_uid',
    processInstanceIdprop: 'caserun_uid',
    caseListVersion: 'v2',
    caseDetailVersion: 'v1',
    automateGen: "GEN3",
    caseDetailParms: [
        ...gen3Parameters
    ]
};
const SURGERY_SL = {
    path: '/api/cases/SURGERY',
    amplifyPath: 'surgery',
    caseIdProp: 'case_uid',
    processInstanceIdprop: 'process_instance_guid',
    caseListVersion: 'v2',
    caseDetailVersion: 'v1',
    automateGen: "GEN3",
    caseDetailParms: [
        ...baseParameters
    ]
};
const AUTOMATE_SL = {
    path: '/api/cases/BEDSIDEPRO',
    caselistAltId: 'BEDSIDEPRO',
    amplifyPath: 'ipc',
    caseIdProp: 'case_uid',
    processInstanceIdprop: 'process_instance_guid',
    caseListVersion: 'v2',
    caseDetailVersion: 'v1',
    automateGen: "GEN2",
    caseDetailParms: [
        ...baseParameters
    ]
};
// --------------------------------
//  URL helpers
// --------------------------------
/**
 * Convert a service-line name into a URL-safe slug.
 * "Bedside Pro" → "bedside-pro", "Radiology" → "radiology".
 */ const toServiceLineSlug = (name)=>name.trim().toLowerCase().replaceAll(/\s+/g, '-');
/**
 * Normalize a value that may have come from a URL segment back into the
 * canonical lowercase-with-spaces form so it can be compared against enum
 * values (which `determineServiceLineConfig` already uppercases internally).
 *
 * Handles: URI-encoded spaces (`%20`), hyphens, and mixed casing.
 * "bedside-pro" | "bedside%20pro" | "Bedside Pro" → "bedside pro"
 */ const normalizeServiceLineName = (raw)=>decodeURIComponent(raw).trim().toLowerCase().replaceAll('-', ' ');
// --------------------------------
//  API
// --------------------------------
/**
 * Determines whether the provided service line name represents the IPC/BSP service line.
 * This was required because there are numerous service line names for BSP.
 *
 * @param serviceLine - The service line name to check.
 * @returns `true` if the service line represents the IPC service line, `false` otherwise.
 */ const isIPC = (serviceLine)=>{
    if (!serviceLine || serviceLine.length === 0) {
        return false;
    }
    let ipcNames = new Set([
        ServiceLines.IPC.toUpperCase(),
        ServiceLines.IPC_LONG_NAME.toUpperCase(),
        ServiceLines.AUTOMATE.toUpperCase(),
        ServiceLines.BEDSIDE_PRO.toUpperCase()
    ]);
    return ipcNames.has(normalizeServiceLineName(serviceLine).toUpperCase());
};
const isSurgery = (serviceLine)=>{
    if (!serviceLine || serviceLine.length === 0) {
        return false;
    }
    let surgeryNames = new Set([
        ServiceLines.SURGERY.toUpperCase()
    ]);
    return surgeryNames.has(normalizeServiceLineName(serviceLine).toUpperCase());
};
const isPathology = (serviceLine)=>{
    if (!serviceLine || serviceLine.length === 0) {
        return false;
    }
    let pathologyNames = new Set([
        ServiceLines.PATHOLOGY.toUpperCase()
    ]);
    return pathologyNames.has(normalizeServiceLineName(serviceLine).toUpperCase());
};
/**
 * Determines the appropriate Automate generation based on the provided case identifier and service line.
 *
 * @param caseIdentifier - The case identifier, which can be either a case_id or a case_uid.
 * @param serviceLine - The service line name.
 * @returns The appropriate Automate generation.
 */ const determineAutomateGeneration = (caseIdentifier, serviceLine)=>{
    if (V1_ALLOWED.has(serviceLine)) {
        const idFormat = detectIdFormat(caseIdentifier);
        if (idFormat === IdentifierFormat.GUID) {
            return "GEN3";
        } else {
            return "GEN1";
        }
    } else if (V2_ALLOWED.has(serviceLine)) {
        return "GEN2";
    } else if (V3_ALLOWED.has(serviceLine)) {
        return "GEN3";
    }
};
/**
 * Determines the appropriate service line configuration based on the provided service line query.
 *
 * @param sl - An optional partial service line object containing information to determine the appropriate configuration.
 * @returns The service line configuration object that matches the provided service line query.
 */ const determineServiceLineConfig = (sl)=>{
    var _ref;
    const name = normalizeServiceLineName((_ref = sl === null || sl === void 0 ? void 0 : sl.name) !== null && _ref !== void 0 ? _ref : '').toUpperCase();
    let automateGen;
    switch(name){
        case `${ServiceLines.RADIOLOGY}`.toUpperCase():
            automateGen = (sl === null || sl === void 0 ? void 0 : sl.caseIdentifier) ? determineAutomateGeneration(sl.caseIdentifier, name) : "GEN1";
            return automateGen === "GEN3" ? _object_spread$c({}, RADIOLOGY_V2_SL) : _object_spread$c({}, RADIOLOGY_V1_SL);
        case `${ServiceLines.PATHOLOGY}`.toUpperCase():
            automateGen = (sl === null || sl === void 0 ? void 0 : sl.caseIdentifier) ? determineAutomateGeneration(sl.caseIdentifier, name) : "GEN1";
            const pathologyConfig = automateGen === "GEN3" ? _object_spread$c({}, PATHOLOGY_V2_SL) : _object_spread$c({}, PATHOLOGY_V1_SL);
            // Override caseDetailVersion to v3 for pathology when displayAllCaseRuns feature flag is enabled
            if (sl === null || sl === void 0 ? void 0 : sl.displayAllCaseRuns) {
                pathologyConfig.caseDetailVersion = 'v3';
            }
            return pathologyConfig;
        case `${ServiceLines.SURGERY}`.toUpperCase():
            return _object_spread$c({}, SURGERY_SL);
        case `${ServiceLines.AUTOMATE}`.toUpperCase():
        case `${ServiceLines.BEDSIDE_PRO}`.toUpperCase():
        case `${ServiceLines.BEDSIDE_PRO_NO_SPACE}`.toUpperCase():
        case `${ServiceLines.IPC_LONG_NAME}`.toUpperCase():
        case ServiceLines.IPC:
            return _object_spread$c({}, AUTOMATE_SL);
        default:
            return _object_spread$c({}, DEFAULT_SL);
    }
};
/**
 * Determines the appropriate process instance ID property based on the provided service line query.
 *
 * @param sl - An optional partial service line object containing information to determine the appropriate process instance ID property.
 * @returns The process instance ID property that matches the provided service line query.
 */ const determineProcessInstanceId = (sl)=>{
    var _ref;
    const name = normalizeServiceLineName((_ref = sl === null || sl === void 0 ? void 0 : sl.name) !== null && _ref !== void 0 ? _ref : '').toUpperCase();
    switch(name){
        case `${ServiceLines.RADIOLOGY}`.toUpperCase():
            return RADIOLOGY_V1_SL.processInstanceIdprop;
        case `${ServiceLines.PATHOLOGY}`.toUpperCase():
            return PATHOLOGY_V1_SL.processInstanceGuidProp;
        case `${ServiceLines.SURGERY}`.toUpperCase():
            return SURGERY_SL.processInstanceIdprop;
        case `${ServiceLines.AUTOMATE}`.toUpperCase():
        case `${ServiceLines.BEDSIDE_PRO}`.toUpperCase():
        case `${ServiceLines.IPC_LONG_NAME}`.toUpperCase():
        case ServiceLines.IPC:
            return AUTOMATE_SL.processInstanceIdprop;
        default:
            return DEFAULT_SL.processInstanceIdprop;
    }
};
/**
 * Constructs the appropriate case detail URL based on service line configuration.
 * 
 * @param caseId - The case ID
 * @param serviceLineConfig - The service line configuration object
 * @returns The constructed URL for case details
 */ const buildCaseDetailUrl = (caseId, serviceLineConfig)=>{
    if (serviceLineConfig.caseDetailVersion === 'v3') {
        return `${serviceLineConfig.path}/caseinstance/${caseId}/details/v3?evidence=true`;
    } else {
        return `${serviceLineConfig.path}/caseinstance/${caseId}/details/${serviceLineConfig.caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
    }
};
let _context = DEFAULT_SL;
const set = (sl)=>_context = sl;
const get = ()=>_context;
const reset = ()=>_context = DEFAULT_SL;

var serviceLines = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AutomateGeneration: AutomateGeneration,
  buildCaseDetailUrl: buildCaseDetailUrl,
  determineProcessInstanceId: determineProcessInstanceId,
  determineServiceLineConfig: determineServiceLineConfig,
  get: get,
  isIPC: isIPC,
  isPathology: isPathology,
  isSurgery: isSurgery,
  normalizeServiceLineName: normalizeServiceLineName,
  reset: reset,
  set: set,
  toServiceLineSlug: toServiceLineSlug
});

function _define_property$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$b(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$b(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$8(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$8(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$8(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const emptyPageable = {
    content: [],
    pageable: {
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        offset: 0,
        pageSize: 25,
        pageNumber: 0,
        unpaged: false,
        paged: true
    },
    totalElements: 0,
    totalPages: 0,
    last: true,
    size: 0,
    number: 0,
    numberOfElements: 0,
    sort: {
        sorted: false,
        unsorted: true,
        empty: true
    },
    first: true,
    empty: true
};
const defaultFilterableOptions = {
    dateFilter: undefined,
    filters: []
};
const defaultSortablePageable = {
    pageableDefinition: _object_spread$b({}, emptyPageable),
    sortableOptions: [
        {
            sortField: 'dateOfService',
            sortDirection: 'desc'
        },
        {
            sortField: 'id',
            sortDirection: 'desc'
        }
    ],
    filterableOptions: _object_spread$b({}, defaultFilterableOptions)
};
/**
 * Build a new sortable pageable for list() callbacks without mutating frozen Redux props.
 * Resets pagination to the first page like the previous in-place mutations did.
 */ function buildSortableWithFilters(sortablePageable, next) {
    var _sortablePageable_filterableOptions;
    const fo = (_sortablePageable_filterableOptions = sortablePageable.filterableOptions) !== null && _sortablePageable_filterableOptions !== void 0 ? _sortablePageable_filterableOptions : {};
    const pd = sortablePageable.pageableDefinition;
    return _object_spread_props$8(_object_spread$b({}, sortablePageable), {
        filterableOptions: _object_spread_props$8(_object_spread$b({}, fo), {
            filters: next.filters,
            dateFilter: next.dateFilter
        }),
        pageableDefinition: _object_spread_props$8(_object_spread$b({}, pd), {
            number: 0,
            first: true,
            last: false,
            pageable: _object_spread_props$8(_object_spread$b({}, pd.pageable), {
                pageNumber: 0,
                offset: 0
            })
        })
    });
}
const searchParamsFactory = (params)=>{
    // there may be multiple sorts for a list
    // https://stackoverflow.com/a/33034533
    let sorts = [];
    let pageables = [];
    if (Array.isArray(params.sortableOptions)) {
        sorts = params.sortableOptions.map((opt)=>[
                `sort`,
                `${opt.sortField},${opt.sortDirection}`
            ]);
    }
    if (params.pageableDefinition) {
        pageables = [
            [
                'page',
                `${params.pageableDefinition.pageable.pageNumber}`
            ],
            [
                'size',
                `${params.pageableDefinition.pageable.pageSize}`
            ]
        ];
    }
    const searchParams = new URLSearchParams([
        ...pageables,
        ...sorts
    ]);
    return searchParams;
};
const relatedCasesSortablePageable = _object_spread_props$8(_object_spread$b({}, defaultSortablePageable), {
    sortableOptions: [
        {
            sortField: 'dateOfService',
            sortDirection: 'desc'
        },
        {
            sortField: 'caseId',
            sortDirection: 'desc'
        }
    ]
});

var paginationUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildSortableWithFilters: buildSortableWithFilters,
  defaultFilterableOptions: defaultFilterableOptions,
  defaultSortablePageable: defaultSortablePageable,
  emptyPageable: emptyPageable,
  relatedCasesSortablePageable: relatedCasesSortablePageable,
  searchParamsFactory: searchParamsFactory
});

function _define_property$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$a(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Fetches the merged configuration jsonValue for a given configuration.
 * @param configurationId - The configuration ID.
 * @param tenantId - The tenant ID.
 * @param serviceLine - The service line.
 * @returns The merged configuration's jsonValue object, or {} if not found.
 */ async function fetchMergedConfigurationJsonValue(configurationId, tenantId, serviceLine) {
    if (!configurationId || !tenantId || !serviceLine) {
        console.warn(`[fetchMergedConfigurationJsonValue] Missing required parameters: configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${serviceLine}`);
        return {};
    }
    let effectiveServiceLine = serviceLine;
    if (isIPC(serviceLine)) {
        effectiveServiceLine = 'Inpatient Professional Coding';
    }
    const endpoint = `/configuration/detail/${configurationId}/${tenantId}/v2?merge=true&serviceLine=${effectiveServiceLine}`;
    const response = await request(endpoint, {
        method: Methods.GET
    });
    const responseData = await response.json();
    if (!Array.isArray(responseData) || responseData.length === 0) {
        console.warn(`[fetchMergedConfigurationJsonValue] No configuration found for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`);
        return {};
    }
    const configObj = responseData[0];
    if (!configObj || !Array.isArray(configObj.values)) {
        console.warn(`[fetchMergedConfigurationJsonValue] Config object missing or values not array for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`);
        return {};
    }
    const mergedValueObj = configObj.values.find((v)=>v.value === 'MERGED');
    if (!mergedValueObj || !mergedValueObj.jsonValue) {
        console.warn(`[fetchMergedConfigurationJsonValue] No merged value found for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`);
        return {};
    }
    return mergedValueObj.jsonValue;
}
const REQUEST_INIT_OPTIONS$3 = {
    method: 'GET',
    cache: 'no-cache',
    redirect: 'follow',
    referrer: 'no-referrer'
};
const getConfigurationsForSectionV2 = async (args)=>{
    const searchParams = new URLSearchParams({});
    if (args === null || args === void 0 ? void 0 : args.tenantId) {
        searchParams.set('tenantId', args.tenantId);
    }
    let serviceLine = '*';
    if (args === null || args === void 0 ? void 0 : args.serviceLine) {
        serviceLine = isIPC(args.serviceLine) ? 'Inpatient Professional Coding' : args.serviceLine;
    }
    searchParams.set('serviceLine', serviceLine);
    const result = await api.requestJSON(`/configuration/section/${args.section}/v2?${searchParams.toString()}`, _object_spread_props$7(_object_spread$a({}, REQUEST_INIT_OPTIONS$3), {
        method: Methods.GET
    }));
    return result;
};
/**
 * Filters source invoices based on configuration settings and automation thresholds
 * @param config - Configuration object containing coderConfig, sourceInvoices, activeItemArtifacts, tenantId, and serviceLine
 * @returns Object containing filtered invoices and configuration values used for filtering
 */ function filterSourceInvoices(config) {
    var _activeItemArtifacts__procedures, _activeItemArtifacts_;
    const { coderConfig, sourceInvoices, activeItemArtifacts, tenantId, serviceLine } = config;
    // Helper function to extract values from a configuration section by keyname
    const getValuesForKeyName = (keyName)=>{
        const config = coderConfig.find((config)=>config.keyname === keyName);
        return (config === null || config === void 0 ? void 0 : config.values) || [];
    };
    // Get configuration values for each keyname
    const automateCheckValues = getValuesForKeyName(ConfigurationKeyName.AUTOMATE_CHECK_CODE_SOURCE_PREDICTED_INVOICE);
    const codeSourceDisplayInvoiceTypesValues = getValuesForKeyName(ConfigurationKeyName.CODE_SOURCE_DISPLAY_INVOICE_TYPES);
    // Use getConfigValueForServiceLine for sophisticated service line and tenant matching
    const automateCheck = getConfigValueForServiceLine(automateCheckValues, serviceLine, tenantId);
    const codeSourceDisplayInvoiceTypes = getConfigValueForServiceLine(codeSourceDisplayInvoiceTypesValues, serviceLine, tenantId);
    let filteredSourceInvoices = sourceInvoices;
    // Only filter if codeSourceDisplayInvoiceTypes is defined
    if (codeSourceDisplayInvoiceTypes && typeof codeSourceDisplayInvoiceTypes === 'object') {
        filteredSourceInvoices = filteredSourceInvoices.filter((invoice)=>{
            return codeSourceDisplayInvoiceTypes['code_source_invoice_types'].includes(invoice.type);
        });
    }
    const checkAutomateThreshold = automateCheck && (activeItemArtifacts === null || activeItemArtifacts === void 0 ? void 0 : (_activeItemArtifacts_ = activeItemArtifacts[0]) === null || _activeItemArtifacts_ === void 0 ? void 0 : (_activeItemArtifacts__procedures = _activeItemArtifacts_.procedures) === null || _activeItemArtifacts__procedures === void 0 ? void 0 : _activeItemArtifacts__procedures.automate) || false;
    if (checkAutomateThreshold) {
        filteredSourceInvoices = filteredSourceInvoices.filter((invoice)=>{
            return invoice.invoice_type !== InvoiceTypes$1.PREDICTION;
        });
    }
    return {
        filteredSourceInvoices,
        automateCheck,
        codeSourceDisplayInvoiceTypes,
        checkAutomateThreshold
    };
}
const serviceLineAliases = {
    'Bedside Pro': 'Inpatient Professional Coding'
};
// Checks if a configuration value's serviceLines match the given service line.
// The includeWildcard flag (default true) controls whether to count a wildcard match.
function serviceLineMatches(configValue, serviceLineName, includeWildcard = true) {
    var _configValue_serviceLines, _configValue_serviceLines1, _configValue_serviceLines2;
    const normalizedServiceLine = serviceLineAliases[serviceLineName] || serviceLineName;
    return ((_configValue_serviceLines = configValue.serviceLines) === null || _configValue_serviceLines === void 0 ? void 0 : _configValue_serviceLines.includes(serviceLineName)) || ((_configValue_serviceLines1 = configValue.serviceLines) === null || _configValue_serviceLines1 === void 0 ? void 0 : _configValue_serviceLines1.includes(normalizedServiceLine)) || includeWildcard && ((_configValue_serviceLines2 = configValue.serviceLines) === null || _configValue_serviceLines2 === void 0 ? void 0 : _configValue_serviceLines2.includes('*'));
}
// Add this new function to prioritize jsonValue over value
function getConfigDisplayValue(configValue) {
    // If jsonValue exists and is not null/undefined, return it
    if (configValue.jsonValue !== null && configValue.jsonValue !== undefined) {
        return configValue.jsonValue;
    }
    // Fall back to the regular value
    return configValue.value;
}
// Retrieves configuration values for a given service line and tenant.
// It prioritizes an exact match (excluding wildcard) before falling back to wildcard matches.
// Now returns jsonValue if available, otherwise falls back to value.
function getConfigValueForServiceLine(values, serviceLineName, tenantId) {
    // Define match criteria in priority order (higher priority = lower index)
    const matchCriteria = [
        // 1. Exact tenant + Exact service line (highest priority)
        (v)=>v.tenantId === tenantId && serviceLineMatches(v, serviceLineName, false),
        // 2. Exact tenant + Wildcard service line
        (v)=>{
            var _v_serviceLines;
            return v.tenantId === tenantId && ((_v_serviceLines = v.serviceLines) === null || _v_serviceLines === void 0 ? void 0 : _v_serviceLines.includes('*'));
        },
        // 3. Parent health system + Exact service line
        (v)=>v.tenantId !== tenantId && v.tenantId !== '*' && serviceLineMatches(v, serviceLineName, false),
        // 4. Parent health system + Wildcard service line
        (v)=>{
            var _v_serviceLines;
            return v.tenantId !== tenantId && v.tenantId !== '*' && ((_v_serviceLines = v.serviceLines) === null || _v_serviceLines === void 0 ? void 0 : _v_serviceLines.includes('*'));
        },
        // 5. Wildcard tenant + Exact service line
        (v)=>v.tenantId === '*' && serviceLineMatches(v, serviceLineName, false),
        // 6. Wildcard tenant + Wildcard service line (lowest priority)
        (v)=>{
            var _v_serviceLines;
            return v.tenantId === '*' && ((_v_serviceLines = v.serviceLines) === null || _v_serviceLines === void 0 ? void 0 : _v_serviceLines.includes('*'));
        }
    ];
    // Find the first matching criteria that has results
    for (const criteria of matchCriteria){
        const matches = values.filter(criteria);
        if (matches.length > 0) {
            return matches.length === 1 ? getConfigDisplayValue(matches[0]) : matches.map((v)=>getConfigDisplayValue(v));
        }
    }
    return null;
}

var configurationUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchMergedConfigurationJsonValue: fetchMergedConfigurationJsonValue,
  filterSourceInvoices: filterSourceInvoices,
  getConfigDisplayValue: getConfigDisplayValue,
  getConfigValueForServiceLine: getConfigValueForServiceLine,
  getConfigurationsForSectionV2: getConfigurationsForSectionV2,
  serviceLineAliases: serviceLineAliases,
  serviceLineMatches: serviceLineMatches
});

const _lookupTable = new Map([
    [
        'body',
        'raw_body'
    ],
    [
        'reason_for_visit',
        'reason_for_visit'
    ],
    [
        'bodyPart',
        'body_region'
    ]
]);
const getFieldId = (fieldName)=>{
    return _lookupTable.get(fieldName) || fieldName;
};
/**
 * Formats a given text based on specific conditions.
 *
 * @param {string} text - The input text that needs to be formatted.
 * @param {number} [max_length=20] - The maximum allowed length for the text before truncation. Default value is 20.
 * @returns {string} - Returns the formatted string where:
 *   - If the text contains a comma, it treats the string as "LastName, FirstName".
 *     It capitalizes the last name and keeps only the first letter of the first name.
 *   - If the text does not contain a comma, it is truncated to the specified `max_length`
 *     and capitalized accordingly.
 *   - If the input text is empty, it returns an empty string.
 *
 * Example:
 *   formatDisplayText('Doe, John'); // Returns: 'Doe, J'
 *   formatDisplayText('apple banana', 5); // Returns: 'Apple'
 */ const formatDisplayText = (text, max_length = 20)=>{
    if (isEmpty(text)) return '';
    if (text.includes(',')) {
        const [lastName, firstName] = text.split(',').map((item)=>item.trim());
        return capitalize(lastName) + (isEmpty(firstName) ? '' : `, ${upperFirst(firstName[0])}`);
    }
    return upperFirst(truncate(text, max_length, '').toLowerCase());
};
const doesPathEndWithV2 = ()=>{
    return window.location.pathname.endsWith('/v2/');
};
const buildDataAccessRequestObject = (state, name, actionDestination)=>{
    var _ref, _ref1, _ref2;
    var _state_codeBench, _state_ui, _state_ui_serviceLine, _state_ui1;
    const context = (state === null || state === void 0 ? void 0 : (_state_codeBench = state.codeBench) === null || _state_codeBench === void 0 ? void 0 : _state_codeBench.userContext) || null;
    const activeUser = (state === null || state === void 0 ? void 0 : (_state_ui = state.ui) === null || _state_ui === void 0 ? void 0 : _state_ui.activeUser) || null;
    const serviceLine = (state === null || state === void 0 ? void 0 : (_state_ui1 = state.ui) === null || _state_ui1 === void 0 ? void 0 : (_state_ui_serviceLine = _state_ui1.serviceLine) === null || _state_ui_serviceLine === void 0 ? void 0 : _state_ui_serviceLine.name) || "";
    return {
        sourceId: (_ref = activeUser === null || activeUser === void 0 ? void 0 : activeUser.userId) !== null && _ref !== void 0 ? _ref : "",
        serviceLine: serviceLine,
        healthSystemUid: (_ref1 = context === null || context === void 0 ? void 0 : context.healthSystemTenantId) !== null && _ref1 !== void 0 ? _ref1 : "",
        tenantUid: (_ref2 = context === null || context === void 0 ? void 0 : context.tenantId) !== null && _ref2 !== void 0 ? _ref2 : "",
        name,
        action: "read",
        actionDestination,
        sort: "Asc",
        limit: 1000
    };
};
const buildPatienttimelineDataAccessRequest = (ui, name, actionDestination)=>{
    var _ref, _ref1, _ref2;
    var _ui_context, _ui_serviceLine;
    const context = (ui === null || ui === void 0 ? void 0 : (_ui_context = ui.context) === null || _ui_context === void 0 ? void 0 : _ui_context.activeContext) || null;
    const activeUser = (ui === null || ui === void 0 ? void 0 : ui.activeUser) || null;
    const serviceLine = (ui === null || ui === void 0 ? void 0 : (_ui_serviceLine = ui.serviceLine) === null || _ui_serviceLine === void 0 ? void 0 : _ui_serviceLine.name) || '';
    return {
        sourceId: (_ref = activeUser === null || activeUser === void 0 ? void 0 : activeUser.userId) !== null && _ref !== void 0 ? _ref : '',
        serviceLine: serviceLine,
        healthSystemUid: (_ref1 = context === null || context === void 0 ? void 0 : context.healthSystemTenantId) !== null && _ref1 !== void 0 ? _ref1 : '',
        tenantUid: (_ref2 = context === null || context === void 0 ? void 0 : context.tenantId) !== null && _ref2 !== void 0 ? _ref2 : '',
        name,
        action: 'read',
        actionDestination,
        sort: 'Asc',
        limit: 1000
    };
};
const getAvatarInitials = (firstName, lastName)=>{
    if (isEmpty(firstName) && isEmpty(lastName)) {
        return 'N/A';
    }
    // Get the initials
    var initials = firstName.charAt(0).toUpperCase() + (lastName && !isEmpty(lastName) ? ` ${lastName.charAt(0).toUpperCase()}` : '');
    return initials;
};

var _utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildDataAccessRequestObject: buildDataAccessRequestObject,
  buildPatienttimelineDataAccessRequest: buildPatienttimelineDataAccessRequest,
  doesPathEndWithV2: doesPathEndWithV2,
  formatDisplayText: formatDisplayText,
  getAvatarInitials: getAvatarInitials,
  getFieldId: getFieldId
});

function _define_property$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$9(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { Bench: Bench$1 } = commonActions;
const REQUEST_INIT_OPTIONS$2 = {
    method: 'GET',
    cache: 'no-cache',
    redirect: 'follow',
    referrer: 'no-referrer'
};
/**
 * Function that returns the current process instance.
 */ const getProcessInstance = async (url)=>{
    const processInstance = await api.requestJSON(url, _object_spread$9({}, REQUEST_INIT_OPTIONS$2));
    return processInstance;
};
const fetchActivity = createAsyncThunk(Bench$1.ACTIVITY, async (processInstance)=>{
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    const userActivityPromise = api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstance.guid.uuid}/useractivity/v1`, _object_spread$9({}, REQUEST_INIT_OPTIONS$2));
    const systemActivityPromise = api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstance.guid.uuid}/systemactivity/v1`, _object_spread$9({}, REQUEST_INIT_OPTIONS$2));
    const userActivityCommentsPromise = api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstance.guid.uuid}/useractivity/comments/v1`, _object_spread$9({}, REQUEST_INIT_OPTIONS$2));
    const [userActivity, systemActivity, userActivityComments] = await Promise.all([
        userActivityPromise,
        systemActivityPromise,
        userActivityCommentsPromise
    ]);
    const activity = [
        ...userActivity.map((activity)=>_object_spread_props$6(_object_spread$9({}, activity), {
                activityType: 'USER'
            })),
        ...systemActivity.map((activity)=>_object_spread_props$6(_object_spread$9({}, activity), {
                activityType: 'SYSTEM'
            })),
        ...userActivityComments.map((activity)=>_object_spread_props$6(_object_spread$9({}, activity), {
                activityType: 'USER_ACTIVITY_COMMENTS'
            }))
    ];
    activity.sort((a, b)=>sortByDate(a.timestamp, b.timestamp));
    return activity;
});
const updateProcessInstance = createAsyncThunk(Bench$1.UPDATE_PROCESS_INSTANCE, async (processInstanceParam, { dispatch })=>{
    const processInstance = await getProcessInstance(`/coding-api/processinstance/${processInstanceParam.serviceLine}/${processInstanceParam.guid}/v1?evidence=true&errors=true`);
    dispatch(fetchActivity(processInstance));
    return processInstance;
});
const fetchCodeBenchLayoutConfiguration = createAsyncThunk('FETCH_CODE_BENCH_LAYOUT_CONFIGURATION', async (params, { getState })=>{
    var _state_ui;
    const { tenantId, serviceLine } = params;
    const state = getState();
    // @ts-ignore state.ui exists on the newer (non-embedded) application V2 UI wont be supported on the embedded application.
    if ((state === null || state === void 0 ? void 0 : (_state_ui = state.ui) === null || _state_ui === void 0 ? void 0 : _state_ui.hasAmplifyCaseRunV2Access) && doesPathEndWithV2()) {
        return fetchMergedConfigurationJsonValue('demographics-bench-layout', tenantId, serviceLine);
    }
    return fetchMergedConfigurationJsonValue('code-bench-layout', tenantId, serviceLine);
});

const fetchDictionaryRows = async (searchParams)=>{
    return await api.requestJSON(`/dictionary/row/unrestricted/v2?${searchParams.toString()}`, {
        method: Methods.GET
    });
};

var dictionaryUtilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchDictionaryRows: fetchDictionaryRows
});

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const _cpt = {
    code: '',
    codeType: 'CPT',
    effectiveDate: '',
    dictionaryName: 'CPT Codes',
    columnName: 'Code'
};
const _mod = {
    code: '',
    codeType: 'MODIFIER',
    effectiveDate: '',
    dictionaryName: 'Modifiers',
    columnName: 'Code'
};
const _icd = {
    code: '',
    codeType: 'ICD',
    effectiveDate: '',
    dictionaryName: 'ICD Codes',
    columnName: 'Code'
};
const buildDescriptionRequest = (invoices, effectiveDate)=>{
    const accumulator = [];
    invoices.forEach((invoice)=>{
        invoice.transactions.forEach((txn)=>{
            if (txn.procedure) {
                accumulator.push(_object_spread_props$5(_object_spread$8({}, _cpt), {
                    code: txn.procedure.procedure_code,
                    effectiveDate
                }));
            }
            (txn.modifiers || []).forEach((mod)=>{
                accumulator.push(_object_spread_props$5(_object_spread$8({}, _mod), {
                    code: mod.modifier_code,
                    effectiveDate
                }));
            });
            (txn.diagnoses || []).forEach((diagnosis)=>{
                accumulator.push(_object_spread_props$5(_object_spread$8({}, _icd), {
                    code: diagnosis.diagnosis_code,
                    effectiveDate
                }));
            });
        });
    });
    return accumulator;
};

var _cpt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  _cpt: _cpt,
  buildDescriptionRequest: buildDescriptionRequest
});

// Code description lookups may or may not include cost centers.
// If cost centers are not included, results may come back in the
// form
// {
//   "31000099-2007257": {
//      "codeType": "TECH",
//      "code": "31000099",...
//    },
//    "31000099-2007254": {
//       "codeType": "TECH",
//       "code": "31000099",
//     },
// }
// For the purposes of the displaying the *description* to the UI
// we assume that the *description* and the *shortDescription* will be
// standard across cost centers.
// The resulting output will be a single code:
// {
//   "310000997": {
//      "codeType": "TECH",
//      "code": "31000099",...
//    }
// }
const normalizeDescriptions = (descriptions)=>{
    const codeMap = {};
    Object.values(descriptions).forEach((entry)=>{
        codeMap[entry.code] = entry;
    });
    return codeMap;
};

function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
const normalzeCCIIssue = (cci)=>{
    const data = {
        message: cci.message,
        source: EditorIssueProvenance.CCI,
        level: cci.status === '2' ? EditorIssueLevel.WARNING : EditorIssueLevel.ERROR,
        artifactType: [
            CaseArtifactTypes.ASSEMBLED,
            CaseArtifactTypes.PROCESSED
        ]
    };
    return data;
};
const normalizeClaimsIssue = (claimsIssue)=>{
    var _claimsIssue_status;
    const data = {
        message: claimsIssue.message,
        source: EditorIssueProvenance.CLAIMS,
        level: ((_claimsIssue_status = claimsIssue.status) === null || _claimsIssue_status === void 0 ? void 0 : _claimsIssue_status.toLowerCase()) === 'error' ? EditorIssueLevel.ERROR : EditorIssueLevel.WARNING,
        artifactType: [
            CaseArtifactTypes.ASSEMBLED,
            CaseArtifactTypes.PROCESSED
        ]
    };
    return data;
};
const normalizeCustomRuleIssue = (claimsIssue)=>{
    var _claimsIssue_status;
    const data = {
        message: claimsIssue.message,
        source: EditorIssueProvenance.CUSTOM_RULES,
        level: (claimsIssue === null || claimsIssue === void 0 ? void 0 : (_claimsIssue_status = claimsIssue.status) === null || _claimsIssue_status === void 0 ? void 0 : _claimsIssue_status.toLowerCase()) === 'error' ? EditorIssueLevel.ERROR : EditorIssueLevel.WARNING,
        artifactType: [
            CaseArtifactTypes.ASSEMBLED,
            CaseArtifactTypes.PROCESSED
        ]
    };
    return data;
};
const normalizeCustomRules = (cciIssues)=>{
    const ret = {};
    Object.entries(cciIssues).forEach(([key, values])=>{
        if (Array.isArray(values)) {
            ret[key] = values.map(normalizeCustomRuleIssue);
        }
    });
    return ret;
};
const normalizeCCIS = (cciIssues)=>{
    const ret = {};
    Object.entries(cciIssues).forEach(([key, values])=>{
        if (Array.isArray(values)) {
            ret[key] = values.map(normalzeCCIIssue);
        }
    });
    return ret;
};
const normalizeClaims = (cciIssues)=>{
    const ret = {};
    if (typeof cciIssues !== 'object') {
        return ret;
    }
    Object.entries(cciIssues).forEach(([key, values])=>{
        if (Array.isArray(values)) {
            ret[key] = values.map(normalizeClaimsIssue);
        } else {
            // sometimes, the value is '{"71045":"null"}'.
            // sometimes it's '{"N63.1":"Invalid Code"}'
            // we display the latter, but not the former.
            if (values !== null && values !== 'null') {
                ret[key] = [
                    normalizeClaimsIssue({
                        status: EditorIssueLevel.UNKNOWN,
                        message: values
                    })
                ];
            }
        }
    });
    return ret;
};
const _merge = (src, mix)=>{
    Object.entries(mix).forEach(([key, value])=>{
        if (Array.isArray(src[key])) {
            src[key] = [
                ...src[key],
                ...value
            ];
        } else if (Array.isArray(value)) {
            src[key] = [
                ...value
            ];
        }
    });
};
const toObject = (item)=>{
    if (isString(item)) {
        return parseVWIssues(item);
    }
    return item !== null && item !== void 0 ? item : {};
};
const parseCodeEdits = (caseRun)=>{
    const merged = {};
    const claims_editor_issues = toObject(caseRun.claims_editor_issues);
    const claims = normalizeClaims(claims_editor_issues);
    _merge(merged, claims);
    const cci_editor_issues = toObject(caseRun.cci_editor_issues);
    const ccis = normalizeCCIS(cci_editor_issues);
    _merge(merged, ccis);
    return merged;
};
const parseVWIssues = (item)=>{
    if (item === null || item === undefined) {
        return {};
    }
    // nested - double stringified JSON structure
    if (isStringifiedJSON(item)) {
        const obj = getValueForString(item);
        Object.entries(obj).forEach((entry)=>{
            const [key, value] = entry;
            if (isStringifiedJSON(value)) {
                obj[key] = getValueForString(value);
            }
        });
        return obj;
    }
    return item;
};
const parseVWByStatus = (codeIssue)=>{
    return codeIssue === null || codeIssue === void 0 ? void 0 : codeIssue.filter((error)=>!isEmpty(error)).reduce((acc, curr)=>{
        const code = Object.keys(curr)[0];
        // group issues by level
        const grouped = groupBy(curr[code], "level");
        const existingItemIndex = acc.findIndex((item)=>code in item);
        if (existingItemIndex !== -1) {
            Object.keys(grouped).forEach((level)=>{
                if (!acc[existingItemIndex][code]) {
                    acc[existingItemIndex][code] = {};
                }
                if (!acc[existingItemIndex][code][level]) {
                    acc[existingItemIndex][code][level] = [];
                }
                acc[existingItemIndex][code][level].push(...grouped[level]);
            });
        } else {
            acc.push({
                [code]: grouped
            });
        }
        return acc;
    }, []);
};
/**
 * Given an Amplify Process Instance return a list of Merge History warnings.
 * @param amplifyErrors {AmplifyErrors}
 * @returns {AmplifyAPI.AmplifyError[]}
 */ const filterMergeHistoryWarnings = (amplifyErrors)=>{
    if (!amplifyErrors || !amplifyErrors.hasOwnProperty('errors')) {
        return [];
    }
    return amplifyErrors.errors.filter((error)=>error.source === AmplifyErrorSources.MERGE_SPLIT_HISTORY);
};
/**
 * Given an Amplify Process Instance return a list of standard errors.
 * Exclude errors from CCI and Claims.
 * @param amplifyErrors {AmplifyErrors}
 * @returns {AmplifyAPI.AmplifyError[]}
 */ const filterInvoiceIssues = (amplifyErrors)=>{
    if (!amplifyErrors || !amplifyErrors.hasOwnProperty('errors')) {
        return [];
    }
    return amplifyErrors.errors.filter((error)=>error.source === AmplifyErrorSources.CUSTOM || error.source === AmplifyErrorSources.STANDARD);
};
/**
 * Given an Amplify Process Instance return a map of CCI and Claims Issues
 * @param amplifyErrors {AmplifyErrors}
 * @returns {CodeIssues}
 */ const parseInvoiceIssues = (amplifyErrors)=>{
    var _parseAndFilterV2Errors;
    if (!amplifyErrors) {
        return {
            cci: [],
            claims: [],
            custom_rules: [],
            unresolved_documents: [],
            hold_issue: []
        };
    }
    const formatedV2Errors = (_parseAndFilterV2Errors = parseAndFilterV2Errors(amplifyErrors === null || amplifyErrors === void 0 ? void 0 : amplifyErrors.errors)) !== null && _parseAndFilterV2Errors !== void 0 ? _parseAndFilterV2Errors : [];
    const errorList = [
        ...amplifyErrors === null || amplifyErrors === void 0 ? void 0 : amplifyErrors.errors,
        ...formatedV2Errors
    ];
    const parseAndNormalize = (editError)=>normalizeClaims(parseVWIssues(editError.message));
    const parseAndNormalizeCCI = (editError)=>normalizeCCIS(parseVWIssues(editError.message));
    const parseAndNormalizeCustomRules = (editError)=>normalizeCustomRules(parseVWIssues(editError.message));
    const claims = errorList.filter((error)=>error.message_key === IssueTypeErrors$1.CLAIMS_EDIT).map(parseAndNormalize).filter((rule)=>Object.keys(rule).length > 0);
    const cci = errorList.filter((error)=>error.message_key === IssueTypeErrors$1.CCI_EDIT).map(parseAndNormalizeCCI).filter((rule)=>Object.keys(rule).length > 0);
    const custom_rules = errorList.filter((error)=>error.message_key === IssueTypeErrors$1.CUSTOM_RULES).map(parseAndNormalizeCustomRules).filter((rule)=>Object.keys(rule).length > 0);
    const unresolved_documents = errorList.filter((error)=>error.source === AmplifyErrorSources.UNRESOLVED_DOCUMENT);
    const hold_issue = errorList.filter((error)=>error.source === AmplifyErrorSources.HOLD);
    return {
        cci,
        claims,
        custom_rules,
        unresolved_documents,
        hold_issue
    };
};
/**
 * Converts a list of issues, both CCI and Claims, to a hash-map based
 * object so that the issues can be appended to codes.  The return data includes
 * claims and CCI issues so that both may be available for the same code.
 * @param codeIssues
 * @returns
 */ const convertIssuesToCodeMap = (codeIssues)=>{
    const returnData = {};
    const populateIssueList = (issueList)=>{
        Object.keys(issueList).forEach((key)=>{
            if (!returnData[key]) {
                returnData[key] = issueList[key];
            } else {
                returnData[key] = [
                    ...returnData[key],
                    ...issueList[key]
                ];
            }
        });
    };
    codeIssues.claims.forEach(populateIssueList);
    codeIssues.cci.forEach(populateIssueList);
    codeIssues.custom_rules.forEach(populateIssueList);
    return returnData;
};
/**
 * Given a process instance returns a map of code errors
 * for both CCI and claims.
 * {
 *  cci : { '77067': [{...err}] },
 *  claims : {}
 * }
 * @param processInstance {AmplifyAPI.ProcessInstance}
 * @returns
 */ const parseProcessInstance = (processInstance)=>{
    const issues = parseInvoiceIssues(processInstance);
    return convertIssuesToCodeMap(issues);
};
/**
 * Creates synthetic errors (read:Standard) for CCI and Claims.
 * This is helpful because CCI issues are attached at the code
 * level, but may need to be represented elsewhere on the charges.
 * The view code for those errors
 * @param amplifyErrors {AmplifyAPI.ProcessInstance}
 * @returns
 */ const createSyntheticStandardErrors = (amplifyErrors)=>{
    if (!amplifyErrors || !amplifyErrors.hasOwnProperty('errors')) {
        return [];
    }
    const synthesizer = (message_key, errorOverride)=>{
        return amplifyErrors.errors.filter((error)=>error.message_key === message_key).map((error)=>{
            return _object_spread$7({}, error, errorOverride);
        });
    };
    const cci = synthesizer(IssueTypeErrors$1.CCI_EDIT, {
        message: 'There are CCI issues for these charges',
        source: AmplifyErrorSources.STANDARD
    });
    const claims = synthesizer(IssueTypeErrors$1.CLAIMS_EDIT, {
        message: 'There are claims issues for these charges',
        source: AmplifyErrorSources.STANDARD
    });
    const customRules = synthesizer(IssueTypeErrors$1.CUSTOM_RULES, {
        message: 'There are custom rule issues for these charges',
        source: AmplifyErrorSources.STANDARD
    });
    return [
        ...cci,
        ...claims,
        ...customRules
    ];
};
const parseAndFilterV2Errors = (errors)=>{
    var _Object_entries;
    if (!errors || errors.length === 0) {
        return [];
    }
    const v2Errors = errors === null || errors === void 0 ? void 0 : errors.filter((error)=>(error === null || error === void 0 ? void 0 : error.error_version) === '2');
    const v2ErrorsByCode = groupBy(v2Errors, (error)=>{
        if (typeof error === 'object' && 'code' in error) {
            return `{"caserun_uid": "${error === null || error === void 0 ? void 0 : error.caserun_uid}", "code": "${error === null || error === void 0 ? void 0 : error.code}", 
      "source":"${error === null || error === void 0 ? void 0 : error.source}","field":"${error === null || error === void 0 ? void 0 : error.field}","message_key":"${error === null || error === void 0 ? void 0 : error.message_key}"}`;
        }
        return '';
    });
    const restructuredErrors = (_Object_entries = Object.entries(v2ErrorsByCode)) === null || _Object_entries === void 0 ? void 0 : _Object_entries.map(([key, errors])=>{
        var _ref;
        let keyJSON = null;
        try {
            keyJSON = JSON.parse(key);
        } catch (unused) {
            return null;
        }
        let parsedError;
        const messageJSON = {
            [(_ref = keyJSON === null || keyJSON === void 0 ? void 0 : keyJSON.code) !== null && _ref !== void 0 ? _ref : '']: errors.map((error)=>{
                if (typeof error === 'object' && 'error_status' in error) {
                    parsedError = {
                        error_version: 'v1',
                        field: keyJSON === null || keyJSON === void 0 ? void 0 : keyJSON.field,
                        message_key: keyJSON === null || keyJSON === void 0 ? void 0 : keyJSON.message_key,
                        source: keyJSON === null || keyJSON === void 0 ? void 0 : keyJSON.source,
                        message: '',
                        formattedInUI: true
                    };
                    return {
                        status: error === null || error === void 0 ? void 0 : error.error_status,
                        message: error === null || error === void 0 ? void 0 : error.message
                    };
                }
            })
        };
        if (!parsedError) return null;
        parsedError.message = JSON.stringify(messageJSON);
        return parsedError;
    }).filter((e)=>e !== null);
    return restructuredErrors !== null && restructuredErrors !== void 0 ? restructuredErrors : [];
};

var vitalware = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertIssuesToCodeMap: convertIssuesToCodeMap,
  createSyntheticStandardErrors: createSyntheticStandardErrors,
  filterInvoiceIssues: filterInvoiceIssues,
  filterMergeHistoryWarnings: filterMergeHistoryWarnings,
  normalizeCCIS: normalizeCCIS,
  normalizeClaims: normalizeClaims,
  normalizeClaimsIssue: normalizeClaimsIssue,
  normalizeCustomRuleIssue: normalizeCustomRuleIssue,
  normalizeCustomRules: normalizeCustomRules,
  normalzeCCIIssue: normalzeCCIIssue,
  parseAndFilterV2Errors: parseAndFilterV2Errors,
  parseCodeEdits: parseCodeEdits,
  parseInvoiceIssues: parseInvoiceIssues,
  parseProcessInstance: parseProcessInstance,
  parseVWByStatus: parseVWByStatus,
  parseVWIssues: parseVWIssues
});

const EMPTY_NOTE = {
    description: '',
    content: '',
    filename: '',
    type: '',
    document_id: null,
    id: null,
    segments: [],
    spans: [],
    documentNotices: [],
    unique_document_number: ''
};

function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// ---------------------------------------
// Functions
// ---------------------------------------
/**
 * Comparitor function for span sorting.
 *
 * Almost all of the code for displaying highlighting relies on spans on a sorted list.  This function is left
 * exported so that it can be tested.
 *
 * @param spanA
 * @param spanB
 */ const buildSorter = ()=>{
    return (spanA, spanB)=>{
        const startsBefore = spanA.span.start < spanB.span.start;
        if (startsBefore) {
            return -1;
        }
        const startsAfter = spanA.span.start > spanB.span.start;
        if (startsAfter) {
            return 1;
        }
        // both spans start at the same point.  we don't need to do
        // any fancy addition here, we can just compare offsets.
        const endsBefore = spanA.span.end < spanB.span.end;
        if (endsBefore) {
            return -1;
        }
        const endsAfter = spanA.span.end > spanB.span.end;
        if (endsAfter) {
            return 1;
        }
        // a and b both start and end in the same block.
        return 0;
    };
};
const getActiveSpans = (spans, segment)=>{
    const tempSpans = [
        ...spans
    ];
    const activeSpans = [];
    let accumulating = true;
    while(accumulating){
        const activeSpan = tempSpans.shift();
        if (activeSpan === undefined) {
            accumulating = false;
        } else {
            var _ref;
            const start = (_ref = activeSpan === null || activeSpan === void 0 ? void 0 : activeSpan.span.start) !== null && _ref !== void 0 ? _ref : undefined;
            if (start === undefined || isNaN(start) || start < segment.start) ; else {
                // test to see if the span is still within the bounds
                // @ts-ignore
                const spanEnd = activeSpan.span.end;
                const segmentEnd = segment.end;
                if (spanEnd > segmentEnd) {
                    accumulating = false;
                } else {
                    activeSpans.push(activeSpan);
                }
            }
        }
    }
    return activeSpans;
};
/**
 * Determine if span2 is contained within span1.  Used to build nesting relationships.
 * @param span1
 * @param span2
 */ const isBoundBy = (span1, span2)=>{
    const span1End = span1.span.end;
    const startsWithin = span2.span.start >= span1.span.start && span2.span.start <= span1End;
    if (!startsWithin) return false;
    const span2End = span2.span.end;
    const endsWithin = span2End <= span1End;
    return endsWithin;
};
/**
 * Predicate function to determine if span2 overlaps span1.
 * @param span1
 * @param span2
 */ const isOverlap = (span1, span2)=>{
    const span1end = span1.span.end;
    // not contained within the span.
    if (span2.span.start >= span1end) {
        return false;
    }
    // test to see if the second span spills over the first.
    const span2end = span2.span.end;
    if (span2end > span1end) {
        return true;
    }
    // the span2 is contained within
    return false;
};
/**
 * Utility function to help make spans for normalizeOverlaps
 * @param span
 * @param mixin
 */ const buildOverlapFragment = (span, mixin)=>{
    return _object_spread_props$4(_object_spread$6({}, span), {
        span: _object_spread$6({}, span.span, mixin)
    });
};
/**
 * Spans may cross over each other.
 * Ex: The quick brown fox jumped over the lazy dog.
 * Span 1: The quick brown (icd)
 * Span 2: brown fox jumped (cpt)
 *
 * The following example would not reflect what we want to happen.
 * Ex: <span class="icd">the quick <span class="cpt">browm</span> fox jumped</span>
 * The first closing span tag would close the cpt class.
 *
 * This function will generate code like the following:
 * <span class="icd">the quick </span><span class="icd"><span class="cpt">browm</span></span><span class="cpt"> fox jumped</span>
 * @param origSpans
 */ const normalizeOverlaps = (origSpans)=>{
    let currentIndex = 0;
    let spans = [
        ...origSpans
    ];
    while(currentIndex < spans.length - 1){
        const activeSpan = spans[currentIndex];
        const nextSpan = spans[currentIndex + 1];
        const overlap = isOverlap(activeSpan, nextSpan);
        if (!overlap) {
            currentIndex++;
        } else {
            // detect the bounds of the overlap
            const overlapStart = nextSpan.span.start;
            const overlapEnd = activeSpan.span.end;
            // create 4 new spans to replace the two
            // * the first one will be the span before there's an overlap
            // * the second is the second half of the first span, ie. the overlapped content of the first span
            // * the third is the overlapped content of the second span
            // * finally, the unoverlapped content of the second span
            const preOverlap = buildOverlapFragment(activeSpan, {
                end: overlapStart
            });
            const overlap1 = buildOverlapFragment(activeSpan, {
                start: overlapStart,
                end: activeSpan.span.end
            });
            const overlap2 = buildOverlapFragment(nextSpan, {
                start: overlapStart,
                end: overlapEnd
            });
            const postOverlap = buildOverlapFragment(nextSpan, {
                start: overlapEnd,
                end: nextSpan.span.end
            });
            const min = Math.max(currentIndex, 0);
            const pre = spans.slice(0, min);
            const post = spans.slice(currentIndex + 2);
            spans = [
                ...pre,
                preOverlap,
                overlap1,
                overlap2,
                postOverlap,
                ...post
            ];
            currentIndex += 3;
        }
    }
    return spans;
};
/**
 * Utility function to determine
 * @param spans
 * @param segment
 */ const buildNest = (spans, segment)=>{
    const span = spans[0];
    const forwardSiblings = spans.slice(1);
    const start = span.span.start - segment.start;
    const end = span.span.end - segment.start;
    let nest = {
        hasChildren: false,
        start,
        end,
        children: [],
        parent: span
    };
    for(var j = 0; j < forwardSiblings.length; j++){
        const sibling = forwardSiblings[j];
        if (isBoundBy(span, sibling)) {
            nest.hasChildren = true;
            nest.children.push(sibling);
        } else {
            break;
        }
    }
    return nest;
};
/**
 * Predicate function to determine if a span starts in a segment
 * @param segment
 * @param span
 */ const startsIn = (segment, span)=>{
    const segmentEnd = segment.end;
    return segment.end > 0 && span.span.start >= segment.start && span.span.start < segmentEnd;
};
/**
 * Predicate function to tell if a span is beyond a segment.  Does not
 * consider whether the span is contained within the segment.
 * @param segment
 * @param span
 */ const exceedsSegment = (segment, span)=>{
    const spanEnd = span.span.end;
    const segmentEnd = segment.end;
    return spanEnd > segmentEnd;
};
/**
 * Predicate function to determine if a span is contained in and
 * exceeds a segment.
 * @param segment
 * @param span
 */ const crossesSegment = (segment, span)=>{
    const contains = startsIn(segment, span);
    return contains && exceedsSegment(segment, span);
};
/**
 * This function returns two spans, one that terminates within segment1 another that begins with segment 2
 * @param segment1
 * @param segment2
 * @param span
 */ const buildSegmentCrossingSpans = (segment1, segment2, span)=>{
    const segment1end = segment1.end;
    const span1 = _object_spread_props$4(_object_spread$6({}, span), {
        span: _object_spread_props$4(_object_spread$6({}, span.span), {
            end: segment1end
        })
    });
    const span2 = _object_spread_props$4(_object_spread$6({}, span), {
        span: _object_spread_props$4(_object_spread$6({}, span.span), {
            start: segment2.start,
            end: span.span.end
        })
    });
    return [
        span1,
        span2
    ];
};
/**
 * Inserts a span into the list at the first point where the segment no longer references spans.
 * @param origSpans - A list of spans
 * @param spanToInsert - A new span to insert into the list
 * @param externalIndex - A pointer to the current position in the span list to start consideration for insertion.
 */ const insertSpan = (origSpans, spanToInsert, externalIndex)=>{
    let currentIndex = externalIndex;
    let spans = [
        ...origSpans
    ];
    while(currentIndex < spans.length && spans[currentIndex].span.start <= spanToInsert.span.start){
        currentIndex++;
    }
    const pre = spans.slice(0, currentIndex);
    const post = spans.slice(currentIndex);
    spans = [
        ...pre,
        spanToInsert,
        ...post
    ];
    return spans;
};
/**
 * Spans may cross segment boundaries.  This function ensures that spans are contained within segment boudaries.
 * @param segments
 * @param origSpans
 */ const bindSpans = (segments, origSpans)=>{
    let spans = [
        ...origSpans
    ];
    let currentIndex = 0;
    for(var i = 0; i < segments.length; i++){
        const segment = segments[i];
        // the next segment may not be a content segment, meaning there's
        // no point in creating a span within it's bounds.
        let finding = true;
        let j = i;
        let nextSegment;
        while(finding){
            if (!segments[j + 1]) {
                finding = false;
            } else {
                nextSegment = segments[j + 1];
                if (nextSegment.end > 0) {
                    finding = false;
                }
                j++;
            }
        }
        if (nextSegment) {
            while(segment && currentIndex < spans.length && startsIn(segment, spans[currentIndex])){
                const crossesBoundary = crossesSegment(segment, spans[currentIndex]);
                if (crossesBoundary) {
                    const [currentSpan, spanToInsert] = buildSegmentCrossingSpans(segment, nextSegment, spans[currentIndex]);
                    // replace the current span
                    const pre = spans.slice(0, currentIndex);
                    const post = spans.slice(currentIndex + 1);
                    spans = [
                        ...pre,
                        currentSpan,
                        ...post
                    ];
                    // insert the new span at the front of the line for the next segment
                    spans = insertSpan(spans, spanToInsert, currentIndex);
                }
                currentIndex++;
            }
        }
    }
    return spans;
};
const isContent = (item)=>{
    return `content` in item;
};
const isNote = (item)=>{
    return `segments` in item;
};
const segmentizeText = (text)=>{
    const lines = `${text}`.split(/\n|\r/);
    let index = 0;
    return lines.map((line)=>{
        const segment = {
            start: index,
            end: index + line.length,
            text: line
        };
        index = index + line.length + 1;
        return segment;
    });
};
/**
 * Utility function to change a string or a content object that doesn't have
 * segments into a segment based content object.
 * @param text
 */ const segmentize = (text)=>{
    if (typeof text === 'string') {
        return segmentizeText(text);
    } else if (isNote(text)) {
        return text.segments;
    } else if (isContent(text)) {
        return segmentizeText(text.content);
    } else {
        const content = !text ? '' : text + '';
        return [
            {
                start: 0,
                end: content.length,
                text: content
            }
        ];
    }
};
const normalizeSpans = (segments, spans)=>{
    const boundedSpans = bindSpans(segments, spans);
    const normalized = normalizeOverlaps(boundedSpans);
    return normalized;
};

var _highlighterUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  bindSpans: bindSpans,
  buildNest: buildNest,
  buildSorter: buildSorter,
  getActiveSpans: getActiveSpans,
  normalizeSpans: normalizeSpans,
  segmentize: segmentize
});

function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
const MimeTypes = {
    HTML: 'text/html',
    TEXT: 'text/plain',
    PDF: 'application/pdf',
    RTF: 'application/rtf'
};
const DOCUMET_CONVERSION_MAP = {
    // if there's an RTF than we expect the HTML
    // this can be extended to other mime types in the future.
    [MimeTypes.RTF]: [
        MimeTypes.HTML
    ]
};
const docComparitor = (doc1, doc2)=>{
    if (doc1.id === doc2.id) {
        return 0;
    }
    if (doc1.id > doc2.id) {
        return 1;
    }
    return -1;
};
const fetchLatestDoc = (docs)=>{
    return [
        ...docs
    ].sort(docComparitor).pop();
};
/**
 * Gets the expected conversion target formats for documents in the given document groups.
 * Returns the first matching conversion target formats found, or an empty array if none found.
 * @param docGroups Dictionary of document metadata arrays grouped by some key
 * @returns Array of expected conversion target mime types
 */ const getExpectedConversionTargets = (docGroups)=>{
    for (const docs of Object.values(docGroups)){
        for (const doc of docs){
            const expectedFormats = DOCUMET_CONVERSION_MAP[doc.mimeType];
            if (expectedFormats) {
                return expectedFormats;
            }
        }
    }
    return [];
};
/**
 * A note may not be segmentized, but it still has content.  This function will build
 * segments from the content if not present.
 * @param testNote {CMxCommonApp.DecoratedNote}
 * @returns
 */ const shimSegmentsIfNeeded = (testNote)=>{
    const note = cloneDeep(testNote);
    if (testNote.filetype === MimeTypes.TEXT) {
        var _ref;
        var _note_segments, _note_content;
        const hasSegments = ((_ref = (_note_segments = note.segments) === null || _note_segments === void 0 ? void 0 : _note_segments.length) !== null && _ref !== void 0 ? _ref : 0) > 0;
        if (!hasSegments && ((_note_content = note.content) === null || _note_content === void 0 ? void 0 : _note_content.length) > 0) {
            note.segments = segmentize(note.content);
            if (note.missedConversion) {
                note.documentNotices.push({
                    message: "There was an error converting the documents to HTML. Instead we're showing you a plain text version.",
                    level: CaseAlertType.WARNING
                });
            }
        }
    }
    return note;
};
/**
 * Takes an object with any number of properties of a CMxCommonApp.DecoratedNote and returns
 * a fully formed CMxCommonApp.DecoratedNote. Centralizes the construction of a CommonApp datastructure.
 * @param decoratedNote
 * @returns {CMxCommonApp.DecoratedNote}
 */ const decoratedNoteFactory = (decoratedNote)=>{
    return _object_spread$5({}, cloneDeep(EMPTY_NOTE), decoratedNote);
};
/** Primary note first, then by note id descending — use for nav tabs + document column order. */ const compareDecoratedNotesForNav = (a, b)=>{
    if (a.primary === true) return -1;
    if (b.primary === true) return 1;
    return (Number(b.id) || 0) - (Number(a.id) || 0);
};
const firstAvailable = (groupBydDocs, mimeTypes)=>{
    const mimeKey = mimeTypes.find((mimeType)=>{
        return groupBydDocs[mimeType] && groupBydDocs[mimeType].length > 0;
    });
    if (mimeKey) {
        return fetchLatestDoc(groupBydDocs[mimeKey]);
    }
};

var documentUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MimeTypes: MimeTypes,
  compareDecoratedNotesForNav: compareDecoratedNotesForNav,
  decoratedNoteFactory: decoratedNoteFactory,
  docComparitor: docComparitor,
  firstAvailable: firstAvailable,
  getExpectedConversionTargets: getExpectedConversionTargets,
  shimSegmentsIfNeeded: shimSegmentsIfNeeded
});

/**
 * Safe access to build-time env vars injected by host apps (DefinePlugin) or Jest.
 * ui-common is pre-bundled for the browser — never use bare `process.env` in src.
 */ const getBuildEnv = ()=>{
    var _g_process;
    const g = globalThis;
    return (_g_process = g.process) === null || _g_process === void 0 ? void 0 : _g_process.env;
};
/** Read a build env var when the host app or test runner has injected `process.env`. */ const readBuildEnv = (key)=>{
    var _getBuildEnv;
    return (_getBuildEnv = getBuildEnv()) === null || _getBuildEnv === void 0 ? void 0 : _getBuildEnv[key];
};
/** Suppress logger output under Jest (matches prior `process.env.JEST_WORKER_ID` check). */ const isJestRuntime = ()=>{
    var _getBuildEnv;
    return Boolean((_getBuildEnv = getBuildEnv()) === null || _getBuildEnv === void 0 ? void 0 : _getBuildEnv.JEST_WORKER_ID);
};

const sequences = {};
const sequenceGenerator = {
    max: (identifier)=>{
        if (!(identifier in sequences)) {
            return -1;
        }
        return sequences[identifier];
    },
    next: (identifier)=>{
        if (!(identifier in sequences)) {
            sequences[identifier] = 0;
        } else {
            sequences[identifier]++;
        }
        return sequences[identifier];
    }
};

const { AmplifyUIActions, CMxApplication } = commonActions;
const showConfirm = createAction(AmplifyUIActions.SHOW_CONFIRM);
const dismissConfirm = createAction(AmplifyUIActions.DISMISS_CONFIRM);
const handleConfirm = createAction(AmplifyUIActions.HANDLE_CONFIRM);
const amplifyFeedback = createAction(AmplifyUIActions.AMPLIFY_FEEDBACK);
const hideFeedback = createAction(AmplifyUIActions.HIDE_FEEDBACK);
const resetCommonState = createAction(StateReset.RESET_COMMON, ()=>({
        payload: undefined,
        meta: {
            broadcast: true
        }
    }));
const awaitingResources = createAction(CMxApplication.AWAITING_RESOURCES);
const setStandaloneMode = createAction(AmplifyUIActions.SET_STANDALONE_MODE);
const setAmplifyView = createAction(AmplifyUIActions.SET_AMPLIFY_VIEW);
const setAutomateView = createAction(AmplifyUIActions.SET_AUTOMATE_VIEW);
/**
 * Action creator for saving user's active service line to capability state
 * @param serviceLineName - The name of the service line to save
 */ const saveServiceLineCapability = createAction(AmplifyUIActions.SAVE_SERVICE_LINE_CAPABILITY);
const ANALYTICS_ACTION_METADATA = Object.freeze({
    analytics: true
});
const chooseContext = createAction(CMxApplication.CHOOSE_CONTEXT, (payload)=>({
        payload,
        meta: ANALYTICS_ACTION_METADATA
    }));

var uiActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ANALYTICS_ACTION_METADATA: ANALYTICS_ACTION_METADATA,
  amplifyFeedback: amplifyFeedback,
  awaitingResources: awaitingResources,
  chooseContext: chooseContext,
  dismissConfirm: dismissConfirm,
  handleConfirm: handleConfirm,
  hideFeedback: hideFeedback,
  resetCommonState: resetCommonState,
  saveServiceLineCapability: saveServiceLineCapability,
  setAmplifyView: setAmplifyView,
  setAutomateView: setAutomateView,
  setStandaloneMode: setStandaloneMode,
  showConfirm: showConfirm
});

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const DATA_ACCESS_SERVICES_LOCATION = '/dataaccess/read/v1';
const REQUEST_INIT_OPTIONS$1 = {
    method: 'POST'
};
const getDataAccessPatientTimelinewithFilter = async ({ caseRun, limit, page, timelineInfiniteLoad, messageTypeFilter, dateFilter, endDateFilter, ui })=>{
    const queryURL = DATA_ACCESS_SERVICES_LOCATION;
    const filterFieldsMap = {
        mrn: caseRun.patient_identifier.number,
        limit
    };
    if (capabilityValue(timelineInfiniteLoad)) {
        filterFieldsMap.offset = limit * page - limit;
        if (!isEmpty(messageTypeFilter)) {
            var _ref;
            const filterData = {
                and: [
                    {
                        message_type: (_ref = messageTypeFilter === null || messageTypeFilter === void 0 ? void 0 : messageTypeFilter.map((item)=>item === null || item === void 0 ? void 0 : item.value)) !== null && _ref !== void 0 ? _ref : []
                    }
                ]
            };
            set$2(filterFieldsMap, 'filter', filterData);
        }
        if (!!dateFilter && !isEmpty(dateFilter)) {
            var _filterFieldsMap_filter;
            const andArray = (filterFieldsMap === null || filterFieldsMap === void 0 ? void 0 : (_filterFieldsMap_filter = filterFieldsMap.filter) === null || _filterFieldsMap_filter === void 0 ? void 0 : _filterFieldsMap_filter.and) || []; // Use default empty array if bodyObject.filter.and is undefined
            let maxParam = {};
            if (!!endDateFilter && !isEmpty(endDateFilter)) {
                maxParam = {
                    max: endDateFilter
                };
            }
            const filterData = {
                and: [
                    ...andArray,
                    {
                        bedside_datetime: _object_spread$4({
                            min: dateFilter
                        }, maxParam)
                    }
                ]
            };
            set$2(filterFieldsMap, 'filter', filterData);
        }
    }
    const patienttimelineRequestObject = buildPatienttimelineDataAccessRequest(ui, 'getPatientTimeline', 'patienttimeline');
    patienttimelineRequestObject.filterFieldsMap = filterFieldsMap;
    try {
        const response = await api.requestJSON(queryURL, _object_spread_props$3(_object_spread$4({}, REQUEST_INIT_OPTIONS$1), {
            body: JSON.stringify(patienttimelineRequestObject)
        }));
        return response;
    } catch (error) {
        throw error;
    }
};
const getDataAccessPatientTimelineCaseWithoutFilter = async ({ caseRun, limit, page, timelineInfiniteLoad, ui })=>{
    const queryURL = DATA_ACCESS_SERVICES_LOCATION;
    const filterFieldsMap = {
        mrn: caseRun.patient_identifier.number,
        limit
    };
    if (capabilityValue(timelineInfiniteLoad)) {
        filterFieldsMap.offset = limit * page - limit;
    }
    const patienttimelineRequestObject = buildPatienttimelineDataAccessRequest(ui, 'getPatientTimeline', 'patienttimeline');
    patienttimelineRequestObject.filterFieldsMap = filterFieldsMap;
    try {
        const response = await api.requestJSON(queryURL, _object_spread_props$3(_object_spread$4({}, REQUEST_INIT_OPTIONS$1), {
            body: JSON.stringify(patienttimelineRequestObject)
        }));
        return response;
    } catch (error) {
        throw error;
    }
};
const getDataAccessPatientMessageCountwithFilter = async (timelineCountParams)=>{
    const { caseRun, dateFilter, endDateFilter, ui } = timelineCountParams;
    const queryURL = DATA_ACCESS_SERVICES_LOCATION;
    let filterFieldsMap = {
        patient_mrn: caseRun.patient_identifier.number
    };
    if (!!dateFilter) {
        filterFieldsMap = _object_spread_props$3(_object_spread$4({}, filterFieldsMap), {
            start_date: dateFilter
        });
    }
    if (!!endDateFilter) {
        filterFieldsMap = _object_spread_props$3(_object_spread$4({}, filterFieldsMap), {
            end_date: endDateFilter
        });
    }
    const patienttimelineRequestObject = buildPatienttimelineDataAccessRequest(ui, 'getPatientMessageCount', 'patientmessagecount');
    patienttimelineRequestObject.filterFieldsMap = filterFieldsMap;
    try {
        const response = await api.requestJSON(queryURL, _object_spread_props$3(_object_spread$4({}, REQUEST_INIT_OPTIONS$1), {
            body: JSON.stringify(patienttimelineRequestObject)
        }));
        return response;
    } catch (error) {
        throw error;
    }
};
const getDataAccessPatientMessageCountWithoutFilter = async (timelineCountParams)=>{
    const { caseRun, ui } = timelineCountParams;
    const queryURL = DATA_ACCESS_SERVICES_LOCATION;
    let filterFieldsMap = {
        patient_mrn: caseRun.patient_identifier.number
    };
    const patienttimelineRequestObject = buildPatienttimelineDataAccessRequest(ui, 'getPatientMessageCount', 'patientmessagecount');
    patienttimelineRequestObject.filterFieldsMap = filterFieldsMap;
    try {
        const response = await api.requestJSON(queryURL, _object_spread_props$3(_object_spread$4({}, REQUEST_INIT_OPTIONS$1), {
            body: JSON.stringify(patienttimelineRequestObject)
        }));
        return response;
    } catch (error) {
        throw error;
    }
};

const CaseStatusDisplayName = {
    Automated: 'Automated',
    Dormant: 'Dormant',
    CAC: 'Manual',
    Done: 'Automated',
    'Case Created': 'In Progress',
    'In Process': 'In Progress',
    'Data Collected': 'In Progress',
    Cancelled: 'Cancelled',
    'Did not code': 'Cancelled',
    Updated_Manual: 'Updated to Manual ',
    CLOSED_NON_CHARGEABLE: 'Closed Non-chargeable'
};
const ProcessStatusDisplayName = {
    'Process Created': 'In Progress (Building Case)',
    'Waiting for data': 'In Progress (Building Case)',
    'Data Collected': 'In Progress (Case Built)',
    'Prediction in Progress': 'In Progress (Predicting)',
    Predicted: 'In Progress (Manual)',
    'At Coder': 'Waiting for Coder',
    Done: '',
    Error: 'Requires attention'
};
const DescriptionDisplayValues = {
    Automated: `Sent to billing`,
    CAC: 'Sent to CAC',
    AboveThreshhold: 'Prediction above confidence threshhold',
    BelowThreshhold: 'Prediction lower than confidence threshhold',
    Cancelled: 'Requires attention',
    'Did not code': 'Requires attention',
    Updated_Manual: 'Due to Addendum',
    CLOSED_NON_CHARGEABLE: 'Closed Non-chargeable'
};
const ReasonDictionary = {
    'Happy Path Prediction': 'Prediction High Confidence',
    'Happy Path Rule': 'Rule High Confidence',
    'Sched Department not in Dictionary': 'Scheduling Department not Valid for Processing'
};

var _caseStatusStrings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CaseStatusDisplayName: CaseStatusDisplayName,
  DescriptionDisplayValues: DescriptionDisplayValues,
  ProcessStatusDisplayName: ProcessStatusDisplayName,
  ReasonDictionary: ReasonDictionary
});

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const UIStatus = uiStatus;
const getCaseRuns = (detail, runType)=>{
    const caseRuns = (detail === null || detail === void 0 ? void 0 : detail.caseRuns) || [];
    if (!caseRuns.length) {
        throw new Error('no case runs available');
    }
    const filteredCaseRuns = caseRuns.filter((run)=>run.run_type === runType);
    return filteredCaseRuns;
};
const getCaseRun = (detail, activeProcessId = -1)=>{
    const caseRuns = (detail === null || detail === void 0 ? void 0 : detail.caseRuns) || [];
    if (!caseRuns.length) {
        throw new Error('no case runs available');
    }
    if (activeProcessId === -1) {
        const primaryRun = caseRuns.find((run)=>run.primary_process_indicator);
        return primaryRun || detail.caseRuns[0];
    }
    const activeCaseRun = caseRuns.find((run)=>run.process_instance_id === activeProcessId);
    return activeCaseRun || detail.caseRuns[0];
};
const deriveStatus = (caseRun)=>{
    let caseStatus;
    let automationIndicator = false;
    if (!caseRun) {
        caseStatus = UIStatus.DORMANT;
    } else {
        caseStatus = caseRun.case_status;
        automationIndicator = caseRun.automated_indicator;
    }
    const status = {
        automated: automationIndicator,
        inProcess: false,
        sentToCac: false,
        sentToBill: false
    };
    const { process_status } = caseRun;
    const statusReadout = {
        description: 'Unspecified',
        signifier: 'Unspecified',
        styleClass: '',
        processStatus: process_status,
        status
    };
    // ---------------- in progress --------------------- //
    if (caseStatus === UIStatus.IN_PROGRESS) {
        if (process_status === `At Coder`) {
            statusReadout.description = `Waiting For Coder`;
            statusReadout.signifier = UIStatus.WAITING;
            statusReadout.styleClass = 'case-status-waiting';
        } else {
            statusReadout.description = `In Progress`;
            statusReadout.signifier = UIStatus.IN_PROGRESS;
            statusReadout.styleClass = 'case-status-in-progress';
        }
        status.inProcess = true;
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // Everything else is not in progress.  Which means that it's either cancelled, complete, or in error.
    // ---------------- cancelled --------------------- //
    if (caseStatus === UIStatus.CANCELLED) {
        statusReadout.signifier = CaseStatusDisplayName.Cancelled;
        statusReadout.description = DescriptionDisplayValues.Cancelled;
        statusReadout.styleClass = 'case-status-cancelled';
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    if (caseStatus === UIStatus.CLOSED_NON_CHARGEABLE) {
        statusReadout.signifier = CaseStatusDisplayName.CLOSED_NON_CHARGEABLE;
        statusReadout.description = DescriptionDisplayValues.CLOSED_NON_CHARGEABLE;
        statusReadout.styleClass = 'case-status-cancelled';
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // ---------------- completed --------------------- //
    if (caseStatus === UIStatus.DORMANT) {
        statusReadout.signifier = CaseStatusDisplayName.Dormant;
        statusReadout.description = CaseStatusDisplayName.Dormant;
        statusReadout.styleClass = 'case-status-historical-above';
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // CAC
    if (caseStatus === UIStatus.MANUAL) {
        statusReadout.signifier = CaseStatusDisplayName.CAC;
        statusReadout.description = DescriptionDisplayValues.CAC;
        statusReadout.styleClass = 'case-status-cac';
        status.sentToCac = true;
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // Updated to Manual (CAC)
    if (caseStatus === UIStatus.UPDATED_MANUAL) {
        statusReadout.signifier = CaseStatusDisplayName.Updated_Manual;
        statusReadout.description = DescriptionDisplayValues.Updated_Manual;
        statusReadout.styleClass = 'case-status-updated-to-manual';
        status.sentToCac = true;
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // Sent to Billing
    if (caseStatus === UIStatus.AUTOMATED) {
        statusReadout.signifier = CaseStatusDisplayName.Automated;
        statusReadout.description = DescriptionDisplayValues.Automated;
        statusReadout.styleClass = 'case-status-sent-to-bill';
        status.sentToBill = true;
        return _object_spread_props$2(_object_spread$3({}, statusReadout), {
            status
        });
    }
    // ---------------- Fall through  --------------------- //
    return _object_spread_props$2(_object_spread$3({}, statusReadout), {
        status
    });
};
const terminalStatus = new Set([
    uiStatus.CANCELLED,
    uiStatus.AUTOMATED,
    uiStatus.MANUAL
]);
const isFinishedCase = (caseRun)=>{
    if (caseRun === undefined) {
        return false;
    }
    return terminalStatus.has(caseRun.case_status);
};
const isPreGoLive = (caseRun)=>{
    var _caseRun_phase;
    if (caseRun === undefined) {
        return false;
    }
    const phaseName = ((_caseRun_phase = caseRun.phase) !== null && _caseRun_phase !== void 0 ? _caseRun_phase : '').toLowerCase();
    return phaseName !== CustomerPhase.LIVE.toLowerCase() && phaseName !== CustomerPhase.PRODUCTION.toLowerCase();
};
const getStatusReason = (caseRun)=>{
    if (caseRun === undefined) {
        return false;
    }
    // if something isn't in a terminal state, then it doesn't make
    // sense to look for a reason we made a decision on something.
    if (!isFinishedCase(caseRun)) {
        return caseRun.process_status;
    }
    if (caseRun.case_status === UIStatus.MANUAL) {
        // vitalware reasons short circuit the rest of reason processing.
        const failedEdits = caseRun.claims_edit_indicator === false;
        if (failedEdits) {
            return 'Due to Claim Edits';
        }
        if (caseRun.cci_edit_indicator === false) {
            return 'Due to CCI Edits';
        }
    }
    // if there's a post-prediction reason so that should be given primacy over
    // a pre-prediction.  This will need to be expanded
    const reason = caseRun.post_prediction_process_reason || caseRun.pre_prediction_process_reason;
    if (reason === null || caseRun.rules === null) {
        return false;
    }
    let rules;
    try {
        rules = JSON.parse(caseRun.rules);
    } catch (e) {
        // TORES: PBC
        // need to validate if we want to do anything more sophisticated here.
        return reason;
    }
    const [category, subCategory] = reason.split(':');
    if (!rules[category]) {
        return reason;
    }
    const activeDecisions = rules[category];
    if (!activeDecisions || activeDecisions.length === 0) {
        return reason;
    }
    const reasons = activeDecisions.filter((decision)=>decision.decoration_subcategory === subCategory || decision.decoration_subcategory.indexOf(subCategory) !== -1).map((decision)=>ReasonDictionary[decision.decoration_description] || decision.decoration_description);
    const finalReason = reasons.length ? reasons.join(', ') : reason;
    return `${finalReason}`;
};
const excludeActiveCaseRun = (activeCase, billingGroup)=>{
    const allRuns = billingGroup.map(getCaseRun);
    return allRuns.filter((caseRun)=>{
        return caseRun.process_instance_id.toString() !== activeCase.process_instance_id.toString();
    });
};
const getGroupedCases = (activeCase, groupedCases, groupType)=>{
    return {
        groupType,
        caseRuns: excludeActiveCaseRun(activeCase, groupedCases)
    };
};
const getCaseLink = (case_uid, case_run_uid, service_line)=>{
    return !!case_uid && !!case_run_uid && !!service_line ? `${service_line}/case/${case_uid}/case-run/${case_run_uid}/` : '';
};
const getChildWindowParams = (case_uid, case_run_uid, service_line, windowOpenArgs, case_id)=>{
    // For Pathology cases that don't have case_uid, use case_id
    let effectiveCaseId = case_uid;
    if (!case_uid && case_id && (service_line === null || service_line === void 0 ? void 0 : service_line.toUpperCase()) === 'PATHOLOGY') {
        effectiveCaseId = String(case_id);
    }
    if (effectiveCaseId && case_run_uid) {
        const params = {
            launchpoint: 'Amplify',
            windowNameExtension: `${effectiveCaseId}_${case_run_uid}`,
            managed: 'false'
        };
        const caseLink = getCaseLink(effectiveCaseId, case_run_uid, service_line);
        const base = _object_spread_props$2(_object_spread$3({}, windowOpenArgs), {
            url: `${windowOpenArgs.url}${caseLink}`
        });
        return _object_spread_props$2(_object_spread$3({}, base), {
            params
        });
    }
    return null;
};
const getCodeTypeShortName = (codeType)=>{
    if (!codeType) return;
    const codeTypeMap = {
        [CodeType.CPT.toUpperCase()]: CodeSearchType.CPT,
        [CodeType.PROCEDURE.toUpperCase()]: CodeSearchType.CPT,
        [CodeType.MODIFIER.toUpperCase()]: CodeSearchType.MODIFIER,
        [CodeType.DIAGNOSIS.toUpperCase()]: CodeSearchType.ICD,
        [CodeType.ICD.toUpperCase()]: CodeSearchType.ICD
    };
    return codeTypeMap[codeType.toUpperCase()];
};
const getCodeTypeFullname = (codeType)=>{
    if (!codeType) return;
    const codeTypeMap = {
        [CodeType.CPT.toUpperCase()]: ChargeSessionCodeType.PROCEDURE,
        [CodeType.PROCEDURE.toUpperCase()]: ChargeSessionCodeType.PROCEDURE,
        [CodeType.MODIFIER.toUpperCase()]: ChargeSessionCodeType.MODIFIER,
        [CodeType.DIAGNOSIS.toUpperCase()]: ChargeSessionCodeType.DIAGNOSIS,
        [CodeType.ICD.toUpperCase()]: ChargeSessionCodeType.DIAGNOSIS
    };
    return codeTypeMap[codeType === null || codeType === void 0 ? void 0 : codeType.toUpperCase()];
};

var _caseUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deriveStatus: deriveStatus,
  getCaseLink: getCaseLink,
  getCaseRun: getCaseRun,
  getCaseRuns: getCaseRuns,
  getChildWindowParams: getChildWindowParams,
  getCodeTypeFullname: getCodeTypeFullname,
  getCodeTypeShortName: getCodeTypeShortName,
  getGroupedCases: getGroupedCases,
  getStatusReason: getStatusReason,
  isFinishedCase: isFinishedCase,
  isPreGoLive: isPreGoLive
});

const convertToFilterRecord = (categoryKey, categoryName, optionsKeyColumn, optionNameColumn, filterData, isSelected = false, displayOrder, hasNullableOption = true)=>{
    let convertedData = [];
    const uniqueEntries = new Set();
    filterData === null || filterData === void 0 ? void 0 : filterData.forEach((row)=>{
        var _row_optionsKeyColumn, _row_optionNameColumn;
        if (!row || typeof row !== 'object' || !row.hasOwnProperty(optionsKeyColumn) || !row.hasOwnProperty(optionNameColumn) || !!!(row === null || row === void 0 ? void 0 : row[optionsKeyColumn]) && !!!(row === null || row === void 0 ? void 0 : row[optionNameColumn])) return;
        const key = (_row_optionsKeyColumn = row[optionsKeyColumn]) !== null && _row_optionsKeyColumn !== void 0 ? _row_optionsKeyColumn : '';
        const name = (_row_optionNameColumn = row[optionNameColumn]) !== null && _row_optionNameColumn !== void 0 ? _row_optionNameColumn : '';
        const entryString = `${key}_${name}`;
        if (!uniqueEntries.has(entryString)) {
            convertedData.push({
                categoryKey: categoryKey !== null && categoryKey !== void 0 ? categoryKey : '',
                categoryName: categoryName !== null && categoryName !== void 0 ? categoryName : '',
                key,
                name,
                defaultSelection: isSelected ? 'INCLUDE' : 'EXCLUDE'
            });
            uniqueEntries.add(entryString);
        }
    });
    if (hasNullableOption) {
        convertedData.splice(0, 0, {
            key: 'noneKey',
            name: 'None',
            categoryKey: categoryKey !== null && categoryKey !== void 0 ? categoryKey : '',
            categoryName: categoryName !== null && categoryName !== void 0 ? categoryName : '',
            defaultSelection: 'INCLUDE'
        });
    }
    return {
        filterOptions: convertedData,
        type: categoryKey,
        label: categoryName,
        displayOrder: displayOrder || 1
    };
};
const getFilterDateTerms = (options, key)=>{
    let date = options === null || options === void 0 ? void 0 : options[key];
    return date ? format(date, FORMATS.DATE) : '';
};
const getFilterTerms = (options)=>{
    return Object.entries(options !== null && options !== void 0 ? options : {}).filter(([key, value])=>!!key && value).map(([key])=>key);
};
const updateNoneKeyValue = (includeTerms)=>{
    if (includeTerms.includes('noneKey')) {
        includeTerms.splice(includeTerms.indexOf('noneKey'), 1);
        includeTerms.push('');
    }
    return includeTerms;
};
const getRelatedCasesInitialFilters = (filterRawData, startDate, endDate)=>{
    var _filterRawData_noteType, _filterRawData_patientClass, _filterRawData_noteSpecialty;
    let noteTypeOptions = {};
    filterRawData === null || filterRawData === void 0 ? void 0 : (_filterRawData_noteType = filterRawData['noteType']) === null || _filterRawData_noteType === void 0 ? void 0 : _filterRawData_noteType.forEach((entry)=>{
        if (!!entry && entry.hasOwnProperty('Note Description') && !!(entry === null || entry === void 0 ? void 0 : entry['Note Description'])) {
            noteTypeOptions[entry === null || entry === void 0 ? void 0 : entry['Note Description']] = entry.hasOwnProperty('Filter Default') ? (entry === null || entry === void 0 ? void 0 : entry['Filter Default']) === DictionaryFilterDefault.INCLUDE ? true : false : true;
        }
    });
    noteTypeOptions['noneKey'] = true;
    let patientClassOptions = {};
    filterRawData === null || filterRawData === void 0 ? void 0 : (_filterRawData_patientClass = filterRawData['patientClass']) === null || _filterRawData_patientClass === void 0 ? void 0 : _filterRawData_patientClass.forEach((entry)=>{
        if (!!entry && entry.hasOwnProperty('Patient Class') && !!(entry === null || entry === void 0 ? void 0 : entry['Patient Class'])) {
            patientClassOptions[entry === null || entry === void 0 ? void 0 : entry['Patient Class']] = true;
        }
    });
    patientClassOptions['noneKey'] = true;
    let noteSpecialtyOptions = {};
    filterRawData === null || filterRawData === void 0 ? void 0 : (_filterRawData_noteSpecialty = filterRawData['noteSpecialty']) === null || _filterRawData_noteSpecialty === void 0 ? void 0 : _filterRawData_noteSpecialty.forEach((entry)=>{
        if (!!entry && entry.hasOwnProperty('Note Specialty') && !!(entry === null || entry === void 0 ? void 0 : entry['Note Specialty'])) {
            noteSpecialtyOptions[entry === null || entry === void 0 ? void 0 : entry['Note Specialty']] = true;
        }
    });
    noteSpecialtyOptions['noneKey'] = true;
    return {
        'Note Type': noteTypeOptions,
        'Patient Class': patientClassOptions,
        Specialty: noteSpecialtyOptions,
        date_range: {
            startDate,
            endDate
        }
    };
};
const getRelatedCasesFilterRequest = (encounterId, filterSelection)=>{
    var _ref, _ref1, _ref2, _ref3, _ref4;
    const includeNoteTypes = getFilterTerms((_ref = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection['Note Type']) !== null && _ref !== void 0 ? _ref : {});
    const hasNoneKeyNoteType = includeNoteTypes.includes('noneKey');
    const includePatientClasses = getFilterTerms((_ref1 = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection['Patient Class']) !== null && _ref1 !== void 0 ? _ref1 : {});
    const hasNoneKeyPatientClass = includePatientClasses.includes('noneKey');
    const includeSpecialties = getFilterTerms((_ref2 = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection['Specialty']) !== null && _ref2 !== void 0 ? _ref2 : {});
    const hasNoneKeySpecialty = includeSpecialties.includes('noneKey');
    const includeEndDateRange = getFilterDateTerms((_ref3 = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection['date_range']) !== null && _ref3 !== void 0 ? _ref3 : {}, 'endDate');
    const includeStartDateRange = getFilterDateTerms((_ref4 = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection['date_range']) !== null && _ref4 !== void 0 ? _ref4 : {}, 'startDate');
    const filterClauses = [
        {
            key: 'description',
            terms: updateNoneKeyValue(includeNoteTypes),
            type: 'EQ'
        },
        {
            key: 'patient_class',
            terms: updateNoneKeyValue(includePatientClasses),
            type: 'IN'
        },
        {
            key: 'notes_specialty',
            terms: updateNoneKeyValue(includeSpecialties),
            type: 'IN'
        },
        {
            key: 'hospital_account_record',
            terms: [
                encounterId
            ],
            type: 'EQ'
        },
        {
            key: 'date_of_service',
            terms: includeEndDateRange ? [
                includeEndDateRange
            ] : [],
            type: 'LESS_THAN_EQUAL'
        },
        {
            key: 'date_of_service',
            terms: includeStartDateRange ? [
                includeStartDateRange
            ] : [],
            type: 'GREATER_THAN_EQUAL'
        },
        ...hasNoneKeyNoteType ? [
            {
                key: 'description',
                terms: [],
                type: 'IS_NULL'
            }
        ] : [],
        ...hasNoneKeyPatientClass ? [
            {
                key: 'patient_class',
                terms: [],
                type: 'IS_NULL'
            }
        ] : [],
        ...hasNoneKeySpecialty ? [
            {
                key: 'notes_specialty',
                terms: [],
                type: 'IS_NULL'
            }
        ] : []
    ].filter(({ type, terms })=>type === 'IS_NULL' || !isEmpty(terms)).map(({ key, terms, type })=>({
            key,
            terms,
            type
        }));
    return filterClauses;
};

/**
 * Worklist-only: after submit/cancel, the app may auto-advance via loadNextOrPreviousCase → getPrevOrNextCase.
 * Cases → Amplify must not satisfy this (CDMX-15442).
 */ function shouldAutoAdvanceWorklistAfterSubmit(cursorAPIPayload) {
    var _ctx_worklistContext;
    const ctx = cursorAPIPayload === null || cursorAPIPayload === void 0 ? void 0 : cursorAPIPayload.cursorAPIContext;
    if (ctx == null) {
        return false;
    }
    if (ctx.servicedeskMode !== true) {
        return false;
    }
    if (!ctx.workitemId) {
        return false;
    }
    const query = (_ctx_worklistContext = ctx.worklistContext) === null || _ctx_worklistContext === void 0 ? void 0 : _ctx_worklistContext.query;
    if (query == null || typeof query !== 'object') {
        return false;
    }
    return true;
}

const PreCodableStatus$1 = new Set([
    AccelerateProcessStatus.WAITING_FOR_IMPORT,
    AccelerateProcessStatus.IMPORTING,
    AccelerateProcessStatus.RETRY_IMPORT
]);
const CodableStatus$1 = new Set([
    AccelerateProcessStatus.NEW,
    AccelerateProcessStatus.IN_PROGRESS
]);
const CancelledStatus$1 = new Set([
    AccelerateProcessStatus.CANCELLED,
    AccelerateProcessStatus.WAITING_FOR_SEND,
    AccelerateProcessStatus.SENT
]);
const PostCodableStatus$1 = new Set([
    AccelerateProcessStatus.WAITING_FOR_SEND,
    AccelerateProcessStatus.SENDING,
    AccelerateProcessStatus.SENT,
    AccelerateProcessStatus.RETRY_SEND,
    AccelerateProcessStatus.SUBMITTED,
    AccelerateProcessStatus.LATE_CASE_UPDATE
]);
const NonCodableStatus = new Set([
    AccelerateProcessStatus.LATE_CASE_UPDATE,
    AccelerateProcessStatus.REPLACED
]);

var AmplifyProcessStates = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CancelledStatus: CancelledStatus$1,
  CodableStatus: CodableStatus$1,
  NonCodableStatus: NonCodableStatus,
  PostCodableStatus: PostCodableStatus$1,
  PreCodableStatus: PreCodableStatus$1
});

const defaultSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
const submissionSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.SUBMITTED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
const omitProcessed = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
const inProgressDefaultSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.ASSEMBLED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
const completeSet = new Set([
    CaseArtifactTypes.MAPPED,
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.PREDICTION,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.SUBMITTED,
    CaseArtifactTypes.ASSEMBLED,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.REMITTANCE,
    CaseArtifactTypes.REFERRAL,
    CaseArtifactTypes.CODED
]);

var artifactSets = /*#__PURE__*/Object.freeze({
  __proto__: null,
  completeSet: completeSet,
  defaultSet: defaultSet,
  inProgressDefaultSet: inProgressDefaultSet,
  omitProcessed: omitProcessed,
  submissionSet: submissionSet
});

const LOAD_STATES = {
    initial: {
        loading: true,
        error: false,
        initial: true
    },
    started: {
        loading: true,
        error: false,
        initial: false
    },
    done: {
        loading: false,
        error: false,
        initial: false
    },
    failed: {
        loading: false,
        error: true,
        initial: false
    }
};

var _loadStates = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOAD_STATES: LOAD_STATES
});

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
const STUB_ORG_CONTEXT = {
    organizationId: 0,
    organizationName: '',
    organizationCode: '',
    organizationType: '',
    tenantId: '',
    parentLevel: 1,
    healthSystemTenantId: '',
    healthSystemCode: '',
    healthSystemName: '',
    displayName: '',
    cognitoEnabled: false,
    resources: [],
    serviceLines: []
};
const cursorAPIContext = {
    worklistContext: {},
    servicedeskMode: false,
    workitemId: '',
    sessionId: '',
    qaCollectionUuid: '',
    launchConfigServiceLine: ''
};
const formErrors = {
    status: '',
    message: null,
    errors: [],
    fieldErrors: {}
};
const groupedCases = {
    groupType: 'none',
    caseRuns: []
};
const holdCase$1 = {
    hold_reason: '',
    comment: '',
    coding_manager_id: ''
};
const DEFAULT_BENCH_EDITABLE = {
    editable: false,
    waiting: false,
    submitted: false,
    cancelled: false,
    reason: ''
};
const DEFAULT_SUGGESTED_CODES = {
    cpt: {
        encounterList: [],
        caseList: [],
        codeSourceList: []
    },
    modifier: {
        encounterList: [],
        caseList: [],
        codeSourceList: []
    },
    icd: {
        encounterList: [],
        caseList: [],
        codeSourceList: []
    }
};
const codeBenchState = {
    capabilities: {
        userContext: _object_spread$2({}, STUB_ORG_CONTEXT),
        roles: [],
        holdCaseStatus: {
            hold_reason: '',
            comment: '',
            coding_manager_id: ''
        },
        capabilities: {},
        cursorAPIContext,
        parentCaserunUid: null,
        parentCase: false,
        activeItem: {},
        submitInProgress: false,
        activeServiceLineName: '',
        excludeCasePermissionsConfig: null
    },
    displayCancellation: false,
    organization: null,
    prompt: null,
    activations: {
        panel: {},
        property: {},
        spans: {}
    },
    propertyConfig: {
        patient: [],
        summary: [],
        expanded: []
    },
    dynamicPropertyConfig: null,
    fallbackPropertyConfig: null,
    modalURL: null,
    activeItem: {},
    //@ts-ignore
    processInstance: null,
    codeDescriptions: {},
    codeEdits: {},
    counts: {
        procedures: 0,
        diagnosis: 0,
        modifiers: 0
    },
    hostCaseId: null,
    chargeSessions: [],
    preCommitChargeSessions: [],
    groupedCases,
    cases: [],
    activity: [],
    codableInvoices: null,
    nonCodeBench: false,
    userContext: null,
    benchEditable: _object_spread$2({}, DEFAULT_BENCH_EDITABLE),
    loadState: LOAD_STATES.initial,
    processInstanceLoadState: LOAD_STATES.initial,
    artifactLoadState: LOAD_STATES.initial,
    billingGroupLoadState: LOAD_STATES.done,
    relatedCasesLoadState: LOAD_STATES.done,
    refreshList: true,
    formErrors,
    artifactSet: defaultSet,
    artifactShowAll: false,
    searchResults: {},
    codeSearchResultsV2: {},
    invoiceOptions: {
        invoices: [],
        required_fields: [],
        summary: {
            departments: {},
            fee_schedules: {},
            all_departments: [],
            existing_departments: []
        }
    },
    notes: [],
    artifactList: [],
    stages: [],
    displayTimeline: false,
    roles: [],
    caseRuns: {},
    displayAddCharge: false,
    showAddChargeError: false,
    showAddChargeLoading: false,
    showFeedBack: false,
    feedback: {
        id: null,
        message: '',
        dismissable: true
    },
    showSubmittedFeedback: false,
    showLoadingSubmission: false,
    showLoadingCancelation: false,
    showCanceledFeedback: false,
    submittedFeedbackTimer: false,
    showSizeExpWarning: false,
    showvitalwareIssuesModal: false,
    hidevitalwareIssuesModal: false,
    caseEdits: {},
    toggleHoldCaseModal: false,
    toggleCaseCommentModal: false,
    toggleExclusionCaseModal: false,
    showLateCaseClearModal: false,
    toggleSplitCaseModal: false,
    submitOldCaseModal: false,
    vitalwareIssues: [],
    mergeSplitHistoryIssues: [],
    documentImprovementIssues: [],
    holdIssues: [],
    holdCaseStatus: _object_spread$2({}, holdCase$1),
    cursorAPIContext: {
        worklistContext: {},
        servicedeskMode: false,
        workitemId: '',
        sessionId: '',
        qaCollectionUuid: '',
        launchConfigServiceLine: ''
    },
    entries: [],
    relatedCases: [],
    relatedCasesPageable: _object_spread$2({}, relatedCasesSortablePageable),
    noteTypes: [],
    providerRoleTypeConfig: [],
    customClaimsRelatedCasesLoadState: LOAD_STATES.done,
    customClaimsRelatedCases: [],
    flagList: [],
    activeNote: {},
    caseAccessTime: '',
    lockCaseUid: '',
    activeMiniTab: MiniTabLabels.CHARGES_LABEL,
    activeVerticalMiniTab: MiniTabLabels.NOTES_LABEL,
    showUnresolvedDocuments: false,
    showSideNavBar: true,
    benchMode: BenchMode.CODE,
    caseVersions: [],
    suggestedCodes: _object_spread$2({}, DEFAULT_SUGGESTED_CODES),
    submitInProgress: false,
    sourceInvoices: {
        sourceInvoices: [],
        sourceInvoicesLoadState: LOAD_STATES.initial
    },
    //TODO : All props to CaseDetail are implicitly added to BenchApplicationState CDMX-2542 even though they are state elsewhere such as AMP-UI
    filterData: [],
    relatedCasesFilterSelection: {},
    caseAccessState: CaseAccessState.NONE
};

const { PermissionLevel } = commonEnums;
const isResourceViewOnly = (resources, resourceName)=>{
    var _resources_find;
    return ((_resources_find = resources.find((resources)=>resources.resourceName === resourceName)) === null || _resources_find === void 0 ? void 0 : _resources_find.permissionLevel) === PermissionLevel.READ_ONLY;
};
const isResourceFullAccess = (resources, resourceName)=>{
    var _resources_find;
    return ((_resources_find = resources.find((resources)=>resources.resourceName === resourceName)) === null || _resources_find === void 0 ? void 0 : _resources_find.permissionLevel) === PermissionLevel.FULL_ACCESS;
};

var resources = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isResourceFullAccess: isResourceFullAccess,
  isResourceViewOnly: isResourceViewOnly
});

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { ProcessStatusLabel, HoldReasonType, HoldReasonLabel } = commonEnums$1;
const { CodableStatus, PostCodableStatus, PreCodableStatus, CancelledStatus } = AmplifyProcessStates;
const determineQaEditable = (status, qaStatus, roles)=>{
    const codableQARoles = new Set([
        'coordinator',
        'professional_services',
        'coding_manager'
    ]);
    const hasCodableQaRole = roles.some((role)=>codableQARoles.has(role));
    const isCaseInQAandCodable = qaStatus === ProcessQAStatus.IN_QA && status === AccelerateProcessStatus.SUBMITTED && hasCodableQaRole;
    return isCaseInQAandCodable;
};
const determineBenchEditable = (processInstance, userContext, roles, parentCaserunUid, submitInProgress = false, canEditCase = true)=>{
    var _ref;
    const benchEditable = _object_spread$1({}, DEFAULT_BENCH_EDITABLE);
    // Early return if processInstance is null/undefined to prevent errors
    if (!processInstance) {
        return _object_spread_props$1(_object_spread$1({}, benchEditable), {
            editable: false,
            waiting: false,
            submitted: false,
            cancelled: false
        });
    }
    const isCaseInQAandCodable = determineQaEditable(processInstance === null || processInstance === void 0 ? void 0 : processInstance.status, processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus, roles);
    /**If case is child case then not editable*/ const isChildCase = !!parentCaserunUid;
    const showHoldSubmissionTimer = isWithinHoldSubmissionWindow(processInstance);
    benchEditable.editable = !submitInProgress && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && !processInstance.cancelled && ((processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus) === ProcessQAStatus.IN_QA ? isCaseInQAandCodable : CodableStatus$1.has(processInstance.status) || showHoldSubmissionTimer) && isResourceFullAccess((_ref = userContext === null || userContext === void 0 ? void 0 : userContext.resources) !== null && _ref !== void 0 ? _ref : [], ResourceId.CODE_CASE) && !isChildCase && processInstance.status !== AccelerateProcessStatus.REMOVED && canEditCase;
    benchEditable.waiting = PreCodableStatus$1.has(processInstance.status);
    benchEditable.submitted = !processInstance.cancelled && PostCodableStatus$1.has(processInstance.status);
    benchEditable.cancelled = processInstance.cancelled && CancelledStatus$1.has(processInstance.status);
    return benchEditable;
};
const getImprovements = (processInstance, benchEditable)=>{
    const reasons = [];
    /** Previously available only for IPC, currently enabling it for all servicelines */ const defaults = {
        value: true,
        reasons: reasons
    };
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const isWithinHoldSubmissionWindow = (processInstance)=>{
    if (!(processInstance === null || processInstance === void 0 ? void 0 : processInstance.holdSubmissionDate)) return false;
    const timeDuration = calculateDurationDateFns(format(new Date(), FORMATS.DATE_TIME_WITH_ZONE), processInstance === null || processInstance === void 0 ? void 0 : processInstance.holdSubmissionDate);
    const seconds = ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.hours) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.hours : 0) * 60 + ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.minutes) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.minutes : 0) * 60 + ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.seconds) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.seconds : 0);
    return !!(processInstance === null || processInstance === void 0 ? void 0 : processInstance.holdSubmission) && seconds > 0;
};
const getImprovementsAction = (processInstance, benchEditable)=>{
    const reasons = [];
    const isDelayedSubmission = isWithinHoldSubmissionWindow(processInstance);
    const defaults = {
        value: benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && (!benchEditable.submitted || benchEditable.submitted && (processInstance.qaStatus === ProcessQAStatus.IN_QA || isDelayedSubmission)) && !benchEditable.cancelled,
        reasons: reasons
    };
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getRenderSubmitCase = (processInstance, benchEditable)=>{
    const reasons = [];
    const displayFlag = benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable);
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const submitCase = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return submitCase;
};
const getActionMenuCancelCapability = (processInstance, benchEditable, actionMenu, roles, resources)=>{
    const isCaseInQAandCodable = determineQaEditable(processInstance === null || processInstance === void 0 ? void 0 : processInstance.status, processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus, roles);
    const serviceLine = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) ? ServiceLines.BEDSIDE_PRO : processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine;
    const hasVoidPermission = isResourceAllowed({
        resources
    }, ResourceId.VOID_CASE, serviceLine);
    const reasons = [];
    const displayFlag = capabilityValue(actionMenu.on) && benchEditable.editable && !isCaseInQAandCodable && hasVoidPermission && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable);
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const cancelCase = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return cancelCase;
};
const getRenderPagination = (processInstance, benchEditable)=>{
    const caseType = processInstance === null || processInstance === void 0 ? void 0 : processInstance.caseType;
    const reasons = [];
    const displayFlag = caseType === UIModesEnum.PLAYGROUND && !benchEditable.editable;
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const pagination = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return pagination;
};
const getRenderviewOnlyCase = (benchEditable)=>{
    const reasons = [];
    const displayFlag = !benchEditable.editable;
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const viewOnlyCase = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return viewOnlyCase;
};
const getRenderHoldCase = (processInstance, holdCase, benchEditable)=>{
    const reasons = [];
    const isOffHold = holdCase.hold_reason === HoldReasonType.OFF_HOLD;
    const isCaseNotOnHold = holdCase.hold_reason === '' || holdCase.hold_reason === null;
    const displayFlag = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.caseType) === UIModesEnum.STANDALONE && (isOffHold || isCaseNotOnHold) && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus) !== ProcessQAStatus.IN_QA;
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getRenderMergeableCase = (processInstance, benchEditable)=>{
    const reasons = [];
    const displayFlag = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.caseType) === UIModesEnum.STANDALONE;
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getRenderOffHoldCase = (processInstance, holdCase, benchEditable)=>{
    const reasons = [];
    const caseHoldStatus = new Set([
        HoldReasonType.HOLD,
        HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY,
        HoldReasonType.HOLD_FOR_MANAGER_REVIEW
    ]);
    const displayFlag = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.caseType) === UIModesEnum.STANDALONE && caseHoldStatus.has(holdCase.hold_reason);
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getToggleCaseComment = (removeHoldCase, caseCommentMode)=>{
    const reasons = [];
    let displayFlag = capabilityValue(removeHoldCase.on) && caseCommentMode;
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
/** service line check */ const isIPCOrSurgery = (processInstance)=>{
    const isIPC$1 = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine);
    const isSurgery$1 = isSurgery(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine);
    return isIPC$1 || isSurgery$1;
};
/**
 * Check if user has permission to show exclude case based on their roles
 * @param userRoles - Array of user's role names
 * @param config - Configuration object with role permissions
 * @returns true if user has at least one role with showExcludeCase permission
 */ const canShowExcludeCase = (userRoles, config)=>{
    if (!userRoles || userRoles.length === 0) {
        return false;
    }
    if (!config || !config.availableRoles || !Array.isArray(config.availableRoles)) {
        return false;
    }
    // Check if user has any role that allows showing exclude case
    return userRoles.some((userRole)=>{
        const roleConfig = config.availableRoles.find((r)=>r.role_name === userRole);
        return (roleConfig === null || roleConfig === void 0 ? void 0 : roleConfig.showExcludeCase) === true;
    });
};
const getRenderToggleChargeableCase = (processInstance, benchEditable, userRoles, excludeCasePermissionsConfig)=>{
    const reasons = [];
    // If no config is available, don't show exclude case option
    if (!excludeCasePermissionsConfig) {
        console.warn('[getRenderToggleChargeableCase] No config available - hiding exclude case option');
        return {
            on: {
                value: false,
                reasons: [
                    CapabilityAvailabilityReason.CONFIGURATION
                ]
            },
            actionable: {
                value: false,
                reasons: [
                    CapabilityAvailabilityReason.CONFIGURATION
                ]
            }
        };
    }
    // Check if user has permission based on their roles
    const hasShowExcludeCasePermission = canShowExcludeCase(userRoles, excludeCasePermissionsConfig);
    const displayFlag = hasShowExcludeCasePermission && (benchEditable.editable || !(processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable)) && !NonCodableStatus.has(processInstance.status);
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getActionMenuCapability = (holdCase, removedCaseHold, toggleChargeableCase, splitCapability, lateCaseClearNotification, processInstance)=>{
    const displayFlag = (capabilityValue(holdCase.on) || capabilityValue(removedCaseHold.on) || capabilityValue(toggleChargeableCase.on) || capabilityValue(splitCapability.on) || capabilityValue(lateCaseClearNotification.on)) && processInstance.status !== AccelerateProcessStatus.REMOVED;
    const reasons = [];
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getGeneralCancelCapability = (actionMenu, cancelCase, benchEditable, resources, activeServiceLineName)=>{
    const serviceLine = isIPC(activeServiceLineName) ? ServiceLines.BEDSIDE_PRO : activeServiceLineName;
    const hasVoidPermission = isResourceAllowed({
        resources
    }, ResourceId.VOID_CASE, serviceLine);
    const displayFlag = !capabilityValue(actionMenu.on) && !capabilityValue(cancelCase.on) && hasVoidPermission && benchEditable.editable && !benchEditable.cancelled;
    const reasons = [];
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    if (!displayFlag) {
        reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getCaseEditable = (processInstance, benchEditable)=>{
    const isIPC$1 = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine);
    const isSurgery$1 = isSurgery(processInstance.serviceLine);
    const reasons = [];
    const isEditable = (isIPC$1 || isSurgery$1) && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.caseType) !== UIModesEnum.EPIC_EMBEDDED && benchEditable.editable;
    const defaults = {
        value: isEditable,
        reasons: reasons
    };
    if (isEditable) {
        defaults.reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    const caseEdit = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return caseEdit;
};
const getOldCaseLoadedAlert = (caseVersions, processInstance)=>{
    var _ref;
    const currentVersionPosition = (_ref = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex((caseVersion)=>{
        var _processInstance_guid;
        return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_guid = processInstance.guid) === null || _processInstance_guid === void 0 ? void 0 : _processInstance_guid.uuid);
    })) !== null && _ref !== void 0 ? _ref : -1;
    const currentVersionObject = currentVersionPosition !== -1 ? caseVersions[currentVersionPosition] : null;
    const displayFlag = (currentVersionObject === null || currentVersionObject === void 0 ? void 0 : currentVersionObject.processInstanceStatus) === AccelerateProcessStatus.REPLACED;
    const reasons = [];
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getPreviousSentCaseAlert = (caseVersions, processInstance)=>{
    var _ref;
    const currentVersionPosition = (_ref = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex((caseVersion)=>{
        var _processInstance_guid;
        return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_guid = processInstance.guid) === null || _processInstance_guid === void 0 ? void 0 : _processInstance_guid.uuid);
    })) !== null && _ref !== void 0 ? _ref : -1;
    const previousVersions = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.filter((_, index)=>index < currentVersionPosition);
    const displayFlag = previousVersions === null || previousVersions === void 0 ? void 0 : previousVersions.some((previousVersion)=>previousVersion.processInstanceStatus === AccelerateProcessStatus.SUBMITTED || previousVersion.processInstanceStatus === AccelerateProcessStatus.CANCELLED || previousVersion.processInstanceStatus === AccelerateProcessStatus.SENT);
    const reasons = [];
    const defaults = {
        value: displayFlag,
        reasons: reasons
    };
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
/**
 * Worklist "Next" / cursor navigation only. Other code-bench capabilities (case actions,
 * submit, menus, etc.) do not use this flag — Cases vs Worklist should match there.
 */ const getServicedeskActions = (processInstance, cursorAPIContext)=>{
    var _cursorAPIContext_worklistContext;
    const reasons = [];
    const hasWorklistQuery = ((_cursorAPIContext_worklistContext = cursorAPIContext.worklistContext) === null || _cursorAPIContext_worklistContext === void 0 ? void 0 : _cursorAPIContext_worklistContext.query) != null && typeof cursorAPIContext.worklistContext.query === 'object';
    const value = cursorAPIContext.servicedeskMode === true && hasWorklistQuery;
    const defaults = {
        value,
        reasons: reasons
    };
    if (!cursorAPIContext.servicedeskMode || !hasWorklistQuery) {
        defaults.reasons.push(CapabilityAvailabilityReason.CONFIGURATION);
    }
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const getNoteUnavailableReason = (activeItem)=>{
    const reasons = [];
    const defaults = {
        value: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.note_unavailable_reason) ? true : false,
        reasons: reasons
    };
    const capability = {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
    return capability;
};
const determineProcessStatus = (processStatusProps, isCaseInAmplify, parentCaserunUid)=>{
    var _processStatusProps_roles, _ref;
    let processStatus;
    const isCaseInQAandCodable = determineQaEditable(processStatusProps.processInstanceStatus, processStatusProps.qaStatus, (_processStatusProps_roles = processStatusProps.roles) !== null && _processStatusProps_roles !== void 0 ? _processStatusProps_roles : []);
    const benchEditable = (_ref = processStatusProps === null || processStatusProps === void 0 ? void 0 : processStatusProps.benchEditable) !== null && _ref !== void 0 ? _ref : determineBenchEditable({
        status: processStatusProps.processInstanceStatus,
        qaStatus: processStatusProps.qaStatus,
        isChargeable: processStatusProps.isChargeable,
        cancelled: processStatusProps.cancelled
    }, processStatusProps.userContext, processStatusProps.roles, parentCaserunUid, false);
    if (!isCaseInAmplify) {
        processStatus = ProcessStatusLabel.AUTOMATE;
    } else if (!processStatusProps.isChargeable) {
        processStatus = ProcessStatusLabel.NON_CHARGEABLE;
    } else if (CancelledStatus.has(processStatusProps.processInstanceStatus) && benchEditable.cancelled || processStatusProps.processInstanceStatus === AccelerateProcessStatus.REMOVED) {
        processStatus = ProcessStatusLabel.VOIDED;
    } else if (isCaseInQAandCodable) {
        processStatus = ProcessStatusLabel.IN_QA;
    } else if (PostCodableStatus.has(processStatusProps.processInstanceStatus) && benchEditable.submitted) {
        processStatus = ProcessStatusLabel.SUBMITTED;
    } else if (processStatusProps.holdReason && processStatusProps.holdReason !== HoldReasonType.OFF_HOLD) {
        var _HoldReasonLabel_processStatusProps_holdReason;
        processStatus = (_HoldReasonLabel_processStatusProps_holdReason = HoldReasonLabel[processStatusProps.holdReason]) !== null && _HoldReasonLabel_processStatusProps_holdReason !== void 0 ? _HoldReasonLabel_processStatusProps_holdReason : HoldReasonLabel.HOLD;
    } else if (PreCodableStatus.has(processStatusProps.processInstanceStatus)) {
        processStatus = ProcessStatusLabel.IMPORTING;
    } else if (CodableStatus.has(processStatusProps.processInstanceStatus)) {
        processStatus = ProcessStatusLabel.READY_FOR_CODING;
        if ((processStatusProps === null || processStatusProps === void 0 ? void 0 : processStatusProps.holdReason) === HoldReasonType.OFF_HOLD) {
            processStatus = processStatus + ': ' + HoldReasonLabel.OFF_HOLD;
        }
    }
    return processStatus;
};
const fecthProcessStatusClasses = (processStatus, holdReason)=>{
    let styles = [
        'process-status-' + (processStatus === null || processStatus === void 0 ? void 0 : processStatus.toLowerCase().replace(/documentation|query|manager|review|:|off hold/g, '').trim().replace(/ /g, '-'))
    ];
    if (processStatus !== undefined) {
        styles.push('chip');
        styles.push('label');
        styles.push('process-status');
    }
    return styles;
};
const getMergeActionMenuCapability = (benchEditable, userContext, parentCase, activeItem, activeServiceLineName)=>{
    const reasons = [];
    const serviceLine = isIPC(activeServiceLineName) ? ServiceLines.BEDSIDE_PRO : activeServiceLineName;
    const hasMergeResource = isResourceAllowed(userContext, ResourceId.MERGE_CASE, serviceLine);
    const showMergeOption = hasMergeResource && (benchEditable === null || benchEditable === void 0 ? void 0 : benchEditable.editable) && !benchEditable.submitted && !parentCase && !!(activeItem === null || activeItem === void 0 ? void 0 : activeItem.merge_key);
    const defaults = {
        value: showMergeOption,
        reasons: reasons
    };
    if (!showMergeOption) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getSplitActionMenuCapability = (benchEditable, userContext, parentCase, activeServiceLineName)=>{
    const reasons = [];
    const serviceLine = isIPC(activeServiceLineName) ? ServiceLines.BEDSIDE_PRO : activeServiceLineName;
    const hasMergeResource = isResourceAllowed(userContext, ResourceId.MERGE_CASE, serviceLine);
    const showSplitOption = hasMergeResource && (benchEditable === null || benchEditable === void 0 ? void 0 : benchEditable.editable) && !benchEditable.submitted && !!parentCase;
    const defaults = {
        value: showSplitOption,
        reasons: reasons
    };
    if (!showSplitOption) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getCoderFeedbackCapability = (benchEditable, processInstance, userContext)=>{
    const reasons = [];
    const serviceLine = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) ? ServiceLines.BEDSIDE_PRO : processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine;
    const hasCoderFeedbackResource = isResourceAllowed(userContext, ResourceId.CODER_FEEDBACK, serviceLine);
    const showCoderFeedbackOption = hasCoderFeedbackResource && (benchEditable === null || benchEditable === void 0 ? void 0 : benchEditable.editable) && processInstance.qaStatus === ProcessQAStatus.IN_QA;
    const defaults = {
        value: showCoderFeedbackOption,
        reasons: reasons
    };
    if (!showCoderFeedbackOption) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getAttachDocsCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.ATTACH_DOCS, activeServiceLineName);
};
// mapping all IPC SL names to BEDSIDE_PRO
const updateServiceLinesIPC = (serviceLines)=>serviceLines.map((serviceLine)=>isIPC(serviceLine) ? ServiceLines.BEDSIDE_PRO : serviceLine);
const getCreateCaseCapability = (userContext, processInstance)=>{
    const reasons = [];
    const serviceLine = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) ? ServiceLines.BEDSIDE_PRO : processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine;
    const hasCreateCaseResource = isResourceAllowed(userContext, ResourceId.CREATE_CASE, serviceLine);
    const showCreateCaseOption = hasCreateCaseResource && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable);
    const defaults = {
        value: showCreateCaseOption,
        reasons: reasons
    };
    if (!hasCreateCaseResource) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getTimelineInfiniteLoadCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.TIMELINE_INFINITE_LOAD, activeServiceLineName);
};
const getProductivityTrackerCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.PRODUCTIVITY_TRACKER, activeServiceLineName);
};
const getDiagnosisCodeSuggestionCapability = (userContext, processInstance, benchEditable)=>{
    const reasons = [];
    const serviceLine = isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) ? ServiceLines.BEDSIDE_PRO : processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine;
    const hasDiagnosisCodeSuggestion = isResourceAllowed(userContext, ResourceId.DIAGNOSIS_CODE_SUGGESTION, serviceLine);
    const showDiagnosisCodeSuggestion = isCaseEditAllowed(processInstance, benchEditable) && hasDiagnosisCodeSuggestion;
    const defaults = {
        value: showDiagnosisCodeSuggestion,
        reasons: reasons
    };
    if (!hasDiagnosisCodeSuggestion) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const isCaseEditAllowed = (processInstance, benchEditable)=>{
    return benchEditable.editable && (processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable) && (!benchEditable.submitted || benchEditable.submitted && processInstance.qaStatus === ProcessQAStatus.IN_QA) && !benchEditable.cancelled;
};
const getCoderNotesCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.CODER_NOTES, activeServiceLineName);
};
const getTransactionV2Capability = (userContext, activeServiceLineName)=>{
    const reasons = [];
    const serviceLine = isIPC(activeServiceLineName) ? ServiceLines.BEDSIDE_PRO : activeServiceLineName;
    const hasTransactionV2 = isResourceAllowed(userContext, ResourceId.TRANSACTION_V2, serviceLine);
    const hasAmplifyV2 = isResourceAllowed(userContext, ResourceId.AMPLIFY_CASE_RUN_V2, serviceLine);
    const showTransactionV2 = hasTransactionV2 && hasAmplifyV2;
    const defaults = {
        value: showTransactionV2,
        reasons: reasons
    };
    if (!hasTransactionV2) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getCodeSourcesFeaturesCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.MULTI_CODESET_FEATURE, activeServiceLineName);
};
/**
 * To fetch capability to load case details with refresh as true
 * When this capability is enabled an extra API call is made with refresh as true
 * This eventually fetches latest data from XC
 * @param userContext
 * @returns
 */ const getGetCaserunWithRefreshCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.GET_CASERUN_WITH_REFRESH, activeServiceLineName);
};
const getAmplifyCaseRunV2Capability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.AMPLIFY_CASE_RUN_V2, activeServiceLineName);
};
const getLateCaseClearNotificationCapability = (processInstance)=>{
    const isLateCaseUpdate = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.status) === AccelerateProcessStatus.LATE_CASE_UPDATE;
    const defaults = {
        value: isLateCaseUpdate,
        reasons: []
    };
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
const getActionBarSelectMultipleWorkitemsCapability = (roles)=>{
    const on = roles.includes('cqa_manager') ? true : false;
    return {
        on: {
            value: on,
            reasons: []
        },
        actionable: {
            value: on,
            reasons: []
        }
    };
};
const getViewScoreDetailCapability = (roles)=>{
    const on = roles.includes('cqa_manager');
    return {
        on: {
            value: on,
            reasons: []
        },
        actionable: {
            value: on,
            reasons: []
        }
    };
};
/**
 * Verifies if a resource is allowed for a specific service line
 * Incudes BSP IPC service line check
 * Includes * check for all service lines
 * @param resource - The resource to verify
 * @param activeServiceLineName - The active service line name to check against
 * @returns True if the resource is allowed for the service line, false otherwise
 */ const verifyServiceLine = (resource, activeServiceLineName)=>{
    var _resource_serviceLines;
    const selectedServiceLine = normalizeServiceLineName(activeServiceLineName !== null && activeServiceLineName !== void 0 ? activeServiceLineName : '');
    const isBSPactive = isIPC(selectedServiceLine);
    if (!!!resource || isEmpty(activeServiceLineName)) {
        return false;
    }
    return resource === null || resource === void 0 ? void 0 : (_resource_serviceLines = resource.serviceLines) === null || _resource_serviceLines === void 0 ? void 0 : _resource_serviceLines.some((serviceLine)=>normalizeServiceLineName(serviceLine) === selectedServiceLine || serviceLine === '*' || isBSPactive && isIPC(serviceLine));
};
/**
 * Checks if a resource is allowed for a specific service line in the given context
 * @param activeContext - The organization context containing resources
 * @param resourceName - The name of the resource to check
 * @param activeServiceLineName - The active service line name to check against
 * @returns True if the resource is allowed for the service line, false otherwise
 */ const isResourceAllowed = (activeContext, resourceName, activeServiceLineName)=>{
    var _ref;
    var _activeContext_resources;
    if (!!!resourceName) {
        return false;
    }
    // check if resource exists in context
    const [chosenResource] = (_ref = activeContext === null || activeContext === void 0 ? void 0 : (_activeContext_resources = activeContext.resources) === null || _activeContext_resources === void 0 ? void 0 : _activeContext_resources.filter((resource)=>resource.resourceName.toLowerCase() === resourceName.toLowerCase())) !== null && _ref !== void 0 ? _ref : [];
    // no, chosen resource found, always return false
    if (!chosenResource) {
        return false;
    }
    if (activeServiceLineName === '*') {
        return true;
    }
    return verifyServiceLine(chosenResource, activeServiceLineName);
};
/**
 * Determines capability availability for a resource based on service line permissions
 * @param activeContext - The organization context containing resources
 * @param resourceName - The name of the resource to check
 * @param activeServiceLineName - The active service line name to check against
 * @returns An object containing capability status with reasons for availability
 */ const determineCapabilityByResource = (activeContext, resourceName, activeServiceLineName)=>{
    const reasons = [];
    const resourcePermitted = isResourceAllowed(activeContext, resourceName, activeServiceLineName);
    const defaults = {
        value: resourcePermitted,
        reasons: reasons
    };
    if (!resourcePermitted) {
        reasons.push(CapabilityAvailabilityReason.PRODUCT_EXCLUDED);
    }
    return {
        on: _object_spread$1({}, defaults),
        actionable: _object_spread$1({}, defaults)
    };
};
/**
 * Determines if provider directory location check is required
 * @param userContext - The organization context containing resources
 * @param activeServiceLineName - The active service line name to check against
 * @returns An object containing capability status with reasons for availability
 */ const getUseProviderDirectoryLocations = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.USE_PROVIDER_DIRECTORY_LOCATIONS, activeServiceLineName);
};
const getRelatedCasesFilterCapability = (userContext, activeServiceLineName)=>{
    return determineCapabilityByResource(userContext, ResourceId.SHOW_RELATED_CASE_FILTER, activeServiceLineName);
};

var benchEditable = /*#__PURE__*/Object.freeze({
  __proto__: null,
  determineBenchEditable: determineBenchEditable,
  determineCapabilityByResource: determineCapabilityByResource,
  determineProcessStatus: determineProcessStatus,
  determineQaEditable: determineQaEditable,
  fecthProcessStatusClasses: fecthProcessStatusClasses,
  getActionBarSelectMultipleWorkitemsCapability: getActionBarSelectMultipleWorkitemsCapability,
  getActionMenuCancelCapability: getActionMenuCancelCapability,
  getActionMenuCapability: getActionMenuCapability,
  getAmplifyCaseRunV2Capability: getAmplifyCaseRunV2Capability,
  getAttachDocsCapability: getAttachDocsCapability,
  getCaseEditable: getCaseEditable,
  getCodeSourcesFeaturesCapability: getCodeSourcesFeaturesCapability,
  getCoderFeedbackCapability: getCoderFeedbackCapability,
  getCoderNotesCapability: getCoderNotesCapability,
  getCreateCaseCapability: getCreateCaseCapability,
  getDiagnosisCodeSuggestionCapability: getDiagnosisCodeSuggestionCapability,
  getGeneralCancelCapability: getGeneralCancelCapability,
  getGetCaserunWithRefreshCapability: getGetCaserunWithRefreshCapability,
  getImprovements: getImprovements,
  getImprovementsAction: getImprovementsAction,
  getLateCaseClearNotificationCapability: getLateCaseClearNotificationCapability,
  getMergeActionMenuCapability: getMergeActionMenuCapability,
  getNoteUnavailableReason: getNoteUnavailableReason,
  getOldCaseLoadedAlert: getOldCaseLoadedAlert,
  getPreviousSentCaseAlert: getPreviousSentCaseAlert,
  getProductivityTrackerCapability: getProductivityTrackerCapability,
  getRelatedCasesFilterCapability: getRelatedCasesFilterCapability,
  getRenderHoldCase: getRenderHoldCase,
  getRenderMergeableCase: getRenderMergeableCase,
  getRenderOffHoldCase: getRenderOffHoldCase,
  getRenderPagination: getRenderPagination,
  getRenderSubmitCase: getRenderSubmitCase,
  getRenderToggleChargeableCase: getRenderToggleChargeableCase,
  getRenderviewOnlyCase: getRenderviewOnlyCase,
  getServicedeskActions: getServicedeskActions,
  getSplitActionMenuCapability: getSplitActionMenuCapability,
  getTimelineInfiniteLoadCapability: getTimelineInfiniteLoadCapability,
  getToggleCaseComment: getToggleCaseComment,
  getTransactionV2Capability: getTransactionV2Capability,
  getUseProviderDirectoryLocations: getUseProviderDirectoryLocations,
  getViewScoreDetailCapability: getViewScoreDetailCapability,
  isCaseEditAllowed: isCaseEditAllowed,
  isIPCOrSurgery: isIPCOrSurgery,
  isResourceAllowed: isResourceAllowed,
  updateServiceLinesIPC: updateServiceLinesIPC,
  verifyServiceLine: verifyServiceLine
});

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { Bench, InvoiceMetadata, Launch, UserInterface } = commonActions;
const { ProcessInstanceActions, InvoiceTypes, IssueTypeErrors } = commonEnums$1;
const clearSearchResults = createAction(Bench.CLEAR_SEARCH);
const caseOrganization = createAction(InvoiceMetadata.ORGANIZATION_AVAILABLE);
const codeDescriptionsAvailable = createAction(Launch.CODE_DESCRIPTIONS);
const REQUEST_INIT_OPTIONS = {
    method: 'GET',
    cache: 'no-cache',
    redirect: 'follow',
    referrer: 'no-referrer'
};
const setUnresolvedDocuments = createAction(Bench.SET_UNRESOLVED_DOCUMENTS);
const setActiveMiniTab = createAction(Bench.SET_ACTIVE_MINI_TAB);
const setActiveVerticalMiniTab = createAction(Bench.SET_ACTIVE_VERTICAL_MINI_TAB);
const popupNavigate = createAction(Bench.POPUP_NAVIGATE);
const promptClose = createAction(Bench.PROMPT_CLOSE);
const popupClose = createAction(Bench.POPUP_CLOSE);
const optimisticCodeChange = createAction(Bench.OPTIMISTIC_CHANGE);
const optimisticProTechChange = createAction(Bench.OPTIMISTIC_PRO_TECH_CHANGE);
const featureSelection = createAction(Bench.FEATURE_SELECTION);
const fetchExcludeCasePermissionsConfig = createAsyncThunk('FETCH_EXCLUDE_CASE_PERMISSIONS_CONFIG', async ({ tenantId, serviceLine })=>{
    try {
        var _configObj_values;
        const response = await fetch(`/configuration/detail/exclude-case-permissions/${tenantId}/v2?merge=true&serviceLine=${serviceLine}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
            }
        });
        if (!response.ok) {
            console.warn(`[fetchExcludeCasePermissionsConfig] HTTP error ${response.status}`);
            return {};
        }
        const responseData = await response.json();
        if (!Array.isArray(responseData) || responseData.length === 0) {
            return {};
        }
        const configObj = responseData[0];
        const mergedValueObj = (_configObj_values = configObj.values) === null || _configObj_values === void 0 ? void 0 : _configObj_values.find((v)=>v.value === 'MERGED');
        return (mergedValueObj === null || mergedValueObj === void 0 ? void 0 : mergedValueObj.jsonValue) || {};
    } catch (error) {
        console.error('[fetchExcludeCasePermissionsConfig] Error:', error);
        return {};
    }
});
const cancelInvoicesPopup = createAction(Bench.CANCEL_INVOICES_POPUP);
const openAddChargeModal = createAction(Bench.OPEN_ADD_CHARGE_MODAL);
const closeAddChargeModal = createAction(Bench.CLOSE_ADD_CHARGE_MODAL);
const showAddChargeLoading = createAction(Bench.ADD_TRANSACTION_LOADING);
const toggleSubmitOldCaseModal = createAction(Bench.TOGGLE_SUBMIT_OLD_CASE_MODAL);
const showSideNavBar = createAction(Bench.SHOW_SIDE_NAV_BAR);
const hideSideNavBar = createAction(Bench.HIDE_SIDE_NAV_BAR);
const showSubmittedFeedback = createAction(Bench.SHOW_SUBMITTED_FEEDBACK);
const showLoadingSubmission = createAction(Bench.SHOW_LOADING_SUBMISSION);
const showLoadingCancelation = createAction(Bench.SHOW_LOADING_CANCELATION);
const hideLoadingSubmission = createAction(Bench.HIDE_LOADING_SUBMISSION);
const hideSubmittedFeedback = createAction(Bench.HIDE_SUBMITTED_FEEDBACK);
const showCanceledFeedback = createAction(Bench.SHOW_CANCELED_MODAL);
const showSizeExpWarning = createAction(Bench.SHOW_SIZE_EXP_WARNING);
const showvitalwareIssuesModal = createAction(Bench.SHOW_CLAIMS_ISSUES_MODAL);
const hidevitalwareIssuesModal = createAction(Bench.HIDE_CLAIMS_ISSUES_MODAL);
const setvitalwareIssues = createAction(Bench.SET_CLAIMS_ISSUES);
const hideSizeExpWarning = createAction(Bench.HIDE_SIZE_EXP_WARNING);
const deleteSizeExpWarning = createAction(Bench.DELETE_SIZE_EXP_WARNING);
const showHoldCaseModal = createAction(Bench.SHOW_HOLD_CASE_MODAL);
const hideHoldCaseModal = createAction(Bench.HIDE_HOLD_CASE_MODAL);
const showCaseCommentModal = createAction(Bench.SHOW_CASE_COMMENT_MODAL);
const hideCaseCommentModal = createAction(Bench.HIDE_CASE_COMMENT_MODAL);
const showExclusionCaseModal = createAction(Bench.SHOW_EXCLUSION_CASE_MODAL);
const hideExclusionCaseModal = createAction(Bench.HIDE_EXCLUSION_CASE_MODAL);
const toggleLateCaseClearModal = createAction(Bench.TOGGLE_LATE_CASE_CLEAR_MODAL);
const showSplitCaseModal = createAction(Bench.SHOW_SPLIT_CASE_MODAL);
const hideSplitCaseModal = createAction(Bench.HIDE_SPLIT_CASE_MODAL);
const cancelInvoicesDismiss = createAction(Bench.CANCEL_INVOICES_DISMISS);
const selectInvoiceToEdit = createAction(Bench.SELECT_INVOICE_TO_EDIT);
const selectInvoiceToAdd = createAction(Bench.SELECT_INVOICE_TO_ADD);
const submittedFeedbackTimer = createAction(Bench.SUBMITTED_MODAL_TIMER);
const setLoadingTechPro = createAction(Bench.SET_LOADING_TECH_PRO);
const setFilterTypes = createAction(Bench.SET_FILTER_TYPES_PATIENT_TIMELINE);
const setFilterTypesInfinite = createAction(Bench.SET_FILTER_TYPES_PATIENT_TIMELINE_INFINITE);
const setFilterDates = createAction(Bench.SET_FILTER_DATES_PATIENT_TIMELINE_INFINITE);
const setFilterDatesInfinite = createAction(Bench.SET_FILTER_DATES_PATIENT_TIMELINE);
const updateTransaction = createAction(Bench.UPDATE_TRANSACTION);
const updateTransactionOptimistically = createAction(Bench.UPDATE_TRANSACTION_OPTIMISTICALLY);
const createTransactionOptimistically = createAction(Bench.CREATE_TRANSACTION_OPTIMISTICALLY);
const replaceOptimisticTransaction = createAction(Bench.REPLACE_OPTIMISTIC_TRANSACTION);
const docMetadataAvailable = createAction(Bench.DOCUMENT_METADATA);
const setActiveNote = createAction(Bench.SET_ACTIVE_NOTE);
const updateRelatedCasesFilterSelection = createAction(Bench.UPDATE_RELATED_CASE_FILTER_SELECTION);
const getCodeChangeMeta = (codeChange)=>{
    const { context: { activeItem, chargeSession, invoice, processInstance } } = codeChange;
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    const processInstanceId = `${processInstance}`;
    return {
        serviceLine: serviceLineConfig.amplifyPath,
        processInstanceId
    };
};
const getCodeChangeURL = (codeChange)=>{
    const { processInstance, invoice } = codeChange.context;
    const { serviceLine } = getCodeChangeMeta(codeChange);
    if (invoice.type === InvoiceTypes.SHARED_CODES) {
        return `/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/codes/shared/v1`;
    }
    return `/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/codes/v1`;
};
const getTransactionURLForNewInvoice = (newInvoiceData)=>{
    const { activeItem, processInstanceId, invoiceGuid } = newInvoiceData;
    const serviceLineConfig = determineServiceLineConfig({
        name: activeItem.service_line
    });
    return `/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstanceId}/transaction/v1?invoiceGuid=${invoiceGuid}`;
};
const getInvoiceURL = (codeChange)=>{
    const { processInstance } = codeChange.context;
    const { serviceLine } = getCodeChangeMeta(codeChange);
    return `/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/v1?evidence=true&errors=true`;
};
const getCreateTransactionAndCodeURL = (codeChange)=>{
    const { processInstance } = codeChange.context;
    const { serviceLine } = getCodeChangeMeta(codeChange);
    return `/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/transactionwithcode/v1`;
};
const getSharedActionURL = (codeChange)=>{
    const { codeUpdate: { diagnoses, transactionGuid, serviceLine, processInstance } } = codeChange;
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    return `/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstance.guid.uuid}/codes/v1`;
};
const cancelInvoicesConfirm = createAsyncThunk(Bench.CANCEL_INVOICES_CONFIRM, async (submission, { dispatch })=>{
    const { processInstance } = submission;
    const uuid = processInstance.guid.uuid;
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    const endpoint = `/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${uuid}/cancel/v1`;
    dispatch(hideFeedback());
    dispatch(showLoadingCancelation());
    await api.request(endpoint, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.POST
    }));
    dispatch(showCanceledFeedback());
    let updateProcessInstance = await api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${uuid}/v1?evidence=true&errors=true`, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchActivity(updateProcessInstance));
    if (submission.uiMode === UIModesEnum.EPIC_EMBEDDED) {
        dispatch(showCanceledFeedback());
    }
    if (shouldAutoAdvanceWorklistAfterSubmit(submission.cursorAPIPayload)) {
        await dispatch(loadNextOrPreviousCase({
            cursorAPIPayload: submission.cursorAPIPayload,
            status: FeedbackMeta.SUCCESS
        }));
    }
    return updateProcessInstance;
});
const fetchCodeDescriptions = createAsyncThunk(Bench.CODE_DESCRIPTIONS, async (req, { dispatch })=>{
    const { caseRunTenantName, caseRunDateOfService, invoices } = req;
    const tenantInfo = await api.requestJSON(`/organization/by-name/${caseRunTenantName}/v1`);
    dispatch(caseOrganization(tenantInfo));
    const url = `/dictionary/codes/description/v2?tenantId=${tenantInfo.tenantId}`;
    const descriptionRequest = buildDescriptionRequest(invoices, caseRunDateOfService);
    if (descriptionRequest.length === 0) {
        return {};
    }
    const descriptions = await api.requestJSON(url, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.POST,
        body: JSON.stringify(descriptionRequest)
    }));
    const normalizeDescriptions$1 = normalizeDescriptions(descriptions);
    dispatch(codeDescriptionsAvailable(normalizeDescriptions$1));
    return normalizeDescriptions$1;
});
const fetchAllInvoices = createAsyncThunk(ProcessInstanceActions.ALL_INVOICES, async (processInstance)=>{
    const url = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/v1`;
    const invoices = await api.requestJSON(url, _object_spread({}, REQUEST_INIT_OPTIONS));
    return invoices;
});
const fetchProcessInstance = createAsyncThunk(ProcessInstanceActions.INVOICE_AVAILABLE, async (caseRun, { dispatch, getState })=>{
    var _state_capabilities_userContext, _state_capabilities;
    const serviceLineConfig = determineServiceLineConfig({
        name: caseRun.service_line
    });
    const processInstance = await getProcessInstance(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${caseRun.process_instance_guid}/v1?evidence=true&errors=true`);
    dispatch(fetchActivity(processInstance));
    dispatch(fetchCodeDescriptions({
        invoices: processInstance.invoices,
        caseRunTenantName: caseRun.tenant_name,
        caseRunDateOfService: caseRun.date_of_service
    }));
    dispatch(fetchAllInvoices(processInstance));
    const { getImprovementsForProcessInstance } = await import('./improvements.actions-DQF6UY_G.mjs').then(function (n) { return n.b; });
    dispatch(getImprovementsForProcessInstance(processInstance));
    if (processInstance.caseType === UIModesEnum.STANDALONE) {
        try {
            await dispatch(getHoldCaseForProcessInstance(processInstance));
        } catch (error) {
            console.error(`Error getting holding case information: ${error.message}`);
        }
    }
    await dispatch(getCaseVersions(processInstance));
    dispatch(fetchSourceInvoices({
        processInstanceId: processInstance.guid.uuid,
        serviceLine: processInstance.serviceLine,
        caseRunTenantName: caseRun.tenant_name,
        caseRunDateOfService: caseRun.date_of_service
    }));
    // Fetch exclude case permissions config
    const state = getState();
    const tenantId = (_state_capabilities = state.capabilities) === null || _state_capabilities === void 0 ? void 0 : (_state_capabilities_userContext = _state_capabilities.userContext) === null || _state_capabilities_userContext === void 0 ? void 0 : _state_capabilities_userContext.tenantId;
    if (tenantId && caseRun.service_line) {
        try {
            await dispatch(fetchExcludeCasePermissionsConfig({
                tenantId,
                serviceLine: caseRun.service_line
            }));
        } catch (error) {
            console.warn('[fetchProcessInstance] Failed to fetch exclude case permissions config:', error);
        }
    }
    return processInstance;
});
const fetchSourceInvoices = createAsyncThunk(ProcessInstanceActions.FETCH_SOURCE_INVOICES, async ({ processInstanceId, serviceLine, caseRunTenantName, caseRunDateOfService }, { dispatch })=>{
    const params = new URLSearchParams();
    const invoiceTypes = [
        InvoiceTypes.ASSEMBLED,
        InvoiceTypes.MAPPED,
        InvoiceTypes.CLINICAL
    ];
    if (invoiceTypes === null || invoiceTypes === void 0 ? void 0 : invoiceTypes.length) {
        params.append('InvoiceTypes', invoiceTypes.join(','));
    }
    if (serviceLine) {
        params.append('ServiceLine', serviceLine);
    }
    const url = `/coding-api/processinstance/${serviceLine}/${processInstanceId}/invoices/v1${params.toString() ? `?${params.toString()}` : ''}`;
    const invoices = await api.requestJSON(url, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchCodeDescriptions({
        invoices,
        caseRunTenantName: caseRunTenantName,
        caseRunDateOfService: caseRunDateOfService
    }));
    return invoices;
});
const submitInvoice = createAsyncThunk(ProcessInstanceActions.INVOICE_SUBMITTED, async (submission, { dispatch })=>{
    const { processInstance, cursorAPIPayload, submitWithOverrideButton, caseAccessTime, activeItem } = submission;
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    const processInstanceId = `${processInstance.guid.uuid}`;
    let errorList = [];
    dispatch(hideFeedback());
    dispatch(showLoadingSubmission());
    const initData = _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.POST
    });
    let submitBody = {};
    if (!!!submitWithOverrideButton && !!caseAccessTime) {
        submitBody = {
            look_back_period: caseAccessTime
        };
    } else if (!!submitWithOverrideButton && submission.vwComment !== null) {
        submitBody = _object_spread_props(_object_spread({}, submitBody), {
            override_message: submission.vwComment
        });
    }
    if ((submission === null || submission === void 0 ? void 0 : submission.removeHold) !== null && (submission === null || submission === void 0 ? void 0 : submission.removeHold) !== undefined) {
        submitBody = _object_spread_props(_object_spread({}, submitBody), {
            remove_hold: submission.removeHold
        });
    }
    if (!isEmpty(submitBody)) {
        initData.body = JSON.stringify(submitBody);
    }
    try {
        await api.request(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstanceId}/submit/v1`, initData);
        dispatch(showSubmittedFeedback());
        if (shouldAutoAdvanceWorklistAfterSubmit(cursorAPIPayload)) {
            await dispatch(loadNextOrPreviousCase({
                cursorAPIPayload: cursorAPIPayload,
                status: FeedbackMeta.SUCCESS
            }));
        }
    } catch (error) {
        const unexpectedBadRequest = typeof (error === null || error === void 0 ? void 0 : error.errors) === 'object' && 'errors' in (error === null || error === void 0 ? void 0 : error.errors);
        dispatch(hideLoadingSubmission());
        if (!unexpectedBadRequest) {
            errorList = (error === null || error === void 0 ? void 0 : error.errors) || [];
            if (errorList.length > 0) {
                dispatch(amplifyFeedback({
                    message: 'There were issues submitting this case.',
                    meta: FeedbackMeta.ERROR,
                    dismissable: true
                }));
            } else {
                dispatch(amplifyFeedback({
                    message: 'There was en error submitting this case.',
                    meta: FeedbackMeta.ERROR,
                    dismissable: true
                }));
            }
            // claim and cci errors implementation
            const { claims, cci, custom_rules } = parseInvoiceIssues(error);
            const standardErrors = filterInvoiceIssues(error);
            const mergeHistory = filterMergeHistoryWarnings(error);
            if (standardErrors.length === 0 && (cci.length > 0 || claims.length > 0 || custom_rules.length > 0 || mergeHistory.length > 0)) {
                dispatch(showvitalwareIssuesModal());
            }
            if (shouldAutoAdvanceWorklistAfterSubmit(cursorAPIPayload)) {
                await dispatch(loadNextOrPreviousCase({
                    cursorAPIPayload: cursorAPIPayload,
                    status: FeedbackMeta.ERROR
                }));
            }
        } else {
            const nonEditableMessage = 'Instance cannot be edited in current state';
            const badRequestErrors = error === null || error === void 0 ? void 0 : error.errors;
            if (typeof badRequestErrors === 'object' && 'message' in badRequestErrors && (badRequestErrors === null || badRequestErrors === void 0 ? void 0 : badRequestErrors.message) === nonEditableMessage) {
                dispatch(amplifyFeedback({
                    message: 'Changes may have occurred to the case. Unable to proceed with Submit',
                    meta: FeedbackMeta.ERROR,
                    dismissable: true
                }));
            } else {
                dispatch(amplifyFeedback({
                    message: 'There was en error submitting this case.',
                    meta: FeedbackMeta.ERROR,
                    dismissable: true
                }));
            }
        }
        // claim and cci errors implementation
        const { claims, cci, custom_rules, unresolved_documents, hold_issue } = parseInvoiceIssues(error);
        const standardErrors = filterInvoiceIssues(error);
        if (standardErrors.length === 0 && (cci.length > 0 || claims.length > 0 || custom_rules.length > 0 || unresolved_documents.length > 0 || hold_issue.length > 0)) {
            dispatch(showvitalwareIssuesModal());
        }
        if (shouldAutoAdvanceWorklistAfterSubmit(cursorAPIPayload)) {
            await dispatch(loadNextOrPreviousCase({
                cursorAPIPayload: cursorAPIPayload,
                status: FeedbackMeta.ERROR
            }));
        }
    }
    let updatedProcessInstance = await api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstanceId}/v1?evidence=true&errors=true`, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchActivity(updatedProcessInstance));
    if (!isPathology(activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line)) {
        dispatch(getCCICustomClaimCrossCases({
            activeItem: activeItem,
            processInstance: updatedProcessInstance
        }));
    }
    return updatedProcessInstance;
});
// -----------------------------
// Edit calls.  There's a pattern with the edit calls
// where each edit executes and then the invoices structure
// is retrieved from the back end.
// -----------------------------
const codeSearch = createAsyncThunk(Bench.CODE_SEARCH, async (codeQuery)=>{
    var _codeQuery_context_activeItem_date_of_service, _ref, _ref1, _readBuildEnv;
    var _codeQuery_context_chargeSession, _codeQuery_context, _codeQuery_context_userContext, _codeQuery_context1;
    const effectiveDate = (_codeQuery_context_activeItem_date_of_service = codeQuery.context.activeItem.date_of_service) !== null && _codeQuery_context_activeItem_date_of_service !== void 0 ? _codeQuery_context_activeItem_date_of_service : '2020-01-01';
    const searchId = (_ref = (_codeQuery_context = codeQuery.context) === null || _codeQuery_context === void 0 ? void 0 : (_codeQuery_context_chargeSession = _codeQuery_context.chargeSession) === null || _codeQuery_context_chargeSession === void 0 ? void 0 : _codeQuery_context_chargeSession.transactionId) !== null && _ref !== void 0 ? _ref : '';
    const tenantId = (_ref1 = (_readBuildEnv = readBuildEnv('REACT_APP_DICT_TENANT_OVERRIDE')) !== null && _readBuildEnv !== void 0 ? _readBuildEnv : (_codeQuery_context1 = codeQuery.context) === null || _codeQuery_context1 === void 0 ? void 0 : (_codeQuery_context_userContext = _codeQuery_context1.userContext) === null || _codeQuery_context_userContext === void 0 ? void 0 : _codeQuery_context_userContext.tenantId) !== null && _ref1 !== void 0 ? _ref1 : '';
    // Code search is not canceled by fetch abort signals.  As this is a type-ahead
    // the responses in flight, may still be valuable if they aren't the latest
    // REQUEST.  That said, we only want to show the latest RESPONSE.
    // There is caching in the reducer, where the responses will be registered.
    // The action is merely responsible for appending some metadata on the search.
    const response = {
        codeQuery,
        searchResults: [],
        meta: {
            searchId: searchId,
            sequenceNumber: sequenceGenerator.next(searchId)
        }
    };
    const searchMods = codeQuery.text.length > 1 && codeQuery.searchType === `${ChargeSessionCodeType.MODIFIER}`.toUpperCase();
    const meetsIMOMin = codeQuery.text.length > 2;
    if (searchMods || meetsIMOMin) {
        const lookupParams = new URLSearchParams([
            [
                'tenantId',
                tenantId
            ]
        ]);
        const searchResponse = await api.requestJSON(`/dictionary/code/v2?${lookupParams.toString()}`, {
            method: Methods.POST,
            body: JSON.stringify({
                searchTerm: codeQuery.text.toUpperCase(),
                codeType: `${codeQuery.searchType}`.toUpperCase(),
                effectiveDate
            })
        });
        response.searchResults = searchResponse.content;
    }
    return response;
});
const txnSharedCodeAction = createAsyncThunk(Bench.TXN_SHARED_CODE, async (txnSharedCodeChange, { dispatch })=>{
    const { action, codeUpdate: { diagnoses, transactionGuid, serviceLine, processInstance } } = txnSharedCodeChange;
    const serviceLineConfig = determineServiceLineConfig({
        name: processInstance.serviceLine
    });
    const updateURL = getSharedActionURL(txnSharedCodeChange);
    const method = action === 'REMOVE' ? Methods.DELETE : action === 'ADD' ? Methods.POST : undefined;
    if (method) {
        await api.requestJSON(updateURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method,
            body: JSON.stringify({
                transactionGuid,
                diagnoses
            })
        }));
    }
    let updatedProcessInstance = await api.requestJSON(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${processInstance.guid.uuid}/v1?evidence=true&errors=true`, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchActivity(updatedProcessInstance));
    return updatedProcessInstance;
});
const codeUpdateFlow = async (codeChange, dispatch)=>{
    const transactionURL = getCodeChangeURL(codeChange);
    const invoiceURL = getInvoiceURL(codeChange);
    // run the codeChange through the factory to get the submission
    // then we'll optimistically set the data to that submission
    // if the action fails we'll be rever to the earlier version.
    const updateDTO$1 = updateDTO(codeChange);
    //We should remove these if they are not used
    dispatch(optimisticCodeChange({
        updateDTO: updateDTO$1,
        codeChange
    }));
    await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.PUT,
        body: JSON.stringify(updateDTO$1)
    }));
    const processInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchActivity(processInstance));
    return processInstance;
};
const codeUpdate = createAsyncThunk(Bench.CODE_UPDATE, (codeChange, { dispatch })=>codeUpdateFlow(codeChange, dispatch));
const codeRemove = createAsyncThunk(Bench.CODE_REMOVE, async (codeChange, { dispatch })=>{
    var _activeItem_encounter_identifier, _codeChange_codes_, _codeChange_codes;
    const transactionURL = getCodeChangeURL(codeChange);
    const invoiceURL = getInvoiceURL(codeChange);
    const { context: { invoice, activeItem } } = codeChange;
    let removeCode;
    if (invoice.type === InvoiceTypes.SHARED_CODES) {
        const diagnosis_code = codeChange.codes[0].code;
        removeCode = {
            diagnosis_code: diagnosis_code
        };
    } else {
        removeCode = deleteDTO(codeChange);
        dispatch(optimisticCodeChange({
            updateDTO: removeCode,
            codeChange
        }));
    }
    await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.DELETE,
        body: JSON.stringify(removeCode)
    }));
    const processInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchRelatedCodes({
        encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier === void 0 ? void 0 : _activeItem_encounter_identifier.number,
        serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line,
        codeType: getCodeTypeShortName(codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_codes = codeChange.codes) === null || _codeChange_codes === void 0 ? void 0 : (_codeChange_codes_ = _codeChange_codes[0]) === null || _codeChange_codes_ === void 0 ? void 0 : _codeChange_codes_.codeType),
        caseId: activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id
    }));
    dispatch(fetchActivity(processInstance));
    return processInstance;
});
const codesRemove = createAsyncThunk(Bench.BULK_CODE_REMOVE, async (codeChange, { dispatch })=>{
    var _activeItem_encounter_identifier, _codeChange_codes_, _codeChange_codes;
    const transactionURL = getCodeChangeURL(codeChange);
    const invoiceURL = getInvoiceURL(codeChange);
    const { context: { invoice, activeItem } } = codeChange;
    if (invoice.type === InvoiceTypes.SHARED_CODES) {
        for (const code of codeChange.codes){
            await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
                method: Methods.DELETE,
                body: JSON.stringify({
                    diagnosis_code: code.code
                })
            }));
        }
    } else {
        const removeCode = BulkDeleteDTO(codeChange);
        dispatch(optimisticCodeChange({
            updateDTO: removeCode,
            codeChange
        }));
        await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.DELETE,
            body: JSON.stringify(removeCode)
        }));
    }
    const processInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchRelatedCodes({
        encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier === void 0 ? void 0 : _activeItem_encounter_identifier.number,
        serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line,
        codeType: getCodeTypeShortName(codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_codes = codeChange.codes) === null || _codeChange_codes === void 0 ? void 0 : (_codeChange_codes_ = _codeChange_codes[0]) === null || _codeChange_codes_ === void 0 ? void 0 : _codeChange_codes_.codeType),
        caseId: activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id
    }));
    dispatch(fetchActivity(processInstance));
    return processInstance;
});
const timeBasedCodeAdd = createAsyncThunk(Bench.TIME_BASED_CODE_ADD, async ({ codeChange, time, age }, { dispatch })=>{
    var _codeChange_context, _transaction_procedure, _transaction_procedure1;
    getInvoiceURL(codeChange);
    const { processInstance } = codeChange.context;
    const { serviceLine } = getCodeChangeMeta(codeChange);
    const transaction = codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_context = codeChange.context) === null || _codeChange_context === void 0 ? void 0 : _codeChange_context.transaction;
    const addTimeBasedCode = {
        em_code: transaction === null || transaction === void 0 ? void 0 : (_transaction_procedure = transaction.procedure) === null || _transaction_procedure === void 0 ? void 0 : _transaction_procedure.procedure_code,
        total_time: time,
        age: age,
        medicare_time_rules: transaction === null || transaction === void 0 ? void 0 : (_transaction_procedure1 = transaction.procedure) === null || _transaction_procedure1 === void 0 ? void 0 : _transaction_procedure1.medicare_time_rules,
        metadata: {
            transaction_id: transaction === null || transaction === void 0 ? void 0 : transaction.guid
        }
    };
    // Capture result while generating the code with time.
    const addTimeBasedCodeResponse = await api.request(`/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/timebasedcode/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.POST,
        body: JSON.stringify(addTimeBasedCode)
    }));
    const addTimeBasedCodeResponseData = await addTimeBasedCodeResponse.json();
    const addOnCodeResponse = addTimeBasedCodeResponseData === null || addTimeBasedCodeResponseData === void 0 ? void 0 : addTimeBasedCodeResponseData.add_on_code;
    if (addOnCodeResponse) {
        let tenantId = processInstance.healthSystemTenantId.uuid;
        const url = `/dictionary/codes/description/v2?tenantId=${tenantId}`;
        const effectiveDate = format(new Date(), FORMATS.DATE);
        const descriptionRequest = _object_spread_props(_object_spread({}, _cpt$1), {
            code: addOnCodeResponse,
            effectiveDate: effectiveDate
        });
        const descriptions = await api.requestJSON(url, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST,
            body: JSON.stringify([
                descriptionRequest
            ])
        }));
        const normalizeDescriptions$1 = normalizeDescriptions(descriptions);
        dispatch(codeDescriptionsAvailable(normalizeDescriptions$1));
    }
    const updatedProcessInstanceAction = await dispatch(updateProcessInstance({
        serviceLine,
        guid: processInstance.guid.uuid
    }));
    return updatedProcessInstanceAction.payload;
});
const timeBasedCodeUpdate = createAsyncThunk(Bench.TIME_BASED_CODE_UPDATE, async ({ codeChange, time, age }, { dispatch })=>{
    var _codeChange_context, _transaction_procedure, _transaction_procedure1;
    getInvoiceURL(codeChange);
    const { processInstance } = codeChange.context;
    const { serviceLine } = getCodeChangeMeta(codeChange);
    const transaction = codeChange === null || codeChange === void 0 ? void 0 : (_codeChange_context = codeChange.context) === null || _codeChange_context === void 0 ? void 0 : _codeChange_context.transaction;
    const addTimeBasedCode = {
        em_code: transaction === null || transaction === void 0 ? void 0 : (_transaction_procedure = transaction.procedure) === null || _transaction_procedure === void 0 ? void 0 : _transaction_procedure.procedure_code,
        total_time: time,
        age: age,
        medicare_time_rules: transaction === null || transaction === void 0 ? void 0 : (_transaction_procedure1 = transaction.procedure) === null || _transaction_procedure1 === void 0 ? void 0 : _transaction_procedure1.medicare_time_rules,
        metadata: {
            transaction_id: transaction === null || transaction === void 0 ? void 0 : transaction.guid
        }
    };
    await api.request(`/coding-api/processinstance/${serviceLine}/${processInstance.guid.uuid}/timebasedcode/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.PUT,
        body: JSON.stringify(addTimeBasedCode)
    }));
    const updatedProcessInstanceAction = await dispatch(updateProcessInstance({
        serviceLine,
        guid: processInstance.guid.uuid
    }));
    return updatedProcessInstanceAction.payload;
});
const transactionOrderChange = createAsyncThunk(Bench.TRANSACTION_ORDER_CHANGE, async (transactionReorderDetail, { dispatch })=>{
    const { context: { invoice, processInstance } } = transactionReorderDetail;
    await api.request(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/${invoice.guid}/transactions/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.PUT,
        body: JSON.stringify(transactionReorderDetail.transactions)
    }));
    const invoiceURL = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/v1?evidence=true&errors=true`;
    const updatedProcessInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchActivity(updatedProcessInstance));
    return updatedProcessInstance;
});
const removeInvoice = createAsyncThunk(Bench.REMOVE_INVOICE, async ({ processInstance, invoiceGuid }, { dispatch })=>{
    const url = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/invoice/v1?invoiceGuid=${invoiceGuid}`;
    await api.request(url, {
        method: Methods.DELETE
    });
    const updatedProcessInstanceAction = await dispatch(updateProcessInstance({
        serviceLine: processInstance.serviceLine,
        guid: processInstance.guid.uuid
    }));
    return updatedProcessInstanceAction.payload;
});
const codeSearchDrop = createAsyncThunk(Bench.CODE_SEARCH_DROP, async (codeChange, { dispatch })=>{
    const searchDrop = true;
    const transactionURL = getCodeChangeURL(codeChange);
    const invoiceURL = getInvoiceURL(codeChange);
    const { context: { invoice } } = codeChange;
    let updateDTO$1;
    if (invoice.type === InvoiceTypes.SHARED_CODES) {
        updateDTO$1 = codeChange.codes.map((code, idx)=>{
            return {
                diagnosis_code: code.code,
                sequence_number: idx + 1
            };
        });
    } else {
        // run the codeChange through the factory to get the submission
        // then we'll optimistically set the data to that submission
        // if the action fails we'll be rever to the earlier version.
        updateDTO$1 = updateDTO(codeChange, searchDrop);
        dispatch(optimisticCodeChange({
            updateDTO: updateDTO$1,
            codeChange
        }));
    }
    await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.PUT,
        body: JSON.stringify(updateDTO$1)
    }));
    return await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
});
const codeAdd = createAsyncThunk(Bench.CODE_ADD, async (codeSearchResult, { dispatch })=>{
    var _activeItem_encounter_identifier, _codeSearchResult_codeInfo;
    const transactionURL = getCodeChangeURL(codeSearchResult);
    const invoiceURL = getInvoiceURL(codeSearchResult);
    const { context } = codeSearchResult;
    const { invoice, activeItem } = context;
    let addDTO;
    if (invoice.type === InvoiceTypes.SHARED_CODES) {
        addDTO = {
            diagnosis_code: codeSearchResult.codeInfo.code,
            code_provenances: codeSearchResult.codeInfo.codeProvenances || null
        };
    } else {
        addDTO = createDTO(codeSearchResult);
    }
    try {
        /**
     * temporarily update the transaction object (optimistically)
     * so that the selected code is immediately visible in the UI before the server responds
     */ if (invoice.type !== InvoiceTypes.SHARED_CODES) {
            dispatch(updateTransactionOptimistically({
                addDTO: addDTO,
                invoiceGuid: invoice.guid
            }));
        }
        const transaction = await api.requestJSON(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST,
            body: JSON.stringify(addDTO)
        }));
        if (codeSearchResult.additionalCodes) {
            for (const codeInfo of codeSearchResult.additionalCodes){
                await dispatch(codesAdd({
                    codesInfo: codeInfo,
                    context: _object_spread_props(_object_spread({}, context), {
                        transaction
                    })
                }));
            }
        }
        if (invoice.type !== InvoiceTypes.SHARED_CODES) {
            dispatch(updateTransaction({
                transaction,
                invoiceGuid: invoice.guid
            }));
        }
    } catch (error) {
        dispatch(amplifyFeedback({
            message: `Unable to add ${addDTO.hasOwnProperty('modifier') ? 'modifier' : addDTO.hasOwnProperty('diagnosis') ? 'diagnosis' : 'procedure'} code.`,
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        throw error;
    }
    const processInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchRelatedCodes({
        encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier === void 0 ? void 0 : _activeItem_encounter_identifier.number,
        serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line,
        codeType: getCodeTypeShortName(codeSearchResult === null || codeSearchResult === void 0 ? void 0 : (_codeSearchResult_codeInfo = codeSearchResult.codeInfo) === null || _codeSearchResult_codeInfo === void 0 ? void 0 : _codeSearchResult_codeInfo.codeType),
        caseId: activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id
    }));
    dispatch(fetchActivity(processInstance));
    return processInstance;
});
const codesAdd = createAsyncThunk(Bench.BULK_CODE_ADD, async (codeSearchResult, { dispatch })=>{
    var _codeSearchResult_codesInfo, _activeItem_encounter_identifier, _codesInfo_;
    const selectResult = _object_spread({
        context: codeSearchResult.context
    }, codeSearchResult === null || codeSearchResult === void 0 ? void 0 : (_codeSearchResult_codesInfo = codeSearchResult.codesInfo) === null || _codeSearchResult_codesInfo === void 0 ? void 0 : _codeSearchResult_codesInfo[0]);
    const transactionURL = getCodeChangeURL(selectResult);
    const invoiceURL = getInvoiceURL(selectResult);
    const { context: { invoice, activeItem }, codesInfo } = codeSearchResult;
    let response;
    try {
        if (invoice.type === InvoiceTypes.SHARED_CODES) {
            for (const codeInfo of codesInfo !== null && codesInfo !== void 0 ? codesInfo : []){
                response = await api.requestJSON(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
                    method: Methods.POST,
                    body: JSON.stringify({
                        diagnosis_code: codeInfo.code,
                        code_provenances: codeInfo.codeProvenances || null
                    })
                }));
            }
        } else {
            const addDTO = BulkcreateDTO(codeSearchResult);
            /**
       * temporarily update the transaction object (optimistically)
       * so that the selected code is immediately visible in the UI before the server responds
       */ dispatch(updateTransactionOptimistically({
                addDTO: addDTO,
                invoiceGuid: invoice.guid
            }));
            response = await api.requestJSON(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
                method: Methods.POST,
                body: JSON.stringify(addDTO)
            }));
            dispatch(updateTransaction({
                transaction: response,
                invoiceGuid: invoice.guid
            }));
        }
    } catch (error) {
        dispatch(amplifyFeedback({
            message: `Unable to add codes`,
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        throw error;
    }
    const processInstance = await api.requestJSON(invoiceURL, _object_spread({}, REQUEST_INIT_OPTIONS));
    dispatch(fetchRelatedCodes({
        encounterId: activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_encounter_identifier = activeItem.encounter_identifier) === null || _activeItem_encounter_identifier === void 0 ? void 0 : _activeItem_encounter_identifier.number,
        serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line,
        codeType: getCodeTypeShortName(codesInfo === null || codesInfo === void 0 ? void 0 : (_codesInfo_ = codesInfo[0]) === null || _codesInfo_ === void 0 ? void 0 : _codesInfo_.codeType),
        caseId: activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id
    }));
    dispatch(fetchActivity(processInstance));
    return processInstance;
});
const createTransactionAndAddCode = createAsyncThunk(Bench.CREATE_TRANSACTION_AND_CODE_ADD, async (codeSearchResult, { dispatch })=>{
    const { codeInfo, context } = codeSearchResult;
    const infoWithContext = _object_spread_props(_object_spread({}, codeInfo), {
        context
    });
    const createTransactionAndCodeURL = getCreateTransactionAndCodeURL(infoWithContext);
    const { context: { invoice, processInstance } } = codeSearchResult;
    const createDTO = createTransactionDTO(infoWithContext);
    /**
   * Optimistically creates a temporary transaction object
   * with the CPT code so that it appears immediately in the UI
   * before the server response is received.
   */ dispatch(createTransactionOptimistically({
        createDTO: createDTO,
        invoiceGuid: invoice.guid
    }));
    try {
        const transaction = await api.requestJSON(createTransactionAndCodeURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST,
            body: JSON.stringify(createDTO)
        }));
        if (codeSearchResult.additionalCodes) {
            for (const codeInfo of codeSearchResult.additionalCodes){
                await dispatch(codesAdd({
                    codesInfo: codeInfo,
                    context: _object_spread_props(_object_spread({}, context), {
                        transaction
                    })
                }));
            }
        }
        dispatch(replaceOptimisticTransaction({
            transaction: transaction,
            invoiceGuid: invoice.guid
        }));
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'Unable to create transaction and add code.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        throw error;
    }
    const updatedProcessInstanceAction = await dispatch(updateProcessInstance({
        serviceLine: processInstance.serviceLine,
        guid: processInstance.guid.uuid
    }));
    return updatedProcessInstanceAction.payload;
});
/**
 * Action for adding new invoice
 */ const addTransaction = createAsyncThunk(Bench.ADD_TRANSACTION, async (newInvoiceData, { dispatch })=>{
    const transactionURL = getTransactionURLForNewInvoice(newInvoiceData);
    // set loading
    dispatch(showAddChargeLoading());
    // request call for add a transaction
    try {
        await api.request(transactionURL, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.POST
        }));
    } catch (e) {
        console.error(e);
        throw e;
    }
    return dispatch(fetchProcessInstance(newInvoiceData.activeItem));
});
const navigatePatient = createAsyncThunk(Launch.NAVIGATE_PATIENT, async (caseRun)=>{
    return [];
});
const navigateCoderNotes = createAsyncThunk(Launch.NAVIGATE_CODER_COMMENTS, async (coderNotesParams, { dispatch })=>{
    dispatch(fetchCoderNotes(_object_spread({}, coderNotesParams)));
});
const navigateProvider = createAsyncThunk(Launch.NAVIGATE_PROVIDER, async (providerInfo, { dispatch })=>{
    const action = await dispatch(navigateProviderDataAccess(providerInfo));
    return action.payload;
});
const navigateProviderDataAccess = createAsyncThunk(Launch.NAVIGATE_PROVIDER_DATAACCESS, async (providerInfo, { getState })=>{
    var _providerInfo_providerName, _ref;
    var _providerData_content;
    if (!(providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.providerNumber)) return null;
    const state = getState();
    const queryURL = '/dataaccess/read/v1';
    const providerSearchBody = _object_spread_props(_object_spread({}, buildDataAccessRequestObject(state, 'searchForProvidersByName', 'searchbillingprovider')), {
        filterFieldsMap: _object_spread({
            provider_name: (_providerInfo_providerName = providerInfo.providerName) !== null && _providerInfo_providerName !== void 0 ? _providerInfo_providerName : ''
        }, providerInfo.tenantCode ? {
            location_name: providerInfo.tenantCode
        } : {})
    });
    const providerData = await api.requestJSON(queryURL, {
        method: Methods.POST,
        body: JSON.stringify(providerSearchBody)
    });
    return (_ref = (_providerData_content = providerData.content) === null || _providerData_content === void 0 ? void 0 : _providerData_content.find((provider)=>(provider === null || provider === void 0 ? void 0 : provider.provider_id) === providerInfo.providerNumber)) !== null && _ref !== void 0 ? _ref : null;
});
const navigateDetail = createAsyncThunk(Launch.NAVIGATE_DETAIL, async (caseNavigate, { dispatch })=>{
    const [caseId, processInstanceGuid] = caseNavigate.split(':');
    const { path: slPath, caseDetailVersion } = get();
    const url = `${slPath}/caseinstance/${caseId}/details/${caseDetailVersion}?evidence=true&processTypes=PREDICTION&processTypes=ADDENDUM`;
    const withDetails = await api.requestJSON(url);
    //
    let activeItem = withDetails.caseRuns.find((caseRun)=>caseRun.process_instance_guid === processInstanceGuid);
    if (!activeItem) {
        activeItem = withDetails.caseRuns[0];
    }
    dispatch(fetchProcessInstance(activeItem));
    const { loadCase } = await import('./cases.action-CWu9M-NT.mjs').then(function (n) { return n.c; });
    await loadCase(activeItem, dispatch);
});
/**
 * Function for toggle tech pro codes
 * @param method
 * @param techCodableTransaction
 * @param dispatch
 * @returns
 */ const toggleTechPro = createAsyncThunk(Bench.TOGGLE_TECH_PRO, async (toggleInfo, { dispatch })=>{
    // start loading process and optimistic change
    dispatch(setLoadingTechPro({
        guid: toggleInfo.techCodableTransaction.invoice.guid,
        value: true
    }));
    dispatch(optimisticProTechChange(toggleInfo.techCodableTransaction));
    const bodyObject = {
        transactionGuid: toggleInfo.techCodableTransaction.transactionGuid
    };
    if (toggleInfo.techCodableTransaction.hasOwnProperty('technicalCode')) {
        bodyObject.technicalCode = toggleInfo.techCodableTransaction.technicalCode;
    } else if (toggleInfo.techCodableTransaction.hasOwnProperty('mappedProcedure')) {
        bodyObject.mappedProcedure = toggleInfo.techCodableTransaction.mappedProcedure;
    }
    const serviceLineConfig = determineServiceLineConfig({
        name: toggleInfo.techCodableTransaction.processInstance.serviceLine
    });
    try {
        // request to toggle pro/tech code
        await api.request(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${toggleInfo.techCodableTransaction.processInstance.guid.uuid}/codes/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: toggleInfo.APImethod,
            body: JSON.stringify(bodyObject)
        }));
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There were issues updating pro/tech charge.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    } finally{
        const processInstance = await getProcessInstance(`/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${toggleInfo.techCodableTransaction.processInstance.guid.uuid}/v1?evidence=true&errors=true`);
        dispatch(setLoadingTechPro({
            guid: toggleInfo.techCodableTransaction.invoice.guid,
            value: false
        }));
        return processInstance;
    }
});
/**
 * Async function for enable tech/pro charges
 */ const enableTechPro = createAsyncThunk(Bench.ENABLE_TECH_PRO, async (techCodableTransaction, { dispatch })=>{
    const action = await dispatch(toggleTechPro({
        APImethod: Methods.POST,
        techCodableTransaction
    }));
    return action.payload;
});
/**
 * Async function for disable tech/pro charges
 */ const disableTechPro = createAsyncThunk(Bench.DISABLE_TECH_PRO, async (techCodableTransaction, { dispatch })=>{
    const action = await dispatch(toggleTechPro({
        APImethod: Methods.DELETE,
        techCodableTransaction
    }));
    return action.payload;
});
/**
 * Function for toggle tech pro codes
 * @param method
 * @param {ToggleChargeableCaseType} toggleChargeableCaseObject
 * @param dispatch
 * @returns
 */ const toggleChargeableCase = createAsyncThunk(Bench.TOGGLE_CHARGEABLE_CASE, async (toggleChargeableCaseObject, { dispatch })=>{
    try {
        // request to toggle pro/tech code
        await api.request(`/coding-api/processinstance/${toggleChargeableCaseObject.serviceLine}/${toggleChargeableCaseObject.processInstanceGuid}/chargeable/v1?isChargeable=${toggleChargeableCaseObject === null || toggleChargeableCaseObject === void 0 ? void 0 : toggleChargeableCaseObject.isChargeable}`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.PUT
        }));
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an issue updating chargeble state.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    } finally{
        dispatch(hideExclusionCaseModal());
        const processInstance = await getProcessInstance(`/coding-api/processinstance/${toggleChargeableCaseObject.serviceLine}/${toggleChargeableCaseObject.processInstanceGuid}/v1?evidence=true&errors=true`);
        dispatch(fetchActivity(processInstance));
        return processInstance;
    }
});
/**
 * Function for clearing late case update notification and taking the case off the worklist view
 * Future changes may be needed to support an undo option also
 * @param {AmplifyAPI.ProcessInstance} processInstance
 * @param dispatch
 * @returns
 */ const clearLateCaseNotification = createAsyncThunk(Bench.CLEAR_LATE_CASE_UPDATE, async (processInstance, { dispatch })=>{
    try {
        var _processInstance_guid;
        await api.request(`/coding-api/processinstance/${processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine}/${processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_guid = processInstance.guid) === null || _processInstance_guid === void 0 ? void 0 : _processInstance_guid.uuid}/latecase/update/v1?dismiss=true`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.PUT
        }));
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an issue clearing the notification.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    } finally{
        dispatch(toggleLateCaseClearModal(false));
        dispatch(fetchActivity(processInstance));
    }
});
/**
 * Function for holding a case
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const holdCase = createAsyncThunk(Bench.HOLD_CASE, async (holdCaseObject, { dispatch })=>{
    let response;
    const processInstance = holdCaseObject.processInstance;
    try {
        var _ref;
        const holdDTO = {
            hold_reason: holdCaseObject.holdReason,
            comment: holdCaseObject.comment,
            coding_manager_id: (_ref = holdCaseObject === null || holdCaseObject === void 0 ? void 0 : holdCaseObject.coding_manager_id) !== null && _ref !== void 0 ? _ref : null
        };
        response = await api.request(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/hold/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
            method: Methods.PUT,
            body: JSON.stringify(holdDTO)
        }));
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an issue upon hold.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    } finally{
        dispatch(getHoldCaseForProcessInstance(processInstance));
        dispatch(hideHoldCaseModal());
        dispatch(hideCaseCommentModal());
        dispatch(fetchActivity(processInstance));
    }
});
/**
 * Function for fetching hold case
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const getHoldCaseForProcessInstance = createAsyncThunk(Bench.FETCH_HOLD_CASE, async (processInstance)=>{
    const response = await api.requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/hold/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.GET
    }));
    return response;
});
/**
 * Function for getting case versions
 * @param method
 * @param {any} ProcessInstance
 * @param dispatch
 * @returns {AmplifyAPI.CaseVersion[]}
 */ const getCaseVersions = createAsyncThunk(Bench.FETCH_CASE_VERSIONS, async (processInstance)=>{
    return await api.requestJSON(`/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/caseversion/v1`, _object_spread_props(_object_spread({}, REQUEST_INIT_OPTIONS), {
        method: Methods.GET
    }));
});
const loadNextOrPreviousCase = createAction(Bench.LOAD_NEXT_OR_PREVIOUS_CASE);
const loadWorkitemInAmplify = createAction(Bench.LOAD_WORKITEM_IN_AMPLIFY);
const loadCursorAPIContext = createAction(Bench.LOAD_CURSOR_API_CONTEXT);
const resetCursorAPIContext = createAction(Bench.RESET_CURSOR_API_CONTEXT);
/**
 * Function for fetching case-data-service and get entries
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const getCaseEntriesWithFilter = createAsyncThunk(Bench.FETCH_CASE_INTERACTIONS_INFINITE, async ({ caseRun, limit, page, timelineInfiniteLoad, messageTypeFilter, dateFilter, endDateFilter, ui })=>{
    return getDataAccessPatientTimelinewithFilter({
        caseRun,
        limit,
        page,
        timelineInfiniteLoad,
        messageTypeFilter,
        dateFilter,
        endDateFilter,
        ui
    });
});
/**
 * Function for fetching case-data-service and get entries
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const getCaseEntries = createAsyncThunk(Bench.FETCH_CASE_INTERACTIONS, async ({ caseRun, limit, page, timelineInfiniteLoad, ui })=>{
    return getDataAccessPatientTimelineCaseWithoutFilter({
        caseRun,
        limit,
        page,
        timelineInfiniteLoad,
        ui
    });
});
/**
 * Function for fetching patient message count
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const getPatientMessageCounts = createAsyncThunk(Bench.FETCH_MESSAGE_COUNTS, async (timelineCountParams)=>{
    return getDataAccessPatientMessageCountWithoutFilter(timelineCountParams);
});
/**
 * Function for fetching patient message count
 * @param method
 * @param {any} holdCaseObject
 * @param dispatch
 * @returns
 */ const getPatientMessageCountsWithFilter = createAsyncThunk(Bench.FETCH_MESSAGE_COUNTS_INFINITE, async (timelineCountParams)=>{
    return getDataAccessPatientMessageCountwithFilter(timelineCountParams);
});
const FLAG_ITEM_SOURCE_ORDER = [
    'encounter',
    'patient'
];
const normalizeFlagText = (flag)=>flag.trim();
/** Dedupe by flag identity; alternate_visit_id can differ on patient-level rows. */ const flagItemMergeKey = (item)=>`${item.flag_type}|${normalizeFlagText(item.flag)}`;
const tagFlagItemsWithSource = (items, source)=>items.map((item)=>_object_spread_props(_object_spread({}, item), {
            flag_src: [
                source
            ]
        }));
const mergeFlagItems = (items)=>{
    const byKey = new Map();
    for (const item of items){
        var _existing_flag_src, _item_flag_src;
        const key = flagItemMergeKey(item);
        const existing = byKey.get(key);
        if (!existing) {
            var _item_flag_src1;
            byKey.set(key, _object_spread_props(_object_spread({}, item), {
                flag: normalizeFlagText(item.flag),
                flag_src: [
                    ...(_item_flag_src1 = item.flag_src) !== null && _item_flag_src1 !== void 0 ? _item_flag_src1 : []
                ]
            }));
            continue;
        }
        const combined = new Set([
            ...(_existing_flag_src = existing.flag_src) !== null && _existing_flag_src !== void 0 ? _existing_flag_src : [],
            ...(_item_flag_src = item.flag_src) !== null && _item_flag_src !== void 0 ? _item_flag_src : []
        ]);
        byKey.set(key, _object_spread_props(_object_spread({}, existing), {
            flag_src: FLAG_ITEM_SOURCE_ORDER.filter((source)=>combined.has(source))
        }));
    }
    return Array.from(byKey.values());
};
const fetchFlagItemsDataAccess = async (caseRun, state, filterFieldsMap)=>{
    var _response_content;
    const queryURL = '/dataaccess/read/v1';
    const body = _object_spread_props(_object_spread({}, buildDataAccessRequestObject(state, 'getEncounterInfo', 'encounterinfo')), {
        filterFieldsMap
    });
    const response = await api.requestJSON(queryURL, {
        method: Methods.POST,
        body: JSON.stringify(body)
    });
    return (_response_content = response.content) !== null && _response_content !== void 0 ? _response_content : [];
};
const fetchAndMergeFlagItems = async (caseRun, state)=>{
    var _ref, _ref1;
    var _caseRun_encounter_identifier, _caseRun_patient_identifier;
    const [encounterRows, patientRows] = await Promise.all([
        fetchFlagItemsDataAccess(caseRun, state, {
            alternate_visit_id: (_ref = caseRun === null || caseRun === void 0 ? void 0 : (_caseRun_encounter_identifier = caseRun.encounter_identifier) === null || _caseRun_encounter_identifier === void 0 ? void 0 : _caseRun_encounter_identifier.number) !== null && _ref !== void 0 ? _ref : ''
        }),
        fetchFlagItemsDataAccess(caseRun, state, {
            patient_mrn: (_ref1 = caseRun === null || caseRun === void 0 ? void 0 : (_caseRun_patient_identifier = caseRun.patient_identifier) === null || _caseRun_patient_identifier === void 0 ? void 0 : _caseRun_patient_identifier.number) !== null && _ref1 !== void 0 ? _ref1 : ''
        })
    ]);
    return mergeFlagItems([
        ...tagFlagItemsWithSource(encounterRows, 'encounter'),
        ...tagFlagItemsWithSource(patientRows, 'patient')
    ]);
};
/**
 * Fetches flag items for a given case run (encounter + patient MRN), merges
 * results, and tags each row with `flag_src` provenance via two
 * `/dataaccess/read/v1` calls.
 */ const getFlagItems = createAsyncThunk(Bench.FETCH_FLAGS, async (caseRun, { getState })=>{
    const state = getState();
    return fetchAndMergeFlagItems(caseRun, state);
});
const getCasesWithEncounter = createAsyncThunk(Bench.FETCH_CASES_WITH_ENCOUNTER, async (params, { dispatch, rejectWithValue })=>{
    try {
        const { encounterId, sortablePageable, serviceLine, filterSelection } = params;
        const searchParams = searchParamsFactory(sortablePageable);
        searchParams.set('encounterId', encounterId);
        const filterClauses = getRelatedCasesFilterRequest(encounterId, filterSelection);
        const result = await api.requestJSON(`/coding-api/${serviceLine}/relatedcases/v2?${searchParams.toString()}`, {
            method: Methods.POST,
            body: JSON.stringify(filterClauses)
        });
        return result;
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an error fetching related cases.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        return rejectWithValue(error);
    }
});
const getCodesWithEncounter = createAsyncThunk(Bench.FETCH_CODES_WITH_ENCOUNTER, async (params, { dispatch })=>{
    try {
        const { encounterId, codeType, serviceLine, caseId } = params;
        const path = `/coding-api/${serviceLine}/relatedcases/codes/v1`;
        const result = await api.requestJSON(path, {
            method: Methods.POST,
            body: JSON.stringify({
                encounter_id: encounterId,
                code_type: codeType,
                case_id: caseId
            })
        });
        return result;
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an error fetching suggested codes.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    }
});
const getRelatedCodes = createAsyncThunk(Bench.GET_RELATED_CODES, async (params, { dispatch, rejectWithValue })=>{
    try {
        const { codeType, serviceLine, caseId } = params;
        const path = `/api/case-data/${serviceLine}/caseinstance/relatedcodes/v1`;
        const result = await api.requestJSON(path, {
            method: Methods.POST,
            body: JSON.stringify({
                case_id: String(caseId),
                code_type: codeType.toLowerCase()
            })
        });
        return result;
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an error fetching related codes.',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
        return rejectWithValue(error);
    }
});
const fetchRelatedCodes = createAsyncThunk(Bench.FETCH_RELATED_CODES, async (params, { dispatch, getState })=>{
    var _state_capabilities_capabilities_transactionV2, _state_capabilities_capabilities, _state_capabilities, _state_capabilities1;
    const state = getState();
    const isTransactionV2 = capabilityValue((_state_capabilities = state.capabilities) === null || _state_capabilities === void 0 ? void 0 : (_state_capabilities_capabilities = _state_capabilities.capabilities) === null || _state_capabilities_capabilities === void 0 ? void 0 : (_state_capabilities_capabilities_transactionV2 = _state_capabilities_capabilities.transactionV2) === null || _state_capabilities_capabilities_transactionV2 === void 0 ? void 0 : _state_capabilities_capabilities_transactionV2.on);
    const isRelatedCodesEnabled = isResourceAllowed((_state_capabilities1 = state.capabilities) === null || _state_capabilities1 === void 0 ? void 0 : _state_capabilities1.userContext, ResourceId.ENABLE_RELATED_CASE_CODES_UI, params.serviceLine);
    if (!isTransactionV2 || !isRelatedCodesEnabled) {
        return;
    }
    const resultAction = await dispatch(getRelatedCodes(params));
    return resultAction.payload;
});
const getCCICustomClaimCrossCases = createAsyncThunk(Bench.FETCH_CCI_CUSTOM_CLAIM_CROSS_CASES, async ({ activeItem, processInstance }, { dispatch })=>{
    const hasCCIEditCustomClaimErrors = processInstance.errors.some((error)=>error.message_key === IssueTypeErrors.CCI_EDIT || error.message_key === IssueTypeErrors.CUSTOM_RULES);
    if (!hasCCIEditCustomClaimErrors) {
        return [];
    }
    try {
        var _processInstance_guid, _processInstance_guid1;
        if (!activeItem || !(processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_guid = processInstance.guid) === null || _processInstance_guid === void 0 ? void 0 : _processInstance_guid.uuid) || !activeItem.service_line) {
            console.error('Invalid activeItem, please try again or contact support. ', activeItem);
            throw new Error('Invalid activeItem');
        }
        const result = await api.requestJSON(`/api/cases/${activeItem.service_line.toUpperCase()}/caseinstance/${processInstance === null || processInstance === void 0 ? void 0 : (_processInstance_guid1 = processInstance.guid) === null || _processInstance_guid1 === void 0 ? void 0 : _processInstance_guid1.uuid}/claimseditgroup/v1`, {
            method: Methods.POST,
            body: JSON.stringify({
                date_of_service: activeItem.date_of_service,
                billing_provider_number: activeItem.billing_provider_number.number
            })
        });
        return result.caseRuns;
    } catch (error) {
        dispatch(amplifyFeedback({
            message: 'There was an error fetching custom claims related cases',
            meta: FeedbackMeta.ERROR,
            dismissable: true
        }));
    }
});
const openWindow = createAction(UserInterface.OPEN_CHILD_WINDOW);
const getDocuments = async (caseRun, tenantInfo, automateGen)=>{
    let filterParams;
    const isIPCServiceLine = isIPC(caseRun.service_line);
    if (automateGen === AutomateGeneration.GEN3) {
        filterParams = buildBusinessKeyFilters(caseRun, tenantInfo);
    } else if (isIPCServiceLine) {
        var _caseRun_notes;
        const docsSeen = new Set();
        filterParams = (_caseRun_notes = caseRun.notes) === null || _caseRun_notes === void 0 ? void 0 : _caseRun_notes.filter((note)=>note.unique_document_number).map((note)=>{
            const docId = note.unique_document_number;
            docsSeen.add(docId);
            return {
                tenantId: `${tenantInfo.tenantId}`,
                uniqueDocumentNumber: docId
            };
        });
    } else {
        filterParams = [
            {
                tenantId: `${tenantInfo.tenantId}`,
                fillerOrderNumber: caseRun.order_filler_number.number
            }
        ];
    }
    // docs metadata filter
    const response = [];
    let docs = await fetchDocumentsByFilterParams(filterParams);
    if (docs.length === 0 && isIPCServiceLine) {
        // if no docs found, try again with businessKey
        filterParams = buildBusinessKeyFilters(caseRun, tenantInfo);
        docs = await fetchDocumentsByFilterParams(filterParams);
    }
    if (automateGen === AutomateGeneration.GEN3 || isIPCServiceLine) {
        const { MimeTypes } = documentUtils;
        const docGroupProperty = isIPCServiceLine ? 'uniqueDocumentNumber' : 'externalId';
        const groupedDocs = groupBy(docs, docGroupProperty);
        Object.entries(groupedDocs).forEach(([externalId, docs])=>{
            // group documents by mimeType
            const groupByDocs = groupBy(docs, 'mimeType');
            const precedence = [
                MimeTypes.HTML,
                MimeTypes.PDF,
                MimeTypes.TEXT
            ];
            const doc = firstAvailable(groupByDocs, precedence);
            if (doc) {
                // check if conversion is expected
                // add to response if conversion is expected and missing
                const conversionTargets = getExpectedConversionTargets(groupByDocs);
                const foundConversion = conversionTargets.includes(doc.mimeType);
                response.push(_object_spread_props(_object_spread({}, doc), {
                    missedConversion: conversionTargets.length > 0 && !foundConversion
                }));
            }
        });
    } else {
        response.push(...docs);
    }
    return response;
};
/**
 * Builds an array of filter parameters for fetching documents by business key.
 *
 * @param caseRun - The case run object containing the case run UID and child case list.
 * @param tenantInfo - The organization information containing the tenant ID.
 * @returns An array of filter parameters with tenant ID and business key.
 */ const buildBusinessKeyFilters = (caseRun, tenantInfo)=>{
    var _caseRun_caserun_uid;
    var _caseRun_child_case_list;
    const filterParams = [
        {
            tenantId: `${tenantInfo.tenantId}`,
            businessKey: (_caseRun_caserun_uid = caseRun.caserun_uid) !== null && _caseRun_caserun_uid !== void 0 ? _caseRun_caserun_uid : ''
        }
    ];
    (_caseRun_child_case_list = caseRun.child_case_list) === null || _caseRun_child_case_list === void 0 ? void 0 : _caseRun_child_case_list.forEach((childCase)=>{
        var _childCase_caserun_uid;
        filterParams.push({
            tenantId: `${tenantInfo.tenantId}`,
            businessKey: (_childCase_caserun_uid = childCase.caserun_uid) !== null && _childCase_caserun_uid !== void 0 ? _childCase_caserun_uid : ''
        });
    });
    return filterParams;
};
/**
 * Fetches a list of documents based on the provided filter parameters.
 *
 * @param filterParams - An array of filter parameters, each containing a tenant ID and an optional business key or filler order number.
 * @returns A promise that resolves to an array of `CMxAPI.DocumentMetadata` objects representing the fetched documents.
 */ const fetchDocumentsByFilterParams = async (filterParams)=>{
    const documentRequests = filterParams.map((filterParam)=>{
        //@ts-ignore
        const docFilter = new URLSearchParams(filterParam);
        return api.requestJSON(`/documents/v2?${docFilter}`);
    });
    // get list of documents
    const allPromises = await Promise.all(documentRequests);
    const docs = allPromises.flatMap((doc)=>doc);
    return docs;
};
const getDocumentsAsHtml = createAsyncThunk('GET_HTML', async (caseRun, { dispatch })=>{
    const { tenant_name, child_case_list = [] } = caseRun;
    const tenantInfo = await api.requestJSON(`/organization/by-name/${tenant_name}/v1`);
    let docs = await getDocuments(caseRun, tenantInfo);
    let htmlNotes = [];
    let caseRuns = [
        caseRun
    ];
    // Get any additional caseRuns so we have document name data
    for (const child of child_case_list){
        if (child.case_uid !== caseRun.case_uid) {
            var _ref;
            const serviceLineConfig = determineServiceLineConfig({
                name: caseRun.service_line
            });
            const caseParams = new URLSearchParams(serviceLineConfig.caseDetailParms);
            const expandedCaseDetail = await api.requestJSON(`${serviceLineConfig.path}/caseinstance/${child.case_uid}/details/${serviceLineConfig.caseDetailVersion}?${caseParams.toString()}`, _object_spread({}, REQUEST_INIT_OPTIONS));
            caseRuns = caseRuns.concat((_ref = expandedCaseDetail === null || expandedCaseDetail === void 0 ? void 0 : expandedCaseDetail.caseRuns) !== null && _ref !== void 0 ? _ref : []);
        }
    }
    let newDocs = [];
    const allowedDocs = new Set([
        'application/pdf',
        'text/html',
        'text/plain'
    ]);
    for (let doc of docs){
        const { id, mimeType } = doc;
        if (!id) {
            console.warn(`no id for document`, doc);
            continue;
        }
        if (allowedDocs.has(mimeType)) {
            // caseruns are an amalgam of all case runs associated with the case
            // so we need to find the caseRun that should be looked up in order
            // with this document
            caseRuns.sort((a, b)=>{
                // if either of the docs a parent, but not both, thenn the one with the parent should be first
                if (!a.parent_case || !b.parent_case) {
                    if (a.parent_case) {
                        return 1;
                    }
                    if (b.parent_case) {
                        return -1;
                    }
                }
                if (a.case_created_datetime === null || b.case_created_datetime === null) return 0;
                // fallback to the lastest created date
                return a.case_created_datetime > b.case_created_datetime ? 1 : -1;
            });
            const caseRun = caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.find((caseRun)=>{
                var _caseRun_notes;
                return (_caseRun_notes = caseRun.notes) === null || _caseRun_notes === void 0 ? void 0 : _caseRun_notes.find((note)=>{
                    //@ts-ignore
                    if (note.unique_document_number === doc.uniqueDocumentNumber) return true;
                    return caseRun.caserun_uid === doc.businessKey;
                });
            });
            const notes = caseRun === null || caseRun === void 0 ? void 0 : caseRun.notes;
            const caseRunNote = notes === null || notes === void 0 ? void 0 : notes.find((note)=>{
                return note.unique_document_number === doc.uniqueDocumentNumber;
            });
            try {
                var _ref1, _ref2, _doc_missedConversion, _ref3, _ref4, _ref5;
                const endpoint = `/documents/download/${id}${mimeType === 'application/pdf' ? '/encoded' : ''}/v1`;
                const content = await api.request(endpoint);
                const text = await content.text();
                const htmlNote = decoratedNoteFactory({
                    description: (_ref1 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.description) !== null && _ref1 !== void 0 ? _ref1 : doc.documentDescription,
                    content: text,
                    filename: (_ref2 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.note_specialty_designation) !== null && _ref2 !== void 0 ? _ref2 : 'Document',
                    type: doc.documentType,
                    document_id: doc.documentId,
                    missedConversion: (_doc_missedConversion = doc.missedConversion) !== null && _doc_missedConversion !== void 0 ? _doc_missedConversion : false,
                    id,
                    filetype: mimeType,
                    datetime: (_ref3 = caseRun === null || caseRun === void 0 ? void 0 : caseRun.datetime_of_service) !== null && _ref3 !== void 0 ? _ref3 : '',
                    primary: (_ref4 = caseRun === null || caseRun === void 0 ? void 0 : caseRun.primary_case_indicator) !== null && _ref4 !== void 0 ? _ref4 : false,
                    unique_document_number: caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.unique_document_number
                });
                htmlNotes.push(htmlNote);
                newDocs.push(_object_spread_props(_object_spread({}, doc), {
                    documentName: (_ref5 = caseRunNote === null || caseRunNote === void 0 ? void 0 : caseRunNote.note_specialty_designation) !== null && _ref5 !== void 0 ? _ref5 : 'Document',
                    primary: caseRun.primary_case_indicator
                }));
            } catch (e) {
                console.error('CB error fetching document', doc, e);
            }
        }
    }
    docs = newDocs.filter((doc)=>doc.documentId !== null);
    dispatch(docMetadataAvailable(docs));
    return htmlNotes;
});
const loadRoles = createAction(Bench.LOAD_ROLES);
const fetchNoteTypes = createAsyncThunk(Bench.FETCH_NOTE_TYPES, async (noteTypeParams)=>{
    const currentDate = format(new Date(), FORMATS.DATE);
    const searchParams = new URLSearchParams({
        tenantId: noteTypeParams.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: currentDate,
        dictionaryName: 'Note Type',
        columnName: 'Key'
    });
    return fetchDictionaryRows(searchParams);
});
const fetchRelateCaseFilterDictionaries = createAsyncThunk(Bench.FETCH_RELATED_CASE_FILTER_DICTIONARIES, async (noteTypeParams)=>{
    var _noteTypeParams_activeItem;
    const date_of_service = ((_noteTypeParams_activeItem = noteTypeParams.activeItem) === null || _noteTypeParams_activeItem === void 0 ? void 0 : _noteTypeParams_activeItem.date_of_service) || format(new Date(), FORMATS.DATE);
    const currentDate = format(new Date(), FORMATS.DATE);
    const noteTypeSearchParams = new URLSearchParams({
        tenantId: noteTypeParams.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: currentDate,
        dictionaryName: 'Note Type',
        columnName: 'Key'
    });
    const noteTypes = await fetchDictionaryRows(noteTypeSearchParams);
    const patientClassParams = new URLSearchParams({
        tenantId: noteTypeParams.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: date_of_service,
        dictionaryName: 'Patient Class',
        columnName: 'Key'
    });
    const patientClasses = await fetchDictionaryRows(patientClassParams);
    const noteSpecialtyParams = new URLSearchParams({
        tenantId: noteTypeParams.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: date_of_service,
        dictionaryName: 'Note Specialty',
        columnName: 'Key'
    });
    const noteSpecialties = await fetchDictionaryRows(noteSpecialtyParams);
    return {
        noteType: noteTypes === null || noteTypes === void 0 ? void 0 : noteTypes.rowValues,
        patientClass: patientClasses === null || patientClasses === void 0 ? void 0 : patientClasses.rowValues,
        noteSpecialty: noteSpecialties === null || noteSpecialties === void 0 ? void 0 : noteSpecialties.rowValues
    };
});
const fetchProviderRoleTypeConfigurations = createAsyncThunk(Bench.PROVIDER_ROLETYPE_CONFIGURATION, async (params)=>{
    const date_of_service = format(new Date(), FORMATS.DATE);
    const searchParams = new URLSearchParams({
        tenantId: params.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: date_of_service,
        dictionaryName: 'Provider Role Type Configurations',
        columnName: 'Key'
    });
    return fetchDictionaryRows(searchParams);
});
const fetchOrderTypeStatus = createAsyncThunk(Bench.FETCH_ORDER_TYPE_STATUS, async (dictionaryInputParams)=>{
    let currentDate = format(new Date(), FORMATS.DATE);
    const searchParams = new URLSearchParams({
        tenantId: dictionaryInputParams.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: currentDate,
        dictionaryName: 'HL7 Order Control Dictionary',
        columnName: 'Key'
    });
    return fetchDictionaryRows(searchParams);
});
const fetchCoderNotes = createAsyncThunk(Bench.FETCH_CODER_NOTES, async (coderNoteInputParams)=>{
    const { lookupType, lookupValue } = coderNoteInputParams;
    const lookupRefName = CoderNotesLookupTypeName[lookupType];
    const path = `/coding-api/coder_notes/v1?${lookupRefName}=${lookupValue}`;
    const result = await api.requestJSON(path, {
        method: Methods.GET
    });
    return result;
});
const setLockCaseUid = createAction(Bench.SET_LOCK_CASE_UID);
const acquireCaseAccess = createAsyncThunk(Bench.ACQUIRE_CASE_ACCESS, async ({ case_uid, processInstance, callback }, { dispatch })=>{
    try {
        const path = `/api/service-desk/directory-service/case_access/open/${case_uid}/v1`;
        const response = await api.request(path, {
            method: Methods.PUT
        });
        if (response.status >= 200 && response.status < 300) {
            dispatch(setLockCaseUid(case_uid));
            dispatch(caseOpenSuccess(processInstance));
            if (callback) callback({
                success: true
            });
        }
    } catch (error) {
        var _error_response;
        if ((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 409 || (error === null || error === void 0 ? void 0 : error.status) === 409) {
            dispatch(caseOpenConflict(processInstance));
            // Access response data directly based on the actual API response structure
            let openedByName;
            try {
                // The response data is now accessible via error.responseData
                const responseData = error.responseData || {};
                if (responseData === null || responseData === void 0 ? void 0 : responseData.opened_case_content) {
                    const firstName = responseData.opened_case_content.opened_by_first_name;
                    const lastName = responseData.opened_case_content.opened_by_last_name;
                    const username = responseData.opened_case_content.opened_by_username;
                    if (firstName && lastName) {
                        openedByName = `${firstName} ${lastName}`;
                    } else if (username) {
                        openedByName = username;
                    } else {
                        openedByName = 'another user';
                    }
                }
            } catch (e) {
                console.error('Failed to parse opened_by', e);
            }
            if (callback) callback({
                conflict: true,
                openedByName
            });
        } else {
            console.error('case access open failed', error);
            dispatch(caseOpenFailed());
        }
    }
});
const refreshCaseAccessTimer = createAsyncThunk(Bench.REFRESH_CASE_ACCESS_TIMER, async (case_uid, { dispatch })=>{
    try {
        const path = `/api/service-desk/directory-service/case_access/open/${case_uid}/v1`;
        await api.request(path, {
            method: Methods.PUT
        });
        dispatch(refreshTimerSuccess());
    } catch (error) {
        console.error('Timer refresh failed', error);
    }
});
const releaseCaseAccess = createAsyncThunk(Bench.RELEASE_CASE_ACCESS, async (case_uid, { dispatch })=>{
    // Skip the network call when there is nothing to release or when the auth
    // token has already been cleared (e.g. during auto-logout, where setToken('')
    // runs before this thunk). A DELETE without a token returns 401, which logs a
    // console error and records a failed Datadog RUM resource. Still clear the
    // lock uid in state so the local lock reference is reset.
    if (!case_uid || !authHandler.token) {
        dispatch(setLockCaseUid(''));
        return;
    }
    try {
        const path = `/api/service-desk/directory-service/case_access/open/${case_uid}/v1`;
        const response = await api.request(path, {
            method: Methods.DELETE
        });
        if (response.status === 204) {
            dispatch(caseCloseSuccess());
        }
    } catch (error) {
        var _ref;
        var _error_response, _error_errors, _error_response1;
        const status = (_ref = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) !== null && _ref !== void 0 ? _ref : error === null || error === void 0 ? void 0 : error.status;
        if (status === 404 || (error === null || error === void 0 ? void 0 : (_error_errors = error.errors) === null || _error_errors === void 0 ? void 0 : _error_errors.status) === 'PAGE NOT FOUND') {
            dispatch(caseCloseNotFound());
        } else if (status === 409 || (error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status) === 409) {
            dispatch(caseCloseConflict());
        } else {
            console.error('case access close failed', error);
            dispatch(caseCloseFailed());
        }
    } finally{
        dispatch(setLockCaseUid(''));
    }
});
const caseOpenSuccess = createAction(Bench.CASE_OPEN_SUCCESS);
const caseOpenFailed = createAction(Bench.CASE_OPEN_FAILED);
const caseOpenConflict = createAction(Bench.CASE_OPEN_CONFLICT);
const refreshTimerSuccess = createAction(Bench.REFRESH_TIMER_SUCCESS);
const caseCloseSuccess = createAction(Bench.CASE_CLOSE_SUCCESS);
const caseCloseNotFound = createAction(Bench.CASE_CLOSE_NOT_FOUND);
const caseCloseConflict = createAction(Bench.CASE_CLOSE_CONFLICT);
const caseCloseFailed = createAction(Bench.CASE_CLOSE_FAILED);
const resetCaseAccess = createAction(Bench.RESET_CASE_ACCESS);
const setBenchMode = createAction(Bench.SET_BENCH_MODE);
const addCoderNote = createAsyncThunk(Bench.ADD_CODER_NOTE, async (coderNoteInputParams, { dispatch })=>{
    const { lookupType, lookupValue, noteContent, patientMRN } = coderNoteInputParams;
    const lookupRefName = CoderNotesLookupTypeName[lookupType];
    const path = `/coding-api/coder_notes/v1?${lookupRefName}=${lookupValue}`;
    await api.requestJSON(path, {
        method: Methods.POST,
        body: JSON.stringify({
            lookup_type: lookupType,
            note_content: noteContent,
            patient_mrn: patientMRN
        })
    });
    const action = await dispatch(fetchCoderNotes(coderNoteInputParams));
    return action.payload;
});
const addUserActivityComment = createAsyncThunk(Bench.ADD_USER_ACTIVITY_COMMENT, async ({ processInstance, comment }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/comments/v1`;
    await api.request(path, {
        method: Methods.POST,
        body: JSON.stringify({
            comment
        })
    });
    return dispatch(fetchActivity(processInstance));
});
const updateCoderNote = createAsyncThunk(Bench.UPDATE_CODER_NOTE, async (coderNoteInputParams, { dispatch })=>{
    const path = `/coding-api/coder_notes/${coderNoteInputParams === null || coderNoteInputParams === void 0 ? void 0 : coderNoteInputParams.noteId}/v1`;
    await api.requestJSON(path, {
        method: Methods.PUT,
        body: JSON.stringify({
            note_content: coderNoteInputParams === null || coderNoteInputParams === void 0 ? void 0 : coderNoteInputParams.noteContent,
            patient_mrn: coderNoteInputParams === null || coderNoteInputParams === void 0 ? void 0 : coderNoteInputParams.patientMRN
        })
    });
    const action = await dispatch(fetchCoderNotes(coderNoteInputParams));
    return action.payload;
});
const deleteCoderNote = createAsyncThunk(Bench.DELETE_CODER_NOTE, async (coderNoteInputParams, { dispatch })=>{
    const path = `/coding-api/coder_notes/${coderNoteInputParams === null || coderNoteInputParams === void 0 ? void 0 : coderNoteInputParams.noteId}/v1`;
    await api.request(path, {
        method: Methods.DELETE
    });
    const action = await dispatch(fetchCoderNotes(coderNoteInputParams));
    return action.payload;
});
const setCodeBenchPropertyConfig = createAction('SET_CODE_BENCH_PROPERTY_CONFIG');
const refreshHoldSubmission = createAction(Bench.REFRESH_HOLD_SUBMISSION);

var codeBench_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  acquireCaseAccess: acquireCaseAccess,
  addCoderNote: addCoderNote,
  addTransaction: addTransaction,
  addUserActivityComment: addUserActivityComment,
  cancelInvoicesConfirm: cancelInvoicesConfirm,
  cancelInvoicesDismiss: cancelInvoicesDismiss,
  cancelInvoicesPopup: cancelInvoicesPopup,
  caseCloseSuccess: caseCloseSuccess,
  caseOpenConflict: caseOpenConflict,
  caseOpenSuccess: caseOpenSuccess,
  caseOrganization: caseOrganization,
  clearLateCaseNotification: clearLateCaseNotification,
  clearSearchResults: clearSearchResults,
  closeAddChargeModal: closeAddChargeModal,
  codeAdd: codeAdd,
  codeDescriptionsAvailable: codeDescriptionsAvailable,
  codeRemove: codeRemove,
  codeSearch: codeSearch,
  codeSearchDrop: codeSearchDrop,
  codeUpdate: codeUpdate,
  codeUpdateFlow: codeUpdateFlow,
  codesAdd: codesAdd,
  codesRemove: codesRemove,
  createTransactionAndAddCode: createTransactionAndAddCode,
  createTransactionOptimistically: createTransactionOptimistically,
  deleteCoderNote: deleteCoderNote,
  deleteSizeExpWarning: deleteSizeExpWarning,
  disableTechPro: disableTechPro,
  docMetadataAvailable: docMetadataAvailable,
  enableTechPro: enableTechPro,
  featureSelection: featureSelection,
  fetchActivity: fetchActivity,
  fetchAllInvoices: fetchAllInvoices,
  fetchCodeBenchLayoutConfiguration: fetchCodeBenchLayoutConfiguration,
  fetchCoderNotes: fetchCoderNotes,
  fetchExcludeCasePermissionsConfig: fetchExcludeCasePermissionsConfig,
  fetchNoteTypes: fetchNoteTypes,
  fetchOrderTypeStatus: fetchOrderTypeStatus,
  fetchProcessInstance: fetchProcessInstance,
  fetchProviderRoleTypeConfigurations: fetchProviderRoleTypeConfigurations,
  fetchRelateCaseFilterDictionaries: fetchRelateCaseFilterDictionaries,
  fetchRelatedCodes: fetchRelatedCodes,
  fetchSourceInvoices: fetchSourceInvoices,
  getCCICustomClaimCrossCases: getCCICustomClaimCrossCases,
  getCaseEntries: getCaseEntries,
  getCaseEntriesWithFilter: getCaseEntriesWithFilter,
  getCaseVersions: getCaseVersions,
  getCasesWithEncounter: getCasesWithEncounter,
  getCodesWithEncounter: getCodesWithEncounter,
  getDocuments: getDocuments,
  getDocumentsAsHtml: getDocumentsAsHtml,
  getFlagItems: getFlagItems,
  getHoldCaseForProcessInstance: getHoldCaseForProcessInstance,
  getPatientMessageCounts: getPatientMessageCounts,
  getPatientMessageCountsWithFilter: getPatientMessageCountsWithFilter,
  getRelatedCodes: getRelatedCodes,
  hideCaseCommentModal: hideCaseCommentModal,
  hideExclusionCaseModal: hideExclusionCaseModal,
  hideHoldCaseModal: hideHoldCaseModal,
  hideLoadingSubmission: hideLoadingSubmission,
  hideSideNavBar: hideSideNavBar,
  hideSizeExpWarning: hideSizeExpWarning,
  hideSplitCaseModal: hideSplitCaseModal,
  hideSubmittedFeedback: hideSubmittedFeedback,
  hidevitalwareIssuesModal: hidevitalwareIssuesModal,
  holdCase: holdCase,
  loadCursorAPIContext: loadCursorAPIContext,
  loadNextOrPreviousCase: loadNextOrPreviousCase,
  loadRoles: loadRoles,
  loadWorkitemInAmplify: loadWorkitemInAmplify,
  mergeFlagItems: mergeFlagItems,
  navigateCoderNotes: navigateCoderNotes,
  navigateDetail: navigateDetail,
  navigatePatient: navigatePatient,
  navigateProvider: navigateProvider,
  navigateProviderDataAccess: navigateProviderDataAccess,
  openAddChargeModal: openAddChargeModal,
  openWindow: openWindow,
  optimisticCodeChange: optimisticCodeChange,
  optimisticProTechChange: optimisticProTechChange,
  popupClose: popupClose,
  popupNavigate: popupNavigate,
  promptClose: promptClose,
  refreshCaseAccessTimer: refreshCaseAccessTimer,
  refreshHoldSubmission: refreshHoldSubmission,
  releaseCaseAccess: releaseCaseAccess,
  removeInvoice: removeInvoice,
  replaceOptimisticTransaction: replaceOptimisticTransaction,
  resetCaseAccess: resetCaseAccess,
  resetCursorAPIContext: resetCursorAPIContext,
  selectInvoiceToAdd: selectInvoiceToAdd,
  selectInvoiceToEdit: selectInvoiceToEdit,
  setActiveMiniTab: setActiveMiniTab,
  setActiveNote: setActiveNote,
  setActiveVerticalMiniTab: setActiveVerticalMiniTab,
  setBenchMode: setBenchMode,
  setCodeBenchPropertyConfig: setCodeBenchPropertyConfig,
  setFilterDates: setFilterDates,
  setFilterDatesInfinite: setFilterDatesInfinite,
  setFilterTypes: setFilterTypes,
  setFilterTypesInfinite: setFilterTypesInfinite,
  setLoadingTechPro: setLoadingTechPro,
  setLockCaseUid: setLockCaseUid,
  setUnresolvedDocuments: setUnresolvedDocuments,
  setvitalwareIssues: setvitalwareIssues,
  showAddChargeLoading: showAddChargeLoading,
  showCanceledFeedback: showCanceledFeedback,
  showCaseCommentModal: showCaseCommentModal,
  showExclusionCaseModal: showExclusionCaseModal,
  showHoldCaseModal: showHoldCaseModal,
  showLoadingCancelation: showLoadingCancelation,
  showLoadingSubmission: showLoadingSubmission,
  showSideNavBar: showSideNavBar,
  showSizeExpWarning: showSizeExpWarning,
  showSplitCaseModal: showSplitCaseModal,
  showSubmittedFeedback: showSubmittedFeedback,
  showvitalwareIssuesModal: showvitalwareIssuesModal,
  submitInvoice: submitInvoice,
  submittedFeedbackTimer: submittedFeedbackTimer,
  timeBasedCodeAdd: timeBasedCodeAdd,
  timeBasedCodeUpdate: timeBasedCodeUpdate,
  toggleChargeableCase: toggleChargeableCase,
  toggleLateCaseClearModal: toggleLateCaseClearModal,
  toggleSubmitOldCaseModal: toggleSubmitOldCaseModal,
  transactionOrderChange: transactionOrderChange,
  txnSharedCodeAction: txnSharedCodeAction,
  updateCoderNote: updateCoderNote,
  updateProcessInstance: updateProcessInstance,
  updateRelatedCasesFilterSelection: updateRelatedCasesFilterSelection,
  updateTransaction: updateTransaction,
  updateTransactionOptimistically: updateTransactionOptimistically
});

export { getPatientMessageCounts as $, deleteSizeExpWarning as A, disableTechPro as B, docMetadataAvailable as C, enableTechPro as D, featureSelection as E, fetchActivity as F, fetchAllInvoices as G, fetchCodeBenchLayoutConfiguration as H, fetchCoderNotes as I, fetchExcludeCasePermissionsConfig as J, fetchNoteTypes as K, fetchOrderTypeStatus as L, fetchProcessInstance as M, fetchProviderRoleTypeConfigurations as N, fetchRelateCaseFilterDictionaries as O, fetchRelatedCodes as P, fetchSourceInvoices as Q, getCCICustomClaimCrossCases as R, getCaseEntries as S, getCaseEntriesWithFilter as T, getCaseVersions as U, getCasesWithEncounter as V, getCodesWithEncounter as W, getDocuments as X, getDocumentsAsHtml as Y, getFlagItems as Z, getHoldCaseForProcessInstance as _, acquireCaseAccess as a, submitInvoice as a$, getPatientMessageCountsWithFilter as a0, getRelatedCodes as a1, hideCaseCommentModal as a2, hideExclusionCaseModal as a3, hideHoldCaseModal as a4, hideLoadingSubmission as a5, hideSideNavBar as a6, hideSizeExpWarning as a7, hideSplitCaseModal as a8, hideSubmittedFeedback as a9, selectInvoiceToAdd as aA, selectInvoiceToEdit as aB, setActiveMiniTab as aC, setActiveNote as aD, setActiveVerticalMiniTab as aE, setBenchMode as aF, setCodeBenchPropertyConfig as aG, setFilterDates as aH, setFilterDatesInfinite as aI, setFilterTypes as aJ, setFilterTypesInfinite as aK, setLoadingTechPro as aL, setLockCaseUid as aM, setUnresolvedDocuments as aN, setvitalwareIssues as aO, showAddChargeLoading as aP, showCanceledFeedback as aQ, showCaseCommentModal as aR, showExclusionCaseModal as aS, showHoldCaseModal as aT, showLoadingCancelation as aU, showLoadingSubmission as aV, showSideNavBar as aW, showSizeExpWarning as aX, showSplitCaseModal as aY, showSubmittedFeedback as aZ, showvitalwareIssuesModal as a_, hidevitalwareIssuesModal as aa, holdCase as ab, loadCursorAPIContext as ac, loadNextOrPreviousCase as ad, loadRoles as ae, loadWorkitemInAmplify as af, mergeFlagItems as ag, navigateCoderNotes as ah, navigateDetail as ai, navigatePatient as aj, navigateProvider as ak, navigateProviderDataAccess as al, openAddChargeModal as am, openWindow as an, optimisticCodeChange as ao, optimisticProTechChange as ap, popupClose as aq, popupNavigate as ar, promptClose as as, refreshCaseAccessTimer as at, refreshHoldSubmission as au, releaseCaseAccess as av, removeInvoice as aw, replaceOptimisticTransaction as ax, resetCaseAccess as ay, resetCursorAPIContext as az, addCoderNote as b, createReducer as b$, submittedFeedbackTimer as b0, timeBasedCodeAdd as b1, timeBasedCodeUpdate as b2, toggleChargeableCase as b3, toggleLateCaseClearModal as b4, toggleSubmitOldCaseModal as b5, transactionOrderChange as b6, txnSharedCodeAction as b7, updateCoderNote as b8, updateProcessInstance as b9, isIPC as bA, isSurgery as bB, isPathology as bC, getRelatedCasesInitialFilters as bD, relatedCasesSortablePageable as bE, CreateCase as bF, MergeCases as bG, AttachDocs as bH, firstAvailable as bI, documentUtils as bJ, completeSet as bK, submissionSet as bL, defaultSet as bM, inProgressDefaultSet as bN, CodableStatus$1 as bO, getFieldId as bP, artifactSets as bQ, buildSorter as bR, DEFAULT_BENCH_EDITABLE as bS, DEFAULT_SUGGESTED_CODES as bT, codeBenchState as bU, InvoiceEditor as bV, sequenceGenerator as bW, buildDataAccessRequestObject as bX, uiActions as bY, EMPTY_NOTE as bZ, enableMapSet as b_, updateRelatedCasesFilterSelection as ba, updateTransaction as bb, updateTransactionOptimistically as bc, createAsyncThunk as bd, ImprovementAction as be, createAction as bf, fetchDictionaryRows as bg, commonActions as bh, toServiceLineSlug as bi, emptyPageable as bj, get as bk, unwrapResult as bl, decoratedNoteFactory as bm, amplifyFeedback as bn, normalizeDescriptions as bo, determineServiceLineConfig as bp, set as bq, isJestRuntime as br, UserInterface$1 as bs, AuthenticatedWindow as bt, Launch$1 as bu, CaseEdits as bv, Case as bw, isResourceAllowed as bx, determineProcessInstanceId as by, buildCaseDetailUrl as bz, addTransaction as c, paginationUtils as c$, segmentize as c0, LOAD_STATES as c1, resetCommonState as c2, determineBenchEditable as c3, normalizeSpans as c4, getGroupedCases as c5, parseCodeEdits as c6, doesPathEndWithV2 as c7, compareDecoratedNotesForNav as c8, parseVWByStatus as c9, getTimelineInfiniteLoadCapability as cA, getAttachDocsCapability as cB, getProductivityTrackerCapability as cC, getGetCaserunWithRefreshCapability as cD, getUseProviderDirectoryLocations as cE, getImprovements as cF, getImprovementsAction as cG, getRenderSubmitCase as cH, getRenderviewOnlyCase as cI, getRenderPagination as cJ, getRenderToggleChargeableCase as cK, getCaseEditable as cL, getCreateCaseCapability as cM, getSplitActionMenuCapability as cN, getLateCaseClearNotificationCapability as cO, getActionMenuCapability as cP, getDiagnosisCodeSuggestionCapability as cQ, getCoderNotesCapability as cR, getTransactionV2Capability as cS, getAmplifyCaseRunV2Capability as cT, getActionMenuCancelCapability as cU, getGeneralCancelCapability as cV, getMergeActionMenuCapability as cW, getCoderFeedbackCapability as cX, getCodeSourcesFeaturesCapability as cY, getRelatedCasesFilterCapability as cZ, benchEditable as c_, determineProcessStatus as ca, shimSegmentsIfNeeded as cb, convertToFilterRecord as cc, parseAndFilterV2Errors as cd, parseProcessInstance as ce, normalizeClaims as cf, parseVWIssues as cg, normalizeCCIS as ch, normalizeCustomRules as ci, parseInvoiceIssues as cj, createSyntheticStandardErrors as ck, filterInvoiceIssues as cl, filterMergeHistoryWarnings as cm, readBuildEnv as cn, AmplifyUIActions$1 as co, getConfigurationsForSectionV2 as cp, getNoteUnavailableReason as cq, getServicedeskActions as cr, getToggleCaseComment as cs, getRenderHoldCase as ct, getRenderOffHoldCase as cu, getOldCaseLoadedAlert as cv, getPreviousSentCaseAlert as cw, chooseContext as cx, getActionBarSelectMultipleWorkitemsCapability as cy, saveServiceLineCapability as cz, addUserActivityComment as d, resources as d0, _caseStatusStrings as d1, _utils as d2, _caseUtils as d3, _highlighterUtils as d4, _loadStates as d5, AmplifyProcessStates as d6, _cpt as d7, serviceLines as d8, buildDescriptionRequest as d9, codeBench_actions as da, configurationUtils as db, dictionaryUtilities as dc, identifierUtils as dd, shouldAutoAdvanceWorklistAfterSubmit as de, vitalware as df, cancelInvoicesConfirm as e, cancelInvoicesDismiss as f, cancelInvoicesPopup as g, caseCloseSuccess as h, caseOpenConflict as i, caseOpenSuccess as j, caseOrganization as k, clearLateCaseNotification as l, clearSearchResults as m, closeAddChargeModal as n, codeAdd as o, codeDescriptionsAvailable as p, codeRemove as q, codeSearch as r, codeSearchDrop as s, codeUpdate as t, codeUpdateFlow as u, codesAdd as v, codesRemove as w, createTransactionAndAddCode as x, createTransactionOptimistically as y, deleteCoderNote as z };
//# sourceMappingURL=code-bench.actions-7mBZu9xm.mjs.map
